(function () {
  // Vendor User Admin UI — settle20 (版位退訂對帳紀錄)
  var LOGO_UPLOAD_MAX_BYTES = 2 * 1024 * 1024;
  var ALLOWED_LOGO_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
  var APP_PROXY_BASE = '/apps/ladybae-vendor-test';
  var LOGO_UPLOAD_API_BASE = (config && config.logoUploadApiBase) || 'https://api.ladybaeshop.com';
  var PATHS = {
    list: APP_PROXY_BASE + '/vendor-admin/users',
    vendors: APP_PROXY_BASE + '/vendor-admin/vendors',
    vendorsUpsert: APP_PROXY_BASE + '/vendor-admin/vendors/upsert',
    vendorsSaveAndSync: APP_PROXY_BASE + '/vendor-admin/vendors/save-and-sync',
    vendorsLogoUploadSession: APP_PROXY_BASE + '/vendor-admin/vendors/logo-upload-session',
    vendorsLogoUploadDirect: LOGO_UPLOAD_API_BASE.replace(/\/$/, '') + '/v1/vendor-admin/vendors/logo-upload-direct',
    vendorsDeactivate: APP_PROXY_BASE + '/vendor-admin/vendors/deactivate',
    vendorsReactivate: APP_PROXY_BASE + '/vendor-admin/vendors/reactivate',
    vendorsDuplicates: APP_PROXY_BASE + '/vendor-admin/vendors/duplicates',
    vendorsHardDelete: APP_PROXY_BASE + '/vendor-admin/vendors/hard-delete',
    vendorsModuleState: APP_PROXY_BASE + '/vendor-admin/vendors/module-state',
    vendorsModuleStateGlobal: APP_PROXY_BASE + '/vendor-admin/vendors/module-state/global',
    shopifyScopes: APP_PROXY_BASE + '/vendor-admin/shopify-admin/scopes',
    vendorsSyncShopifyLegacy: APP_PROXY_BASE + '/vendor-admin/vendors/sync-shopify',
    vendorsImportShopify: APP_PROXY_BASE + '/vendor-admin/vendors/import-shopify-metaobject',
    vendorsImportShopifyBulk: APP_PROXY_BASE + '/vendor-admin/vendors/import-shopify-metaobjects-bulk',
    customersSearch: APP_PROXY_BASE + '/vendor-admin/customers/search',
    upsert: APP_PROXY_BASE + '/vendor-admin/users/upsert',
    deactivate: APP_PROXY_BASE + '/vendor-admin/users/deactivate',
    listings: APP_PROXY_BASE + '/vendor-admin/listings',
    listingsApprove: APP_PROXY_BASE + '/vendor-admin/listings/approve',
    listingsReject: APP_PROXY_BASE + '/vendor-admin/listings/reject',
    listingsReopen: APP_PROXY_BASE + '/vendor-admin/listings/reopen',
    listingsFeeUpdate: APP_PROXY_BASE + '/vendor-admin/listings/fee-update',
    unpublishRequests: APP_PROXY_BASE + '/vendor-admin/listings/unpublish-requests',
    unpublishApprove: APP_PROXY_BASE + '/vendor-admin/listings/unpublish-approve',
    unpublishReject: APP_PROXY_BASE + '/vendor-admin/listings/unpublish-reject',
    courseDecisionForce: APP_PROXY_BASE + '/vendor-admin/listings/course-decision/force',
    courseDecisionRetryNotify: APP_PROXY_BASE + '/vendor-admin/listings/course-decision/retry-notify',
    courseDecisionRetryMeta: APP_PROXY_BASE + '/vendor-admin/listings/course-decision/retry-meta',
    courseDecisionRemirrorSheets: APP_PROXY_BASE + '/vendor-admin/listings/course-decision/remirror-sheets',
    courseDecisionRetrySeal: APP_PROXY_BASE + '/vendor-admin/listings/course-decision/retry-seal',
    listingTaxonomySettings: APP_PROXY_BASE + '/vendor-admin/listing-taxonomy-settings',
    slotAddonPurchaseSettings: APP_PROXY_BASE + '/vendor-admin/slot-addon-purchase-settings',
    cityTaxonomy: APP_PROXY_BASE + '/vendor-admin/city-taxonomy',
    cityBackfill: APP_PROXY_BASE + '/vendor-admin/city-backfill',
    cityBackfillApply: APP_PROXY_BASE + '/vendor-admin/city-backfill/apply',
    feePlans: APP_PROXY_BASE + '/vendor-admin/fee-plans',
    feePlanSave: APP_PROXY_BASE + '/vendor-admin/fee-plans/save',
    feePlanDeactivate: APP_PROXY_BASE + '/vendor-admin/fee-plans/deactivate',
    bonusGrantIssue: APP_PROXY_BASE + '/vendor-admin/fee-grants/issue-bonus',
    privateApplications: APP_PROXY_BASE + '/vendor-admin/private-applications',
    privateApplicationApprove: APP_PROXY_BASE + '/vendor-admin/private-applications/approve',
    privateApplicationReject: APP_PROXY_BASE + '/vendor-admin/private-applications/reject',
    slots: APP_PROXY_BASE + '/vendor-admin/slots',
    slotSave: APP_PROXY_BASE + '/vendor-admin/slots/save',
    slotDeactivate: APP_PROXY_BASE + '/vendor-admin/slots/deactivate',
    freeQuotaPolicies: APP_PROXY_BASE + '/vendor-admin/free-quota-policies',
    freeQuotaPolicySave: APP_PROXY_BASE + '/vendor-admin/free-quota-policies/save',
    settlements: APP_PROXY_BASE + '/vendor-admin/settlements',
    settlementsPreview: APP_PROXY_BASE + '/vendor-admin/settlements/preview',
    settlementsCreate: APP_PROXY_BASE + '/vendor-admin/settlements/create',
    feeGrantRefundRecords: APP_PROXY_BASE + '/vendor-admin/fee-grants/refund-records',
    feeGrantRefundApprove: APP_PROXY_BASE + '/vendor-admin/fee-grants/refund-approve',
    feeGrantRefundReject: APP_PROXY_BASE + '/vendor-admin/fee-grants/refund-reject',
    promoStats: APP_PROXY_BASE + '/vendor-admin/promo-stats',
  };

  var ADMIN_BOOTSTRAP_VENDORS = [
    { slug_handle: '__admin__', name: 'LadyBae 管理員', source: 'admin_bootstrap', is_active: true },
    { slug_handle: 'Admin0920', name: 'LadyBae 管理員', source: 'admin_bootstrap', is_active: true },
  ];

  var CITY_OPTIONS = [
    { code: 'city-taipei', label: '臺北市' },
    { code: 'city-new-taipei', label: '新北市' },
    { code: 'city-taoyuan', label: '桃園市' },
    { code: 'city-taichung', label: '臺中市' },
    { code: 'city-tainan', label: '臺南市' },
    { code: 'city-kaohsiung', label: '高雄市' },
    { code: 'city-keelung', label: '基隆市' },
    { code: 'city-hsinchu-city', label: '新竹市' },
    { code: 'city-hsinchu-county', label: '新竹縣' },
    { code: 'city-miaoli', label: '苗栗縣' },
    { code: 'city-changhua', label: '彰化縣' },
    { code: 'city-nantou', label: '南投縣' },
    { code: 'city-yunlin', label: '雲林縣' },
    { code: 'city-chiayi-city', label: '嘉義市' },
    { code: 'city-chiayi-county', label: '嘉義縣' },
    { code: 'city-pingtung', label: '屏東縣' },
    { code: 'city-yilan', label: '宜蘭縣' },
    { code: 'city-hualien', label: '花蓮縣' },
    { code: 'city-taitung', label: '臺東縣' },
    { code: 'city-penghu', label: '澎湖縣' },
    { code: 'city-kinmen', label: '金門縣' },
    { code: 'city-lienchiang', label: '連江縣' },
  ];

  function cityCheckboxGridHtml(selectedCodes, inputName) {
    var selected = {};
    (Array.isArray(selectedCodes) ? selectedCodes : []).forEach(function (c) {
      selected[String(c)] = true;
    });
    var name = inputName || 'lb-admin-city';
    return '<div class="lb-admin-city-grid">' +
      CITY_OPTIONS.map(function (c) {
        return '<label><input type="checkbox" name="' + name + '" value="' +
          escapeHtml(c.code) + '"' + (selected[c.code] ? ' checked' : '') +
          '> ' + escapeHtml(c.label) + '</label>';
      }).join('') +
      '</div>';
  }

  function collectCityCodesFrom(root, inputName) {
    if (!root) return [];
    var name = inputName || 'lb-admin-city';
    return Array.prototype.slice.call(root.querySelectorAll('input[name="' + name + '"]:checked'))
      .map(function (el) { return el.value; })
      .filter(Boolean);
  }

  function cityLabels(codes) {
    return (codes || []).map(function (code) {
      for (var i = 0; i < CITY_OPTIONS.length; i++) {
        if (CITY_OPTIONS[i].code === code) return CITY_OPTIONS[i].label;
      }
      return code;
    });
  }

  var OFFICIAL_SCAN_SLUG = 'LadyBaeStaff';
  var OFFICIAL_OPS_SLUG = 'LadyBaeOps';

  var ROLE_LABELS = { owner: '擁有者', admin: '管理員', staff: '工作人員', scan_only: '僅掃碼' };

  var OFFICIAL_SCAN_BOOTSTRAP_VENDORS = [
    { slug_handle: 'LadyBaeStaff', name: 'LadyBae 內部掃碼', source: 'official_scan_bootstrap', is_active: true },
  ];

  var OFFICIAL_OPS_BOOTSTRAP_VENDORS = [
    { slug_handle: 'LadyBaeOps', name: 'LadyBae 內部營運（全廠商後台）', source: 'official_ops_bootstrap', is_active: true },
  ];

  var config = { loggedIn: false, loginUrl: '/account/login' };
  try {
    var configEl = document.getElementById('lb-admin-config');
    if (configEl) config = JSON.parse(configEl.textContent || '{}');
  } catch (e) {
    config = { loggedIn: false, loginUrl: '/account/login' };
  }

  var state = {
    activeTab: 'registry',
    page: 1,
    limit: 50,
    pagination: null,
    vendors: [],
    registryVendors: [],
    registryMode: '',
    registryEditSlug: '',
    userEditRow: null,
    listItems: [],
    advancedMode: /\badvanced=1\b/.test(window.location.search),
    selectedCustomerId: '',
    selectedCustomerLabel: '',
    customerSearchTimer: null,
    refundRecords: [],
    refundScope: 'open',
    refundSlug: '',
  };

  function $(id) { return document.getElementById(id); }

  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  function escapeHtml(value) {
    // Never coerce empty → "—" (leaks into input value attributes as a literal symbol)
    if (value == null || value === '') return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /** Shopify product id as digits only (GID or numeric). */
  function adminNumericProductId(raw) {
    var s = String(raw || '').trim();
    if (!s) return '';
    var m = s.match(/\/(?:Product|ProductVariant)\/(\d+)/i);
    if (m) return m[1];
    if (/^\d+$/.test(s)) return s;
    return '';
  }

  function hideShopifyNoun(text) {
    return String(text == null ? '' : text).replace(/Shopify/gi, 'SAdmin');
  }

  function adminShopifyProductAdminUrl(productId) {
    var pid = adminNumericProductId(productId);
    if (!pid) return '';
    return 'https://admin.shopify.com/store/2ddda5-79/products/' + encodeURIComponent(pid);
  }

  /** Dual tracking: 課程 #listingId + 商品 {shopify} (link in Admin). */
  function adminTrackIdsHtml(item) {
    if (!item || item.id == null || item.id === '') return '—';
    var lid = String(item.id);
    var pid = adminNumericProductId(item.shopify_product_id);
    var html = '<div class="lb-admin-track-ids">' +
      '<span class="lb-admin-track-id">課程 #' + escapeHtml(lid) + '</span>';
    if (pid) {
      var href = adminShopifyProductAdminUrl(pid);
      html += '<span class="lb-admin-track-id lb-admin-track-id--product">' +
        (href
          ? '<a href="' + escapeHtml(href) + '" target="_blank" rel="noopener">商品 ' + escapeHtml(pid) + '</a>'
          : ('商品 ' + escapeHtml(pid))) +
        '</span>';
    }
    html += '</div>';
    return html;
  }

  function adminProductIdReviewHtml(item) {
    var pid = adminNumericProductId(item && item.shopify_product_id);
    if (!pid) {
      return '<span style="color:#a63d3d;font-weight:800">尚未建立（請退回待審核後重試確認上架）</span>';
    }
    var href = adminShopifyProductAdminUrl(pid);
    var link = href
      ? '<a href="' + escapeHtml(href) + '" target="_blank" rel="noopener"><code style="font-size:0.95em">' + escapeHtml(pid) + '</code></a>'
      : ('<code style="font-size:0.95em">' + escapeHtml(pid) + '</code>');
    return link + '<div class="lb-admin-review-note">SAdmin 商品數字 ID（與廠商後台「商品」欄一致）</div>';
  }

  function safeHttpUrl(u) {
    var s = String(u == null ? '' : u).trim();
    return /^https?:\/\//i.test(s) ? s : '';
  }

  /** 審核預覽用：允許 http(s) 與已存的 data:image base64。 */
  function safeImageSrc(u) {
    var s = String(u == null ? '' : u).trim();
    if (/^https?:\/\//i.test(s)) return s;
    if (/^data:image\/(png|jpeg|jpg|webp|gif);base64,[A-Za-z0-9+/=\s]+$/i.test(s)) return s;
    return '';
  }

  function adminReviewImageHtml(srcs, kindLabel) {
    return '<div class="lb-admin-review-images">' +
      srcs.map(function (src, i) {
        var safeSrc = safeImageSrc(src);
        if (!safeSrc) {
          return '<span class="lb-admin-muted">無法預覽' + escapeHtml(kindLabel) + ' #' + (i + 1) + '</span>';
        }
        var img = '<img src="' + escapeHtml(safeSrc) + '" alt="' + escapeHtml(kindLabel) + ' ' + (i + 1) + '">';
        var httpHref = safeHttpUrl(src);
        if (httpHref) {
          return '<a class="lb-admin-review-images__item" href="' + escapeHtml(httpHref) + '" target="_blank" rel="noopener" title="開啟原圖 #' + (i + 1) + '">' +
            img +
          '</a>';
        }
        return '<span class="lb-admin-review-images__item">' + img + '</span>';
      }).join('') +
    '</div>';
  }

  function setFlash(message, isError) {
    var el = $('lb-admin-flash');
    if (!el) return;
    if (!message) {
      hide(el);
      el.textContent = '';
      el.className = 'lb-admin-flash';
      return;
    }
    show(el);
    el.textContent = hideShopifyNoun(message);
    el.className = 'lb-admin-flash ' + (isError ? 'lb-admin-flash--err' : 'lb-admin-flash--ok');
  }

  function parseCustomerIdFromInput(raw) {
    var input = String(raw || '').trim();
    if (!input) return '';
    if (/^\d+$/.test(input)) return input;
    var match = input.match(/\/customers\/(\d+)/i) || input.match(/Customer\/(\d+)/i);
    return match && match[1] ? match[1] : input;
  }

  function getSelectedRole() {
    return ($('lb-admin-role-input') && $('lb-admin-role-input').value) || 'owner';
  }

  function switchTab(tab) {
    state.activeTab = tab;
    var tabs = {
      registry: { btn: $('lb-admin-tab-registry-btn'), panel: $('lb-admin-panel-registry') },
      permissions: { btn: $('lb-admin-tab-permissions-btn'), panel: $('lb-admin-panel-permissions') },
      listings: { btn: $('lb-admin-tab-listings-btn'), panel: $('lb-admin-panel-listings') },
      'city-backfill': { btn: $('lb-admin-tab-city-backfill-btn'), panel: $('lb-admin-panel-city-backfill') },
      taxonomy: { btn: $('lb-admin-tab-taxonomy-btn'), panel: $('lb-admin-panel-taxonomy') },
      'slots': { btn: $('lb-admin-tab-slots-btn'), panel: $('lb-admin-panel-slots') },
      'fee-plans': { btn: $('lb-admin-tab-fee-plans-btn'), panel: $('lb-admin-panel-fee-plans') },
      'private-apps': { btn: $('lb-admin-tab-private-apps-btn'), panel: $('lb-admin-panel-private-apps') },
      settlements: { btn: $('lb-admin-tab-settlements-btn'), panel: $('lb-admin-panel-settlements') },
      'slot-refunds': { btn: $('lb-admin-tab-slot-refunds-btn'), panel: $('lb-admin-panel-slot-refunds') },
    };
    Object.keys(tabs).forEach(function (key) {
      var t = tabs[key];
      if (!t.btn || !t.panel) return;
      var active = key === tab;
      t.btn.classList.toggle('lb-admin-tab--active', active);
      t.btn.setAttribute('aria-selected', active ? 'true' : 'false');
      if (active) show(t.panel); else hide(t.panel);
    });
    if (tab === 'listings') {
      loadAdminListings();
      loadUnpublishRequests();
    }
    if (tab === 'city-backfill') loadCityBackfill();
    if (tab === 'taxonomy') loadTaxonomySettings();
    if (tab === 'slots') {
      loadSlots();
      loadFreeQuotaPolicies();
    }
    if (tab === 'fee-plans') {
      loadFeePlans();
      loadSlotOptions();
    }
    if (tab === 'private-apps') loadPrivateApplications();
    if (tab === 'settlements') loadSettlements();
    if (tab === 'slot-refunds') loadSlotRefundRecords();
  }

  function vendorScore(item) {
    var score = 0;
    if (item.sync_status === 'synced') score += 100;
    else if (item.sync_status === 'shopify_linked' || item.shopify_metaobject_id) score += 50;
    if (item.shopify_metaobject_id) score += 20;
    if (item.shopify_file_id) score += 10;
    return score;
  }

  function pickPreferredVendorFromGroup(group) {
    if (!group || !group.length) return null;
    return group.slice().sort(function (a, b) {
      return vendorScore(b) - vendorScore(a);
    })[0];
  }

  function groupActiveVendorsByNormalizedSlug(vendors) {
    var groups = {};
    vendors.filter(function (v) { return v.is_active !== false; }).forEach(function (item) {
      var key = String(item.slug_handle || '').trim().toLowerCase();
      if (!key) return;
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    });
    return groups;
  }

  function appendBootstrapVendors(vendors, items) {
    items.forEach(function (item) {
      if (!vendors.some(function (v) { return v.slug_handle === item.slug_handle; })) {
        vendors.unshift(item);
      }
    });
  }

  function vendorOptionsForRole(_role) {
    var vendors = state.vendors.slice();
    appendBootstrapVendors(vendors, OFFICIAL_OPS_BOOTSTRAP_VENDORS);
    appendBootstrapVendors(vendors, OFFICIAL_SCAN_BOOTSTRAP_VENDORS);
    // Admin0920 一律顯示；選到後角色會鎖成「管理員」，避免換角色時重建下拉造成跳選
    appendBootstrapVendors(vendors, ADMIN_BOOTSTRAP_VENDORS);
    var active = vendors.filter(function (v) { return v.is_active !== false; });
    var groups = groupActiveVendorsByNormalizedSlug(active);
    var picked = [];
    Object.keys(groups).forEach(function (key) {
      var preferred = pickPreferredVendorFromGroup(groups[key]);
      if (preferred) {
        preferred = Object.assign({}, preferred);
        if (groups[key].length > 1) {
          preferred.duplicate_slug_warning = '大小寫重複，已優先顯示 synced 主廠商';
        }
        picked.push(preferred);
      }
    });
    if (state.advancedMode) {
      active.forEach(function (item) {
        if (!picked.some(function (p) { return p.slug_handle === item.slug_handle; })) {
          picked.push(Object.assign({}, item, {
            duplicate_slug_warning: item.duplicate_slug_warning || 'duplicate（advanced）',
          }));
        }
      });
    }
    return picked.sort(function (a, b) {
      return formatVendorLabel(a).localeCompare(formatVendorLabel(b), 'zh-TW');
    });
  }

  function sortVendorOptionsWithBootstrapFirst(options) {
    var bootstrapSlugs = OFFICIAL_OPS_BOOTSTRAP_VENDORS
      .concat(OFFICIAL_SCAN_BOOTSTRAP_VENDORS)
      .concat(ADMIN_BOOTSTRAP_VENDORS)
      .map(function (item) { return item.slug_handle; });
    var bootstrap = [];
    var regular = [];
    options.forEach(function (item) {
      if (bootstrapSlugs.indexOf(item.slug_handle) >= 0) bootstrap.push(item);
      else regular.push(item);
    });
    bootstrap.sort(function (a, b) {
      return bootstrapSlugs.indexOf(a.slug_handle) - bootstrapSlugs.indexOf(b.slug_handle);
    });
    regular.sort(function (a, b) {
      return formatVendorLabel(a).localeCompare(formatVendorLabel(b), 'zh-TW');
    });
    return bootstrap.concat(regular);
  }

  function formatVendorLabel(item) {
    var name = item.name && item.name !== item.slug_handle
      ? item.name + '（' + item.slug_handle + '）'
      : item.slug_handle;
    return name;
  }

  function populateVendorSelect(selectEl, role, selectedSlug) {
    if (!selectEl) return;
    var options = sortVendorOptionsWithBootstrapFirst(vendorOptionsForRole(role));
    if (!options.length) {
      selectEl.innerHTML = '<option value="">— 尚無啟用中的廠商 —</option>';
      selectEl.disabled = true;
      show($('lb-admin-slug-empty'));
      return;
    }
    hide($('lb-admin-slug-empty'));
    selectEl.disabled = false;
    selectEl.innerHTML = options.map(function (item) {
      var selected = selectedSlug === item.slug_handle ? ' selected' : '';
      var warn = item.duplicate_slug_warning ? ' ⚠' : '';
      return '<option value="' + escapeHtml(item.slug_handle) + '"' + selected + '>' +
        escapeHtml(formatVendorLabel(item)) + warn + '</option>';
    }).join('');
  }

  function populateFilterVendorSelect() {
    var selectEl = $('lb-admin-filter-slug');
    if (!selectEl) return;
    var current = selectEl.value;
    var options = state.vendors.filter(function (v) { return v.is_active !== false; }).slice();
    appendBootstrapVendors(options, OFFICIAL_OPS_BOOTSTRAP_VENDORS);
    appendBootstrapVendors(options, OFFICIAL_SCAN_BOOTSTRAP_VENDORS);
    appendBootstrapVendors(options, ADMIN_BOOTSTRAP_VENDORS);
    selectEl.innerHTML = '<option value="">全部廠商</option>' + options.map(function (item) {
      var selected = current === item.slug_handle ? ' selected' : '';
      return '<option value="' + escapeHtml(item.slug_handle) + '"' + selected + '>' +
        escapeHtml(formatVendorLabel(item)) + '</option>';
    }).join('');
  }

  function updateFormRoleVendorHint(slug) {
    var hint = $('lb-admin-role-vendor-hint');
    if (!hint) return;
    if (slug === OFFICIAL_SCAN_SLUG) {
      hint.textContent = 'LadyBaeStaff 為內部全廠商掃碼代號，只能選「僅掃碼」或「工作人員」，無法選擁有者。一般廠商請先改選該廠商再設擁有者。';
      show(hint);
      return;
    }
    if (slug === OFFICIAL_OPS_SLUG) {
      hint.textContent = 'LadyBaeOps 為內部全廠商後台代號（可看全部真實廠商）。請選「工作人員」（不可匯出）或「擁有者」（可匯出）。掃碼請改用 LadyBaeStaff。';
      show(hint);
      return;
    }
    if (slug === 'Admin0920' || slug === '__admin__') {
      hint.textContent = '此代號僅供 LadyBae 內部管理員，角色固定為「管理員」。';
      show(hint);
      return;
    }
    hint.textContent = '';
    hide(hint);
  }

  function populateFormRoleSelect(slug, selectedRole) {
    var selectEl = $('lb-admin-role-input');
    if (!selectEl) return;
    var roles = slug ? roleOptionsForVendorSlug(slug) : ['owner', 'staff', 'scan_only', 'admin'];
    var keep = selectedRole || selectEl.value || 'owner';
    var role = roles.indexOf(keep) >= 0 ? keep : roles[0];
    selectEl.innerHTML = roles.map(function (item) {
      var selected = item === role ? ' selected' : '';
      var label = ROLE_LABELS[item] || item;
      return '<option value="' + escapeHtml(item) + '"' + selected + '>' + escapeHtml(label) + '</option>';
    }).join('');
    updateFormRoleVendorHint(slug || '');
  }

  function applyOfficialScanRoleHint() {
    var slug = resolveSlugFromForm();
    populateFormRoleSelect(slug, getSelectedRole());
  }

  function syncSlugInputs(selectedSlug) {
    var keepSlug = selectedSlug != null ? selectedSlug : resolveSlugFromForm();
    populateVendorSelect($('lb-admin-slug-select'), null, keepSlug);
    populateFilterVendorSelect();

    var manual = $('lb-admin-slug-manual');
    var select = $('lb-admin-slug-select');
    if (state.advancedMode) {
      show(manual);
      if (manual && keepSlug) manual.value = keepSlug;
      if (select) select.removeAttribute('required');
      if (manual) manual.setAttribute('required', 'required');
    } else {
      hide(manual);
      if (select) select.setAttribute('required', 'required');
      if (manual) manual.removeAttribute('required');
    }
    populateFormRoleSelect(resolveSlugFromForm(), getSelectedRole());
  }

  function applyAdvancedModeUI() {
    document.querySelectorAll('.lb-admin-advanced-only').forEach(function (el) {
      if (state.advancedMode) {
        show(el);
      } else {
        hide(el);
      }
    });
    var manualField = $('lb-admin-customer-manual-field');
    var customerInput = $('lb-admin-customer-input');
    if (customerInput) {
      if (state.advancedMode) {
        customerInput.setAttribute('required', 'required');
      } else {
        customerInput.removeAttribute('required');
      }
    }
    if (!state.advancedMode && manualField) {
      hide(manualField);
    }
  }

  function readFileAsBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        var result = String(reader.result || '');
        var base64 = result;
        var match = /^data:[^;]+;base64,(.+)$/i.exec(result);
        if (match) base64 = match[1];
        resolve(base64);
      };
      reader.onerror = function () {
        reject(new Error('商標檔案讀取失敗'));
      };
      reader.readAsDataURL(file);
    });
  }

  function validateLogoFile(file) {
    if (!file) return null;
    if (ALLOWED_LOGO_TYPES.indexOf(file.type) < 0) {
      return {
        code: 'INVALID_LOGO_CONTENT_TYPE',
        message: '商標僅支援 png / jpeg / webp',
      };
    }
    if (file.size > LOGO_UPLOAD_MAX_BYTES) {
      return {
        code: 'FILE_TOO_LARGE',
        message: '商標檔案不可超過 2MB',
      };
    }
    return null;
  }

  function normalizeLogoUrlForPayload(value) {
    var trimmed = (value || '').trim();
    if (!trimmed) return '';
    var lowered = trimmed.toLowerCase();
    if (lowered === 'https://...' || lowered === 'http://...') return '';
    if (/^https?:\/\/\.{2,}$/i.test(trimmed)) return '';
    return trimmed;
  }

  async function parseJsonApiResponse(response, options) {
    options = options || {};
    var contentType = response.headers.get('content-type') || '';
    var text = await response.text();
    var looksLikeHtml = /^\s*</.test(text) || /<!doctype html/i.test(text);
    if (contentType.indexOf('application/json') < 0 || looksLikeHtml) {
      return {
        response: response,
        payload: {
          ok: false,
          error: {
            code: options.htmlErrorCode || 'APP_PROXY_RETURNED_HTML',
            message: options.htmlErrorMessage ||
              'App Proxy 回傳了網頁 HTML 而非 JSON（常見原因：同步逾時或路徑未正確轉發）。請重試；若只改結算欄位，請改按「僅儲存 DB」。',
          },
          raw: text.slice(0, 300),
        },
      };
    }
    var parsed = null;
    try { parsed = JSON.parse(text); } catch (e) { parsed = null; }
    if (!parsed) {
      return {
        response: response,
        payload: {
          ok: false,
          error: {
            code: 'INVALID_JSON_RESPONSE',
            message: '系統回傳格式異常',
          },
        },
      };
    }
    return { response: response, payload: parsed };
  }

  async function buildSaveAndSyncPayload(fields) {
    var payload = {
      slug_handle: fields.slug_handle,
      name: fields.name,
      contact_email: fields.contact_email || '',
      contact_phone: fields.contact_phone || '',
      is_active: fields.is_active,
    };
    if (fields.registry_id) {
      payload.registry_id = fields.registry_id;
    }
    if (fields.clear_logo) {
      payload.clear_logo = true;
    }
    var logoUrl = normalizeLogoUrlForPayload(fields.logo_url);
    if (logoUrl) {
      payload.logo_url = logoUrl;
    }
    if (fields.fee_rate !== undefined && fields.fee_rate !== '') {
      payload.fee_rate = fields.fee_rate;
    }
    if (fields.event_id_prefix) payload.event_id_prefix = fields.event_id_prefix;
    if (fields.company_name) payload.company_name = fields.company_name;
    if (fields.tax_id) payload.tax_id = fields.tax_id;
    if (fields.bank_name) payload.bank_name = fields.bank_name;
    if (fields.bank_account) payload.bank_account = fields.bank_account;
    if (fields.private_listing_requires_review !== undefined) {
      payload.private_listing_requires_review = !!fields.private_listing_requires_review;
    }
    return payload;
  }

  async function saveAndSyncRegistry(payload) {
    var response = await fetch(PATHS.vendorsSaveAndSync, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    return parseJsonApiResponse(response);
  }

  async function createLogoUploadSession(fields, file) {
    var response = await fetch(PATHS.vendorsLogoUploadSession, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        registry_id: fields.registry_id || fields.slug_handle,
        slug_handle: fields.slug_handle,
        filename: file.name,
        content_type: file.type,
        size: file.size,
      }),
    });
    return parseJsonApiResponse(response);
  }

  async function uploadLogoDirect(sessionPayload, fields, file) {
    var uploadUrl = (sessionPayload && sessionPayload.upload_url) || PATHS.vendorsLogoUploadDirect;
    var token = sessionPayload && sessionPayload.upload_token;
    var form = new FormData();
    form.append('logo', file);
    form.append('registry_id', fields.registry_id || fields.slug_handle);
    form.append('slug_handle', fields.slug_handle);
    var response = await fetch(uploadUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: form,
    });
    return parseJsonApiResponse(response, {
      htmlErrorCode: 'APP_PROXY_RETURNED_HTML',
      htmlErrorMessage: '商標上傳回傳格式異常',
    });
  }

  async function submitRegistryWithOptionalLogo(fields, fileInput, options) {
    options = options || {};
    var file = fileInput && fileInput.files && fileInput.files[0];
    if (file) {
      var fileErr = validateLogoFile(file);
      if (fileErr) {
        throw fileErr;
      }
    }

    var payload = await buildSaveAndSyncPayload(fields);
    if (file) {
      delete payload.logo_url;
    }

    var saveResult = await saveAndSyncRegistry(payload);
    var outcome = await handleSaveAndSyncOutcome(saveResult, fields.slug_handle, {
      openDrawerOnError: options.openDrawerOnError,
      showDrawerError: options.showDrawerError,
      clearDrawerError: options.clearDrawerError,
      onItem: options.onItem,
      skipDrawerOnSuccess: !!file,
    });

    if (!file) {
      return outcome;
    }
    if (!outcome.success && !outcome.partial) {
      return outcome;
    }

    if (options.submitBtn) {
      setButtonLoading(options.submitBtn, true, '上傳商標…');
    }

    var sessionResult = await createLogoUploadSession(fields, file);
    if (!sessionResult.payload || sessionResult.payload.ok !== true) {
      if (options.submitBtn) setButtonLoading(options.submitBtn, false);
      var sessErr = extractApiError(sessionResult);
      var baseItem = outcome.item;
      if (options.showDrawerError) {
        showDrawerActionError(sessErr.code, sessErr.message);
      }
      setFlash('基本資料已儲存，但商標上傳失敗：[' + (sessErr.code || 'ERROR') + '] ' + (sessErr.message || ''), true);
      if (baseItem) {
        await refreshRegistryList();
        openEditDrawer(baseItem, { showSyncHint: true });
      }
      return { handled: true, success: false, partial: true, logoFailed: true, item: baseItem };
    }

    var uploadResult = await uploadLogoDirect(sessionResult.payload, fields, file);
    if (options.submitBtn) {
      setButtonLoading(options.submitBtn, false);
    }

    if (!uploadResult.payload || uploadResult.payload.ok !== true) {
      var upErr = extractApiError(uploadResult);
      if (options.showDrawerError) {
        showDrawerActionError(upErr.code, upErr.message);
      }
      setFlash('基本資料已儲存，但商標上傳失敗：[' + (upErr.code || 'ERROR') + '] ' + (upErr.message || ''), true);
      var partialItem = upErr.item || outcome.item;
      if (partialItem) {
        applyRegistryItemFromSave(partialItem);
        await refreshRegistryList();
        await loadVendors(false);
        openEditDrawer(partialItem, { showSyncHint: true });
      }
      return { handled: true, success: false, partial: true, logoFailed: true, item: partialItem };
    }

    var vendor = uploadResult.payload.vendor || uploadResult.payload.item;
    if (options.clearDrawerError) clearDrawerActionError();
    if (vendor) {
      applyRegistryItemFromSave(vendor);
    }
    setFlash('已儲存並同步至 LadyBae（含商標）：' + fields.slug_handle, false);
    await refreshRegistryList();
    await loadVendors(false);
    if (vendor) {
      openEditDrawer(vendor, { showSyncHint: true });
    }
    return { handled: true, success: true, partial: false, item: vendor };
  }

  function formatSaveAndSyncFlash(slug, item) {
    if (!item) return '已儲存 ' + slug;
    var status = item.sync_status || '';
    if (status === 'synced' || status === 'shopify_metaobject_linked') {
      return '已儲存並同步至 LadyBae：' + slug + '（已同步）';
    }
    if (status === 'sync_failed') {
      return '已儲存 ' + slug + '，但 LadyBae 同步失敗（同步失敗）';
    }
    return '已儲存 ' + slug;
  }

  function applyRegistryItemFromSave(item) {
    if (!item) return;
    applyRegistryItemToState(item);
    updateSyncPanel(item);
    var display = resolveLogoDisplayForItem(item);
    if ($('lb-registry-edit-logo') && display.url) {
      $('lb-registry-edit-logo').value = display.url;
    }
    applyLogoPreviewForItem($('lb-registry-edit-logo-preview'), item);
  }

  function renderDuplicateSlugWarning(row) {
    if (!row.duplicate_slug_warning) return '';
    return '<div class="lb-admin-slug-warning" title="' + escapeHtml(row.duplicate_slug_warning) + '">⚠ 大小寫重複，請選一筆主廠商，另一筆停用</div>';
  }

  function clearCustomerSelection() {
    state.selectedCustomerId = '';
    state.selectedCustomerLabel = '';
    var selectedEl = $('lb-admin-customer-selected');
    if (selectedEl) {
      hide(selectedEl);
      selectedEl.textContent = '';
    }
    var searchEl = $('lb-admin-customer-search');
    if (searchEl) searchEl.value = '';
    hideCustomerSearchResults();
    renderMemberPermissionsPanel([]);
    var listTitle = $('lb-admin-list-title');
    if (listTitle) listTitle.textContent = '全部權限列表';
  }

  function bindMemberPermissionActions(root, items) {
    if (!root) return;
    root.querySelectorAll('[data-member-edit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.getAttribute('data-member-edit') || '-1', 10);
        var row = items[index];
        if (row) openUserEditDrawer(row);
      });
    });
    root.querySelectorAll('[data-member-deactivate]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.getAttribute('data-member-deactivate') || '-1', 10);
        var row = items[index];
        if (row) deactivateUserRecord(row.shopify_customer_id, row.slug_handle, row.shopify_customer_id_last4);
      });
    });
    root.querySelectorAll('[data-member-activate]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.getAttribute('data-member-activate') || '-1', 10);
        var row = items[index];
        if (row) reactivateUserRecord(row);
      });
    });
  }

  function renderMemberPermissionsPanel(items) {
    var host = $('lb-admin-member-perms');
    var list = $('lb-admin-member-perms-list');
    var empty = $('lb-admin-member-perms-empty');
    if (!host || !list) return;

    if (!state.selectedCustomerId) {
      hide(host);
      list.innerHTML = '';
      if (empty) hide(empty);
      return;
    }

    show(host);
    var rows = (items || []).filter(function (row) {
      return String(row.shopify_customer_id || '') === String(state.selectedCustomerId);
    });

    if (!rows.length) {
      list.innerHTML = '';
      if (empty) show(empty);
      return;
    }
    if (empty) hide(empty);

    list.innerHTML = rows.map(function (row, index) {
      var activeBadge = row.is_active
        ? '<span class="lb-admin-badge lb-admin-badge--on">生效中</span>'
        : '<span class="lb-admin-badge lb-admin-badge--off">已停用</span>';
      var roleLabel = ROLE_LABELS[row.role] || row.role;
      return '<article class="lb-admin-member-perm-card">' +
        '<div class="lb-admin-member-perm-card__main">' +
          '<div class="lb-admin-member-perm-card__vendor">' +
            '<code>' + escapeHtml(row.slug_handle) + '</code>' +
            '<span class="lb-admin-muted">廠商鎖定，不可改</span>' +
          '</div>' +
          '<div class="lb-admin-member-perm-card__meta">' +
            '<strong>' + escapeHtml(roleLabel) + '</strong>' +
            activeBadge +
          '</div>' +
          (row.note ? '<p class="lb-admin-muted" style="margin:0.25rem 0 0">' + escapeHtml(row.note) + '</p>' : '') +
        '</div>' +
        '<div class="lb-admin-member-perm-card__actions">' +
          '<button type="button" class="lb-admin-btn lb-admin-btn--ghost" data-member-edit="' + index + '">修改角色</button>' +
          (row.is_active
            ? '<button type="button" class="lb-admin-btn lb-admin-btn--danger" data-member-deactivate="' + index + '" title="只撤銷此會員對該廠商的後台權限，不影響課程／活動">停用權限</button>'
            : '<button type="button" class="lb-admin-btn lb-admin-btn--accent" data-member-activate="' + index + '" title="重新啟用此會員對該廠商的後台權限">啟用權限</button>') +
        '</div>' +
      '</article>';
    }).join('');
    bindMemberPermissionActions(list, rows);
  }

  async function refreshSelectedMemberPermissions() {
    var listTitle = $('lb-admin-list-title');
    if (!state.selectedCustomerId) {
      renderMemberPermissionsPanel([]);
      if (listTitle) listTitle.textContent = '全部權限列表';
      return;
    }
    if (listTitle) {
      listTitle.textContent = '此會員相關權限（' + (state.selectedCustomerLabel || state.selectedCustomerId) + '）';
    }
    if ($('lb-admin-filter-q')) {
      $('lb-admin-filter-q').value = state.selectedCustomerId;
    }
    state.page = 1;
    var params = new URLSearchParams();
    params.set('q', state.selectedCustomerId);
    params.set('page', '1');
    params.set('limit', '50');
    var result = await fetchJson(PATHS.list + '?' + params.toString(), { method: 'GET' });
    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      renderMemberPermissionsPanel([]);
      await refreshList();
      return;
    }
    renderMemberPermissionsPanel(result.payload.items || []);
    state.pagination = result.payload.pagination || null;
    renderTable(result.payload.items || []);
    updatePagination();
  }

  function hideCustomerSearchResults() {
    var panel = $('lb-admin-customer-search-results');
    if (panel) {
      hide(panel);
      panel.innerHTML = '';
    }
  }

  function renderCustomerSearchResults(items) {
    var panel = $('lb-admin-customer-search-results');
    if (!panel) return;
    if (!items || !items.length) {
      panel.innerHTML = '<p class="lb-admin-muted">無符合的顧客</p>';
      show(panel);
      return;
    }
    panel.innerHTML = items.map(function (item) {
      var label = escapeHtml(item.display_name) + ' · 編號 ' +
        escapeHtml(item.customer_id_masked || item.customer_id) + ' · ' +
        escapeHtml(item.email_masked || '—') + ' · ' +
        escapeHtml(item.phone_masked || '—');
      return '<button type="button" class="lb-admin-customer-result" role="option" data-id="' +
        escapeHtml(item.customer_id) + '" data-label="' + escapeHtml(item.display_name) + '" data-email="' +
        escapeHtml(item.email_masked || '') + '" data-phone="' + escapeHtml(item.phone_masked || '') + '">' +
        label + '</button>';
    }).join('');
    panel.querySelectorAll('.lb-admin-customer-result').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.selectedCustomerId = btn.getAttribute('data-id') || '';
        state.selectedCustomerLabel = btn.getAttribute('data-label') || '';
        var selectedEl = $('lb-admin-customer-selected');
        if (selectedEl) {
          selectedEl.textContent = '已選擇：' + state.selectedCustomerLabel +
            '（ID ' + state.selectedCustomerId + ' · ' +
            (btn.getAttribute('data-email') || '—') + ' · ' +
            (btn.getAttribute('data-phone') || '—') + '）';
          show(selectedEl);
        }
        if ($('lb-admin-customer-input')) {
          $('lb-admin-customer-input').value = state.selectedCustomerId;
        }
        hideCustomerSearchResults();
        if ($('lb-admin-customer-search')) {
          $('lb-admin-customer-search').value = state.selectedCustomerLabel;
        }
        refreshSelectedMemberPermissions();
      });
    });
    show(panel);
  }

  async function searchShopifyCustomers(query) {
    if (query.length < 2) {
      hideCustomerSearchResults();
      return;
    }
    var result = await fetchJson(PATHS.customersSearch + '?q=' + encodeURIComponent(query), {
      method: 'GET',
    });
    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var err = formatCustomerSearchError(extractApiError(result));
      var panel = $('lb-admin-customer-search-results');
      if (panel) {
        panel.innerHTML = '<p class="lb-admin-search-error"><strong>[' + escapeHtml(hideShopifyNoun(err.code)) + ']</strong> ' +
          escapeHtml(hideShopifyNoun(err.message)) + '</p>';
        show(panel);
      }
      setFlash('顧客搜尋失敗：[' + err.code + '] ' + err.message, true);
      return;
    }
    var items = result.payload.items || [];
    if (!items.length) {
      var emptyPanel = $('lb-admin-customer-search-results');
      if (emptyPanel) {
        emptyPanel.innerHTML = '<p class="lb-admin-muted">查無顧客</p>';
        show(emptyPanel);
      }
      return;
    }
    renderCustomerSearchResults(items);
  }

  async function runCustomerSearch() {
    var query = ($('lb-admin-customer-search') && $('lb-admin-customer-search').value || '').trim();
    if (query.length < 2) {
      setFlash('搜尋關鍵字至少 2 字', true);
      hideCustomerSearchResults();
      return;
    }
    var searchBtn = $('lb-admin-customer-search-btn');
    setButtonLoading(searchBtn, true, '搜尋中…');
    await searchShopifyCustomers(query);
    setButtonLoading(searchBtn, false);
  }

  function resolveCustomerIdFromForm() {
    if (state.advancedMode) {
      return parseCustomerIdFromInput($('lb-admin-customer-input') && $('lb-admin-customer-input').value);
    }
    return state.selectedCustomerId || '';
  }

  function resolveSlugFromForm() {
    if (state.advancedMode) {
      return ($('lb-admin-slug-manual') && $('lb-admin-slug-manual').value || '').trim();
    }
    return ($('lb-admin-slug-select') && $('lb-admin-slug-select').value || '').trim();
  }

  async function fetchJson(url, options) {
    var response = await fetch(url, Object.assign({
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }, options || {}));
    var payload = null;
    try { payload = await response.json(); } catch (e) { payload = null; }
    return { response: response, payload: payload };
  }

  function isSuccessfulJson(result) {
    return Boolean(
      result &&
      result.response &&
      result.response.ok &&
      result.payload &&
      result.payload.ok === true
    );
  }

  async function loadVendors(includeInactive) {
    var params = includeInactive ? '?include_inactive=true' : '';
    var result = await fetchJson(PATHS.vendors + params, { method: 'GET' });
    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      return result;
    }
    var items = Array.isArray(result.payload.items) ? result.payload.items : [];
    state.registryVendors = items;
    state.vendors = items;
    state.registryMode = result.payload.registry_mode || '';
    syncSlugInputs();
    populateBonusGrantSelects();
    return result;
  }

  function formatPartialSyncMessage(payload) {
    var err = (payload && payload.error) || {};
    var stage = (payload && payload.stage) || err.stage || 'unknown';
    var code = err.code || 'PARTIAL_SYNC_FAILED';
    var message = err.message || 'LadyBae 同步失敗';
    return 'DB 已儲存，但 LadyBae 同步失敗：' + stage + ' / ' + code + ' / ' + message;
  }

  function extractApiError(result) {
    var payload = result && result.payload;
    var out;
    if (payload) {
      if (payload.partial_ok) {
        out = {
          code: (payload.error && payload.error.code) || 'PARTIAL_SYNC_FAILED',
          message: formatPartialSyncMessage(payload),
          item: payload.vendor || payload.item || null,
          partial_ok: true,
          stage: payload.stage || (payload.error && payload.error.stage) || '',
        };
      } else if (payload.error) {
        out = {
          code: payload.error.code || ('HTTP_' + (result.response && result.response.status)),
          message: payload.error.message || '請求失敗',
          item: payload.vendor || payload.item || null,
          stage: payload.stage || payload.error.stage || '',
        };
      }
    }
    if (!out && payload && payload.code && payload.message) {
      out = { code: String(payload.code), message: String(payload.message) };
    }
    if (!out && payload && payload.message && result.response && result.response.status >= 400) {
      out = {
        code: 'HTTP_' + result.response.status,
        message: String(payload.message),
        item: null,
      };
    }
    if (!out) {
      out = {
        code: 'HTTP_' + (result.response && result.response.status),
        message: '請求失敗',
        item: null,
      };
    }
    out.code = hideShopifyNoun(out.code);
    out.message = hideShopifyNoun(out.message);
    return out;
  }

  function formatCustomerSearchError(err) {
    if (!err) return { code: 'ERROR', message: '搜尋失敗' };
    if (err.code === 'SHOPIFY_ADMIN_SCOPE_INSUFFICIENT_READ_CUSTOMERS') {
      return {
        code: err.code,
        message: 'LadyBae App 缺少 read_customers 權限，請重新授權 App。',
      };
    }
    return {
      code: err.code || 'ERROR',
      message: err.message || '搜尋失敗',
    };
  }

  function showDrawerActionError(code, message) {
    var el = $('lb-registry-drawer-action-error');
    if (!el) return;
    el.textContent = hideShopifyNoun((code ? '[' + code + '] ' : '') + (message || ''));
    show(el);
    try {
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } catch (e) { /* ignore */ }
  }

  function clearDrawerActionError() {
    var el = $('lb-registry-drawer-action-error');
    if (el) {
      hide(el);
      el.textContent = '';
    }
  }

  function validateSettlementFields(fields) {
    var feeRaw = String(fields.fee_rate || '').trim();
    if (feeRaw) {
      var fee = Number(feeRaw);
      if (isNaN(fee) || fee < 0 || fee > 1) {
        return {
          code: 'INVALID_FEE_RATE',
          message: '手續費率請只填 0~1 的數字（例如 0.10 = 10%），不要填文字',
        };
      }
    }
    var taxId = String(fields.tax_id || '').trim();
    if (taxId && !/^\d+$/.test(taxId)) {
      return {
        code: 'INVALID_TAX_ID',
        message: '統一編號請只填數字（例如 12345678）',
      };
    }
    var prefix = String(fields.event_id_prefix || '').trim();
    if (prefix && !/^[A-Za-z0-9_-]+$/.test(prefix)) {
      return {
        code: 'INVALID_EVENT_ID_PREFIX',
        message: 'event_id 前綴僅允許 A-Z / a-z / 0-9 / _ / -',
      };
    }
    return null;
  }

  function setButtonLoading(btn, loading, loadingText) {
    if (!btn) return;
    if (loading) {
      if (!btn.dataset.prevText) btn.dataset.prevText = btn.textContent;
      btn.disabled = true;
      btn.textContent = loadingText || '處理中…';
      btn.classList.add('lb-admin-btn--loading');
    } else {
      btn.disabled = false;
      btn.textContent = btn.dataset.prevText || btn.textContent;
      btn.classList.remove('lb-admin-btn--loading');
    }
  }

  function applyRegistryItemToState(item) {
    if (!item || !item.slug_handle) return;
    var idx = state.registryVendors.findIndex(function (v) { return v.slug_handle === item.slug_handle; });
    if (idx >= 0) {
      state.registryVendors[idx] = item;
    }
  }

  function formatSyncStatus(item) {
    var status = item.sync_status || 'db_only';
    if (status === 'synced' || status === 'shopify_metaobject_linked') {
      return '已同步';
    }
    if (status === 'shopify_linked') {
      return 'LadyBae 已連結';
    }
    if (status === 'logo_uploaded') {
      return '商標已上傳';
    }
    if (status === 'sync_failed') {
      return '同步失敗';
    }
    if (status === 'import_failed') {
      return '匯入失敗';
    }
    return '僅資料庫';
  }

  function syncStatusBadgeClass(status) {
    if (status === 'synced' || status === 'shopify_metaobject_linked') {
      return 'lb-admin-badge lb-admin-badge--synced';
    }
    if (status === 'shopify_linked') {
      return 'lb-admin-badge lb-admin-badge--linked';
    }
    if (status === 'logo_uploaded') {
      return 'lb-admin-badge lb-admin-badge--uploaded';
    }
    if (status === 'sync_failed' || status === 'import_failed') {
      return 'lb-admin-badge lb-admin-badge--failed';
    }
    return 'lb-admin-badge';
  }

  function maskMetaobjectId(value) {
    var id = String(value || '').trim();
    if (!id) return '—';
    if (id.length <= 16) return id;
    return id.slice(0, 8) + '…' + id.slice(-6);
  }

  function updateSyncPanel(item) {
    var statusEl = $('lb-registry-edit-sync-status');
    var metaEl = $('lb-registry-edit-metaobject-id');
    var syncedEl = $('lb-registry-edit-last-synced');
    var errorEl = $('lb-registry-edit-sync-error');
    if (!statusEl) return;

    var status = (item && item.sync_status) || 'db_only';
    statusEl.textContent = formatSyncStatus(item || {});
    statusEl.className = syncStatusBadgeClass(status);

    if (metaEl) {
      metaEl.textContent = maskMetaobjectId(item && item.shopify_metaobject_id);
    }
    if (syncedEl) {
      syncedEl.textContent = item && item.last_synced_at
        ? new Date(item.last_synced_at).toLocaleString('zh-TW')
        : '—';
    }
    if (errorEl) {
      if (item && item.sync_error) {
        errorEl.textContent = hideShopifyNoun(item.sync_error);
        show(errorEl);
      } else {
        errorEl.textContent = '';
        hide(errorEl);
      }
    }
  }

  function isSyncedVendorItem(item) {
    var status = item && item.sync_status;
    return status === 'synced' || status === 'shopify_metaobject_linked';
  }

  function hasLinkedShopifyLogo(item) {
    return !!(item && item.shopify_file_id && String(item.shopify_file_id).trim());
  }

  function resolveLogoDisplayForItem(item) {
    if (!item) {
      return { url: '', label: '', placeholder: '無商標' };
    }
    var url = String(item.logo_url || '').trim();
    if (isValidLogoUrl(url)) {
      return {
        url: url,
        label: isSyncedVendorItem(item) ? '商標' : '',
        placeholder: '',
      };
    }
    if (hasLinkedShopifyLogo(item) && isSyncedVendorItem(item)) {
      return {
        url: '',
        label: '商標',
        placeholder: '商標已連結，圖片網址處理中',
      };
    }
    return { url: '', label: '', placeholder: '無商標' };
  }

  function applyLogoPreviewForItem(containerEl, item, options) {
    options = options || {};
    var display = resolveLogoDisplayForItem(item);
    if (isValidLogoUrl(display.url)) {
      updateLogoPreview(containerEl, display.url, {
        label: options.label || display.label,
      });
      return;
    }
    if (!containerEl) return;
    containerEl.innerHTML = '';
    containerEl.classList.add('lb-admin-logo-preview--empty');
    if (display.label) {
      var badge = document.createElement('span');
      badge.className = 'lb-admin-logo-preview__badge';
      badge.textContent = display.label;
      containerEl.appendChild(badge);
    }
    var placeholder = document.createElement('span');
    placeholder.className = 'lb-admin-logo-preview__placeholder';
    placeholder.textContent = display.placeholder || '無商標';
    containerEl.appendChild(placeholder);
  }

  function isValidLogoUrl(url) {
    var value = String(url || '').trim();
    if (!value) return false;
    return /^https?:\/\//i.test(value) || /^blob:/i.test(value);
  }

  function renderLogoThumbHtml(urlOrItem) {
    var item = (urlOrItem && typeof urlOrItem === 'object') ? urlOrItem : null;
    var url = item ? resolveLogoDisplayForItem(item).url : String(urlOrItem || '').trim();
    if (isValidLogoUrl(url)) {
      return '<img class="lb-admin-logo-thumb" src="' + escapeHtml(url) + '" alt="" loading="lazy" onerror="this.replaceWith(Object.assign(document.createElement(\'span\'),{className:\'lb-admin-logo-thumb lb-admin-logo-thumb--placeholder\',textContent:\'無\'}))">';
    }
    if (item && hasLinkedShopifyLogo(item) && isSyncedVendorItem(item)) {
      return '<span class="lb-admin-logo-thumb lb-admin-logo-thumb--linked" title="商標已連結，圖片網址處理中">🔗</span>';
    }
    return '<span class="lb-admin-logo-thumb lb-admin-logo-thumb--placeholder">無</span>';
  }

  function updateLogoPreview(containerEl, url, options) {
    options = options || {};
    if (!containerEl) return;
    containerEl.innerHTML = '';
    containerEl.classList.remove('lb-admin-logo-preview--empty');
    var label = options.label || '';
    if (label) {
      var badge = document.createElement('span');
      badge.className = 'lb-admin-logo-preview__badge';
      badge.textContent = label;
      containerEl.appendChild(badge);
    }
    if (isValidLogoUrl(url)) {
      var img = document.createElement('img');
      img.src = url.trim();
      img.alt = '';
      img.onerror = function () {
        containerEl.innerHTML = '<span class="lb-admin-logo-preview__placeholder">無法載入</span>';
        containerEl.classList.add('lb-admin-logo-preview--empty');
      };
      containerEl.appendChild(img);
    } else {
      containerEl.innerHTML = '<span class="lb-admin-logo-preview__placeholder">無商標</span>';
      containerEl.classList.add('lb-admin-logo-preview--empty');
    }
  }

  function mountDrawerToBody(drawer) {
    if (!drawer) return;
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  function setDrawerOpenState(open) {
    if (open) {
      document.documentElement.classList.add('lb-admin-drawer-open');
      document.body.style.overflow = 'hidden';
    } else {
      document.documentElement.classList.remove('lb-admin-drawer-open');
      document.body.style.overflow = '';
    }
  }

  function ensureRegistryDrawerActionBar() {
    // Bindings are set once in initListeners; nothing dynamic needed now.
  }

  var MODULE_LABELS = {
    EXPOSURE: '純上架',
    PROMO: '宣傳刊登（不含金流）',
    FULL: '宣傳刊登（含金流）',
    PRIVATE: '資格限定課',
  };

  function formatModuleDate(value) {
    if (!value) return '';
    var d = new Date(value);
    return isNaN(d.getTime()) ? '' : d.toLocaleDateString('zh-TW');
  }

  function renderModuleStates(items) {
    var host = $('lb-registry-module-list');
    if (!host) return;
    if (!items || !items.length) {
      host.innerHTML = '<p class="lb-admin-muted">無法載入模組狀態</p>';
      return;
    }
    host.innerHTML = items.map(function (row) {
      var mode = String(row.listing_mode || '');
      var enabled = row.enabled !== false;
      var stopped = !!row.force_stopped_at;
      var cls = 'lb-admin-module-row' +
        (stopped ? ' lb-admin-module-row--stopped' : (enabled ? '' : ' lb-admin-module-row--off'));
      // Plain text — a pill "開啟" looked clickable and hid the real actions
      // when the drawer (portaled to <body>) lost #lb-admin-root button CSS.
      var status = stopped
        ? '目前：強制停售'
        : (enabled ? '目前：開啟中' : '目前：已停用');

      var meta = [];
      if (row.closed_at) meta.push('停用於 ' + formatModuleDate(row.closed_at) + '（既有額度可用到期，未綁定的單堂額度 90 天內須送審）');
      if (stopped) meta.push('強制停售於 ' + formatModuleDate(row.force_stopped_at) + (row.stop_reason ? '：' + row.stop_reason : ''));

      // Use <a> not <button>: theme chrome often zeroes-out nested buttons once
      // the drawer is mounted outside #lb-admin-root.
      var actions = (enabled
        ? '<a href="#" role="button" class="lb-admin-btn lb-admin-btn--outline lb-module-act" data-mode="' + escapeHtml(mode) + '" data-action="disable">停用（溫和退場）</a>'
        : '<a href="#" role="button" class="lb-admin-btn lb-admin-btn--accent lb-module-act" data-mode="' + escapeHtml(mode) + '" data-action="enable">重新開啟</a>') +
        (stopped
          ? '<a href="#" role="button" class="lb-admin-btn lb-admin-btn--ghost lb-module-act" data-mode="' + escapeHtml(mode) + '" data-action="release_force_stop">解除強制停售</a>'
          : '<a href="#" role="button" class="lb-admin-btn lb-admin-btn--danger lb-module-act" data-mode="' + escapeHtml(mode) + '" data-action="force_stop">強制停售</a>');

      return '<div class="' + cls + '">' +
        '<div class="lb-admin-module-row__head">' +
          '<span class="lb-admin-module-row__name">' + escapeHtml(MODULE_LABELS[mode] || mode) + '</span>' +
          '<span class="lb-admin-module-row__status">' + escapeHtml(status) + '</span>' +
        '</div>' +
        '<div class="lb-admin-module-row__actions">' + actions + '</div>' +
        (meta.length ? '<span class="lb-admin-module-row__meta">' + escapeHtml(meta.join('　')) + '</span>' : '') +
        '</div>';
    }).join('');

    if (!host._lbModuleActBound) {
      host._lbModuleActBound = true;
      host.addEventListener('click', function (ev) {
        var btn = ev.target && ev.target.closest ? ev.target.closest('.lb-module-act') : null;
        if (!btn || !host.contains(btn)) return;
        ev.preventDefault();
        applyModuleStateAction(btn.getAttribute('data-mode'), btn.getAttribute('data-action'));
      });
    }
  }

  async function loadModuleStates(slug) {
    var host = $('lb-registry-module-list');
    if (!host || !slug) return;
    host.innerHTML = '<p class="lb-admin-muted">載入中…</p>';
    var result = await fetchJson(PATHS.vendorsModuleState + '?slug_handle=' + encodeURIComponent(slug), {
      headers: { Accept: 'application/json' },
    });
    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      host.innerHTML = '<p class="lb-admin-muted">無法載入模組狀態</p>';
      return;
    }
    // Drawer may have moved on to another vendor while this was in flight.
    if (state.registryEditSlug !== slug) return;
    renderModuleStates(result.payload.items);
  }

  async function applyModuleStateAction(mode, action) {
    var slug = state.registryEditSlug;
    if (!slug || !mode || !action) return;
    var label = MODULE_LABELS[mode] || mode;
    var reason = '';

    if (action === 'force_stop') {
      reason = window.prompt('強制停售「' + label + '」會立刻下架該模組所有上架中課程並將 SAdmin 商品設為草稿。\n已購買的額度不會收回，已售出票券仍可核銷。\n\n請填寫停售理由：', '');
      if (reason === null) return;
      if (!String(reason).trim()) {
        setFlash('強制停售必須填寫理由', true);
        return;
      }
    } else if (action === 'disable') {
      if (!window.confirm('停用「' + label + '」後，該廠商不能再購買方案或送審新課程；既有額度／年約可繼續用到期，已售出票券不受影響。確定停用？')) return;
    }

    var result = await fetchJson(PATHS.vendorsModuleState, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        slug_handle: slug,
        listing_mode: mode,
        action: action,
        reason: reason || undefined,
      }),
    });

    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var err = result.payload && result.payload.error;
      setFlash((err && err.message ? err.message : '模組狀態更新失敗') + (err && err.code ? ' (' + err.code + ')' : ''), true);
      return;
    }

    var shutdown = result.payload.shutdown;
    if (result.payload.shutdown_error) {
      // State flipped but the courses are still live — the operator must act.
      setFlash(
        label + ' 狀態已更新，但下架失敗，課程可能仍在販售：' + result.payload.shutdown_error,
        true
      );
    } else {
      setFlash(
        label + ' 已更新' +
        (shutdown ? '：下架 ' + shutdown.unpublished + ' 筆，SAdmin 轉草稿 ' + shutdown.shopify_drafted + ' 筆' : ''),
        false
      );
    }
    await loadModuleStates(slug);
  }

  function openEditDrawer(item, options) {
    if (!item) return;
    options = options || {};
    state.registryEditSlug = item.slug_handle;
    clearDrawerActionError();
    $('lb-registry-drawer-title').textContent = '編輯廠商 · ' + item.slug_handle;
    $('lb-registry-edit-slug').value = item.slug_handle || '';
    $('lb-registry-edit-name').value = item.name || '';
    $('lb-registry-edit-email').value = item.contact_email || '';
    $('lb-registry-edit-phone').value = item.contact_phone || '';
    $('lb-registry-edit-logo').value = item.logo_url || '';
    $('lb-registry-edit-active').checked = item.is_active !== false;
    if ($('lb-registry-edit-private-requires-review')) {
      $('lb-registry-edit-private-requires-review').checked = !!item.private_listing_requires_review;
    }
    if ($('lb-registry-edit-fee-rate')) $('lb-registry-edit-fee-rate').value = item.fee_rate != null ? item.fee_rate : '';
    if ($('lb-registry-edit-event-id-prefix')) $('lb-registry-edit-event-id-prefix').value = item.event_id_prefix || '';
    if ($('lb-registry-edit-company-name')) $('lb-registry-edit-company-name').value = item.company_name || '';
    if ($('lb-registry-edit-tax-id')) $('lb-registry-edit-tax-id').value = item.tax_id || '';
    if ($('lb-registry-edit-bank-name')) $('lb-registry-edit-bank-name').value = item.bank_name || '';
    if ($('lb-registry-edit-bank-account')) $('lb-registry-edit-bank-account').value = item.bank_account || '';
    var fileInput = $('lb-registry-edit-logo-file');
    if (fileInput) fileInput.value = '';
    applyLogoPreviewForItem($('lb-registry-edit-logo-preview'), item);
    updateSyncPanel(item);
    loadModuleStates(item.slug_handle);
    var hint = $('lb-registry-drawer-hint');
    if (hint) {
      if (options.showSyncHint) show(hint);
      else hide(hint);
    }
    var drawer = $('lb-registry-drawer');
    mountDrawerToBody(drawer);
    show(drawer);
    drawer.setAttribute('aria-hidden', 'false');
    setDrawerOpenState(true);
    ensureRegistryDrawerActionBar();
    $('lb-registry-edit-name').focus();
  }

  function closeEditDrawer() {
    state.registryEditSlug = '';
    clearDrawerActionError();
    var hint = $('lb-registry-drawer-hint');
    if (hint) hide(hint);
    var drawer = $('lb-registry-drawer');
    hide(drawer);
    drawer.setAttribute('aria-hidden', 'true');
    setDrawerOpenState(false);
  }

  async function upsertRegistryVendor(body) {
    return fetchJson(PATHS.vendorsUpsert, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
  }

  function renderRegistryTable(items) {
    var tbody = $('lb-registry-table-body');
    var cardsHost = $('lb-registry-cards');
    if (!tbody) return;
    if (!items || !items.length) {
      tbody.innerHTML = '<tr><td colspan="8">無資料</td></tr>';
      if (cardsHost) cardsHost.innerHTML = '<p class="lb-admin-muted" style="text-align:center;padding:1rem 0">無資料</p>';
      return;
    }

    var cardsHtml = '';
    tbody.innerHTML = items.map(function (row) {
      var activeBadge = row.is_active
        ? '<span class="lb-admin-badge lb-admin-badge--on">啟用</span>'
        : '<span class="lb-admin-badge lb-admin-badge--off">停用</span>';
      var updated = row.updated_at ? new Date(row.updated_at).toLocaleString('zh-TW') : '—';
      var feeLabel = row.fee_rate != null && row.fee_rate !== ''
        ? (Number(row.fee_rate) * 100).toFixed(0) + '%'
        : '—';
      var actions =
        '<button type="button" class="lb-admin-btn lb-admin-btn--ghost lb-registry-edit" data-slug="' + escapeHtml(row.slug_handle) + '">編輯</button> ' +
        (row.is_active
          ? '<button type="button" class="lb-admin-btn lb-admin-btn--danger lb-registry-deactivate" data-slug="' + escapeHtml(row.slug_handle) + '">停用</button>'
          : '<button type="button" class="lb-admin-btn lb-registry-reactivate" data-slug="' + escapeHtml(row.slug_handle) + '">恢復</button>') +
        (state.advancedMode && /(test|probe)/i.test(row.slug_handle)
          ? ' <button type="button" class="lb-admin-btn lb-admin-btn--danger lb-registry-hard-delete" data-slug="' + escapeHtml(row.slug_handle) + '">硬刪除</button>'
          : '');

      cardsHtml += '<article class="lb-admin-m-card">' +
        '<div class="lb-admin-m-card__head lb-admin-m-card__head--logo">' +
          renderLogoThumbHtml(row) +
          '<div class="lb-admin-m-card__title-block">' +
            '<div class="lb-admin-m-card__title">' + escapeHtml(row.name) + '</div>' +
            '<code class="lb-admin-m-card__slug">' + escapeHtml(row.slug_handle) + '</code>' +
          '</div>' +
          activeBadge +
        '</div>' +
        '<div class="lb-admin-m-card__row"><span>同步</span><strong>' + escapeHtml(formatSyncStatus(row)) + '</strong></div>' +
        '<div class="lb-admin-m-card__row"><span>手續費率</span><strong>' + escapeHtml(feeLabel) + '</strong></div>' +
        '<div class="lb-admin-m-card__row"><span>更新</span><span>' + escapeHtml(updated) + '</span></div>' +
        '<div class="lb-admin-m-card__actions">' + actions + '</div>' +
      '</article>';

      return '<tr>' +
        '<td>' + renderLogoThumbHtml(row) + '</td>' +
        '<td><code>' + escapeHtml(row.slug_handle) + '</code>' + renderDuplicateSlugWarning(row) + '</td>' +
        '<td>' + escapeHtml(row.name) + '</td>' +
        '<td>' + activeBadge + '</td>' +
        '<td>' + escapeHtml(formatSyncStatus(row)) + '</td>' +
        '<td>' + escapeHtml(feeLabel) + '</td>' +
        '<td>' + escapeHtml(updated) + '</td>' +
        '<td class="lb-admin-table-actions">' + actions + '</td>' +
        '</tr>';
    }).join('');
    if (cardsHost) cardsHost.innerHTML = cardsHtml;

    function bindRegistryActions(root) {
      if (!root) return;
      root.querySelectorAll('.lb-registry-edit').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var slug = btn.getAttribute('data-slug');
          var item = state.registryVendors.find(function (v) { return v.slug_handle === slug; });
          if (item) openEditDrawer(item);
        });
      });
      root.querySelectorAll('.lb-registry-deactivate').forEach(function (btn) {
        btn.addEventListener('click', function () {
          deactivateRegistryRow(btn.getAttribute('data-slug'));
        });
      });
      root.querySelectorAll('.lb-registry-reactivate').forEach(function (btn) {
        btn.addEventListener('click', function () {
          reactivateRegistryRow(btn.getAttribute('data-slug'));
        });
      });
      root.querySelectorAll('.lb-registry-hard-delete').forEach(function (btn) {
        btn.addEventListener('click', function () {
          hardDeleteRegistryRow(btn.getAttribute('data-slug'));
        });
      });
    }
    bindRegistryActions(tbody);
    bindRegistryActions(cardsHost);
  }

  function globalIntentLabel(row) {
    if (row.global && row.global.force_stopped_at) return '全站意圖：強制停售';
    if (row.global && row.global.enabled === false) return '全站意圖：溫和關閉';
    return '全站意圖：開啟';
  }

  function renderGlobalModuleStates(items) {
    var host = $('lb-global-module-list');
    if (!host) return;
    if (!items || !items.length) {
      host.innerHTML = '<p class="lb-admin-muted">無法載入全站模組狀態</p>';
      return;
    }
    host.innerHTML = items.map(function (row) {
      var mode = String(row.listing_mode || '');
      var counts = row.counts || {};
      var mix = !row.uniform
        ? ('不一致：開 ' + (counts.enabled || 0) +
          '／溫和關 ' + (counts.disabled || 0) +
          '／強制停售 ' + (counts.force_stopped || 0) +
          ' — 請先用單廠編輯對齊')
        : ('啟用中廠商 ' + (counts.total || 0) + ' 家狀態一致');

      function btn(action, label, enabled, danger) {
        var cls = 'lb-admin-btn lb-global-module-act' +
          (danger ? ' lb-admin-btn--danger' : ' lb-admin-btn--outline');
        if (!enabled) cls += ' is-disabled';
        return '<button type="button" class="' + cls + '"' +
          ' data-mode="' + escapeHtml(mode) + '"' +
          ' data-action="' + escapeHtml(action) + '"' +
          (enabled ? '' : ' disabled aria-disabled="true"') +
          '>' + escapeHtml(label) + '</button>';
      }

      return '<div class="lb-admin-global-module-row' + (row.uniform ? '' : ' is-mixed') + '">' +
        '<div class="lb-admin-global-module-row__head">' +
          '<span class="lb-admin-global-module-row__name">' + escapeHtml(MODULE_LABELS[mode] || mode) + '</span>' +
          '<span class="lb-admin-global-module-row__intent">' + escapeHtml(globalIntentLabel(row)) + '</span>' +
        '</div>' +
        '<p class="lb-admin-global-module-row__mix">' + escapeHtml(mix) + '</p>' +
        '<div class="lb-admin-global-module-row__actions">' +
          btn('enable', '全站開啟', !!row.can_enable, false) +
          btn('disable', '全站停用', !!row.can_disable, false) +
          btn('force_stop', '全站強制停售', !!row.can_force_stop, true) +
          btn('release_force_stop', '全站解除強制停售', !!row.can_release_force_stop, false) +
        '</div>' +
        '</div>';
    }).join('');

    if (!host._lbGlobalModuleBound) {
      host._lbGlobalModuleBound = true;
      host.addEventListener('click', function (ev) {
        var btn = ev.target && ev.target.closest ? ev.target.closest('.lb-global-module-act') : null;
        if (!btn || !host.contains(btn) || btn.disabled) return;
        applyGlobalModuleStateAction(btn.getAttribute('data-mode'), btn.getAttribute('data-action'));
      });
    }
  }

  async function loadGlobalModuleStates() {
    var host = $('lb-global-module-list');
    if (!host) return;
    host.innerHTML = '<p class="lb-admin-muted">載入中…</p>';
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : null;
    try {
      var result = await fetchJson(PATHS.vendorsModuleStateGlobal, {
        headers: { Accept: 'application/json' },
        signal: ctrl ? ctrl.signal : undefined,
      });
      if (!result.response.ok || !result.payload || result.payload.ok !== true) {
        var code = result.payload && result.payload.error && result.payload.error.code;
        var msg = result.payload && result.payload.error && result.payload.error.message;
        host.innerHTML = '<p class="lb-admin-muted">無法載入全站模組狀態' +
          (msg ? '：' + escapeHtml(msg) : '') +
          (code ? ' (' + escapeHtml(code) + ')' : '') +
          ' <button type="button" class="lb-admin-btn lb-admin-btn--ghost" id="lb-global-module-retry">重試</button></p>';
        var retry = $('lb-global-module-retry');
        if (retry) retry.addEventListener('click', loadGlobalModuleStates);
        return;
      }
      renderGlobalModuleStates(result.payload.items);
    } catch (err) {
      var aborted = err && (err.name === 'AbortError' || /abort/i.test(String(err.message || err)));
      host.innerHTML = '<p class="lb-admin-muted">' +
        (aborted ? '載入逾時（15 秒）' : '載入失敗') +
        ' <button type="button" class="lb-admin-btn lb-admin-btn--ghost" id="lb-global-module-retry">重試</button></p>';
      var retryBtn = $('lb-global-module-retry');
      if (retryBtn) retryBtn.addEventListener('click', loadGlobalModuleStates);
    } finally {
      if (timer) clearTimeout(timer);
    }
  }

  function setGlobalModuleFlash(message, isError) {
    var el = $('lb-global-module-flash');
    if (el) {
      if (!message) {
        el.hidden = true;
        el.textContent = '';
        return;
      }
      el.hidden = false;
      el.textContent = hideShopifyNoun(message);
      el.className = 'lb-admin-flash ' + (isError ? 'lb-admin-flash--err' : 'lb-admin-flash--ok');
      try { el.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) { /* ignore */ }
    }
    setFlash(message, isError);
  }

  function setSlotAddonPurchaseFlash(message, isError) {
    var el = $('lb-slot-addon-purchase-flash');
    if (el) {
      if (!message) {
        el.hidden = true;
        el.textContent = '';
        return;
      }
      el.hidden = false;
      el.textContent = hideShopifyNoun(message);
      el.className = 'lb-admin-flash ' + (isError ? 'lb-admin-flash--err' : 'lb-admin-flash--ok');
      try { el.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) { /* ignore */ }
    }
    setFlash(message, isError);
  }

  function renderSlotAddonPurchaseSettings(enabled) {
    var host = $('lb-slot-addon-purchase-body');
    if (!host) return;
    var on = enabled !== false;
    host.innerHTML =
      '<div class="lb-admin-global-module-row">' +
        '<div class="lb-admin-global-module-row__head">' +
          '<span class="lb-admin-global-module-row__name">營運結帳：廣告版位方案區</span>' +
          '<span class="lb-admin-global-module-row__intent">' +
            escapeHtml(on ? '目前：顯示' : '目前：隱藏') +
          '</span>' +
        '</div>' +
        '<p class="lb-admin-global-module-row__mix">' +
          (on
            ? '營運結帳頁會列出廣告版位方案（進階方案區）。'
            : '營運結帳頁不列廣告版位方案；<strong>不影響購買</strong>：廠商仍可在「課程廣告刊登 → 第 2 步」購買／領取。') +
        '</p>' +
        '<div class="lb-admin-global-module-row__actions">' +
          '<button type="button" class="lb-admin-btn lb-admin-btn--outline lb-slot-addon-purchase-act"' +
            ' data-enabled="true"' + (on ? ' disabled aria-disabled="true"' : '') + '>顯示</button>' +
          '<button type="button" class="lb-admin-btn lb-admin-btn--danger lb-slot-addon-purchase-act"' +
            ' data-enabled="false"' + (!on ? ' disabled aria-disabled="true"' : '') + '>隱藏</button>' +
        '</div>' +
      '</div>';

    if (!host._lbSlotAddonBound) {
      host._lbSlotAddonBound = true;
      host.addEventListener('click', function (ev) {
        var btn = ev.target && ev.target.closest ? ev.target.closest('.lb-slot-addon-purchase-act') : null;
        if (!btn || !host.contains(btn) || btn.disabled) return;
        saveSlotAddonPurchaseSettings(btn.getAttribute('data-enabled') === 'true');
      });
    }
  }

  async function loadSlotAddonPurchaseSettings() {
    var host = $('lb-slot-addon-purchase-body');
    if (!host) return;
    host.innerHTML = '<p class="lb-admin-muted">載入中…</p>';
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : null;
    try {
      var result = await fetchJson(PATHS.slotAddonPurchaseSettings, {
        headers: { Accept: 'application/json' },
        signal: ctrl ? ctrl.signal : undefined,
      });
      if (!result.response.ok || !result.payload || result.payload.ok !== true) {
        var code = result.payload && result.payload.error && result.payload.error.code;
        var msg = result.payload && result.payload.error && result.payload.error.message;
        host.innerHTML = '<p class="lb-admin-muted">無法載入設定' +
          (msg ? '：' + escapeHtml(msg) : '') +
          (code ? ' (' + escapeHtml(code) + ')' : '') +
          ' <button type="button" class="lb-admin-btn lb-admin-btn--ghost" id="lb-slot-addon-purchase-retry">重試</button></p>';
        var retry = $('lb-slot-addon-purchase-retry');
        if (retry) retry.addEventListener('click', loadSlotAddonPurchaseSettings);
        return;
      }
      renderSlotAddonPurchaseSettings(result.payload.enabled !== false);
    } catch (err) {
      var aborted = err && (err.name === 'AbortError' || /abort/i.test(String(err.message || err)));
      host.innerHTML = '<p class="lb-admin-muted">' +
        (aborted ? '載入逾時（15 秒）' : '載入失敗') +
        ' <button type="button" class="lb-admin-btn lb-admin-btn--ghost" id="lb-slot-addon-purchase-retry">重試</button></p>';
      var retryBtn = $('lb-slot-addon-purchase-retry');
      if (retryBtn) retryBtn.addEventListener('click', loadSlotAddonPurchaseSettings);
    } finally {
      if (timer) clearTimeout(timer);
    }
  }

  async function saveSlotAddonPurchaseSettings(enabled) {
    setSlotAddonPurchaseFlash(enabled ? '儲存中：顯示…' : '儲存中：隱藏…', false);
    try {
      var result = await fetchJson(PATHS.slotAddonPurchaseSettings, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ enabled: !!enabled }),
      });
      if (!result.response.ok || !result.payload || result.payload.ok !== true) {
        var code = result.payload && result.payload.error && result.payload.error.code;
        var msg = result.payload && result.payload.error && result.payload.error.message;
        setSlotAddonPurchaseFlash((msg || '儲存失敗') + (code ? ' (' + code + ')' : ''), true);
        return;
      }
      renderSlotAddonPurchaseSettings(result.payload.enabled !== false);
      setSlotAddonPurchaseFlash(
        result.payload.enabled !== false
          ? '營運結帳已顯示廣告版位方案'
          : '營運結帳已隱藏廣告版位方案（課程廣告刊登照舊可購買／領取）',
        false
      );
    } catch (err) {
      setSlotAddonPurchaseFlash((err && err.message) || '儲存失敗', true);
    }
  }

  async function applyGlobalModuleStateAction(mode, action) {
    if (!mode || !action) return;
    var label = MODULE_LABELS[mode] || mode;
    var reason = '';

    if (action === 'force_stop') {
      reason = window.prompt(
        '全站強制停售「' + label + '」會對所有啟用中廠商立刻下架該模組課程並將 SAdmin 商品設為草稿。\n已購買額度不收回；已售票仍可核銷。\n\n請填寫停售理由：',
        ''
      );
      if (reason === null) return;
      if (!String(reason).trim()) {
        setGlobalModuleFlash('強制停售必須填寫理由', true);
        return;
      }
    } else if (action === 'disable') {
      if (!window.confirm(
        '全站停用「' + label + '」後，所有啟用中廠商不能再購買新方案；既有額度可送審至用完或到期。新建廠商也會預設關閉。確定？'
      )) return;
    } else if (action === 'enable') {
      if (!window.confirm('全站開啟「' + label + '」？所有啟用中廠商與之後新建廠商都會恢復可購買／送審。')) return;
    } else if (action === 'release_force_stop') {
      if (!window.confirm('全站解除「' + label + '」強制停售？不會自動重開模組或復售課程。')) return;
    }

    setGlobalModuleFlash('處理中…', false);
    var result;
    try {
      result = await fetchJson(PATHS.vendorsModuleStateGlobal, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          listing_mode: mode,
          action: action,
          reason: reason || undefined,
        }),
      });
    } catch (err) {
      setGlobalModuleFlash(err && err.message ? err.message : '全站模組更新失敗', true);
      return;
    }

    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var err = result.payload && result.payload.error;
      var failMsg = (err && err.message ? err.message : '全站模組更新失敗') +
        (err && err.code ? ' (' + err.code + ')' : '') +
        (result.response && result.response.status ? ' [HTTP ' + result.response.status + ']' : '');
      setGlobalModuleFlash(failMsg, true);
      await loadGlobalModuleStates();
      return;
    }

    var fanout = result.payload.fanout || {};
    var updateErrs = (fanout.update_errors && fanout.update_errors.length) || 0;
    var shutdownErrs = (fanout.shutdown_errors && fanout.shutdown_errors.length) || 0;
    var hasErr = !!(updateErrs || shutdownErrs);
    setGlobalModuleFlash(
      label + ' 全站已更新：同步 ' + (fanout.updated || 0) + '/' + (fanout.vendors || 0) + ' 家' +
      (fanout.unpublished != null ? '，下架 ' + fanout.unpublished + ' 筆' : '') +
      (updateErrs ? '（' + updateErrs + ' 家狀態寫入失敗）' : '') +
      (shutdownErrs ? '（' + shutdownErrs + ' 家下架失敗）' : ''),
      hasErr
    );
    await loadGlobalModuleStates();
  }

  async function refreshRegistryList() {
    var includeInactive = $('lb-registry-show-inactive') && $('lb-registry-show-inactive').checked;
    var result = await loadVendors(includeInactive);
    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var code = result.payload && result.payload.error && result.payload.error.code;
      var msg = result.payload && result.payload.error && result.payload.error.message;
      setFlash((msg || '載入廠商列表失敗') + (code ? ' (' + code + ')' : ''), true);
      return;
    }
    renderRegistryTable(state.registryVendors);
    loadGlobalModuleStates();
    loadSlotAddonPurchaseSettings();
  }

  async function handleSaveAndSyncOutcome(result, slug, options) {
    options = options || {};
    var payload = result.payload;

    if (payload && payload.partial_ok) {
      var partialErr = extractApiError(result);
      if (options.showDrawerError) {
        showDrawerActionError(partialErr.code, partialErr.message);
      }
      setFlash(partialErr.message, true);
      if (partialErr.item) {
        applyRegistryItemFromSave(partialErr.item);
      }
      await refreshRegistryList();
      await loadVendors(false);
      if (partialErr.item) {
        if (options.onItem) options.onItem(partialErr.item);
        openEditDrawer(partialErr.item, { showSyncHint: true });
      }
      return { handled: true, success: false, partial: true, item: partialErr.item };
    }

    if (!result.response.ok || !payload || payload.ok !== true) {
      var err = extractApiError(result);
      if (options.showDrawerError) {
        showDrawerActionError(err.code, err.message);
      }
      setFlash('[' + (err.code || 'ERROR') + '] ' + (err.message || '儲存並同步失敗'), true);
      if (err.item) {
        if (options.onItem) options.onItem(err.item);
        await refreshRegistryList();
        if (options.openDrawerOnError) {
          openEditDrawer(err.item, { showSyncHint: true });
        }
      }
      return { handled: true, success: false, partial: false, item: err.item };
    }

    var item = payload.vendor || payload.item;
    var isSyncFailed = item && item.sync_status === 'sync_failed';
    setFlash(formatSaveAndSyncFlash(slug, item), isSyncFailed);
    if (options.clearDrawerError) clearDrawerActionError();
    if (item && options.onItem) options.onItem(item);
    await refreshRegistryList();
    await loadVendors(false);
    if (item && !options.skipDrawerOnSuccess) {
      openEditDrawer(item, { showSyncHint: true });
    }
    return { handled: true, success: true, partial: false, item: item };
  }

  async function submitRegistryAddDbOnly() {
    var slug = ($('lb-registry-add-slug').value || '').trim();
    var name = ($('lb-registry-add-name').value || '').trim();
    if (!slug || !name) {
      setFlash('廠商代稱與名稱為必填', true);
      return;
    }
    if (!/^[A-Za-z0-9_-]+$/.test(slug)) {
      setFlash('廠商代稱僅允許英數字、底線與連字號', true);
      return;
    }

    var body = {
      slug_handle: slug,
      name: name,
      contact_email: ($('lb-registry-add-email').value || '').trim(),
      contact_phone: ($('lb-registry-add-phone').value || '').trim(),
      logo_url: state.advancedMode ? ($('lb-registry-add-logo').value || '').trim() : '',
      is_active: $('lb-registry-add-active').checked,
      private_listing_requires_review: !!($('lb-registry-add-private-requires-review') && $('lb-registry-add-private-requires-review').checked),
      fee_rate: $('lb-registry-add-fee-rate') ? ($('lb-registry-add-fee-rate').value || '').trim() : '',
      event_id_prefix: $('lb-registry-add-event-id-prefix') ? ($('lb-registry-add-event-id-prefix').value || '').trim() : '',
      company_name: $('lb-registry-add-company-name') ? ($('lb-registry-add-company-name').value || '').trim() : '',
      tax_id: $('lb-registry-add-tax-id') ? ($('lb-registry-add-tax-id').value || '').trim() : '',
      bank_name: $('lb-registry-add-bank-name') ? ($('lb-registry-add-bank-name').value || '').trim() : '',
      bank_account: $('lb-registry-add-bank-account') ? ($('lb-registry-add-bank-account').value || '').trim() : '',
    };

    var settlementErr = validateSettlementFields(body);
    if (settlementErr) {
      setFlash(settlementErr.message, true);
      return;
    }

    var dbBtn = $('lb-registry-add-db-only');
    setButtonLoading(dbBtn, true, '儲存中…');
    var result = await upsertRegistryVendor(body);
    setButtonLoading(dbBtn, false);

    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var err = extractApiError(result);
      setFlash('[' + (err.code || 'ERROR') + '] ' + (err.message || '僅儲存 DB 失敗'), true);
      return;
    }

    setFlash('已儲存到資料庫（含結算欄位）：' + slug, false);
    $('lb-registry-add-form').reset();
    $('lb-registry-add-active').checked = true;
    await refreshRegistryList();
    await loadVendors(false);
  }

  async function submitRegistryAddForm(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    var slug = ($('lb-registry-add-slug').value || '').trim();
    var name = ($('lb-registry-add-name').value || '').trim();
    if (!slug || !name) {
      setFlash('廠商代稱與名稱為必填', true);
      return;
    }
    if (!/^[A-Za-z0-9_-]+$/.test(slug)) {
      setFlash('廠商代稱僅允許英數字、底線與連字號', true);
      return;
    }

    var fields = {
      slug_handle: slug,
      name: name,
      contact_email: ($('lb-registry-add-email').value || '').trim(),
      contact_phone: ($('lb-registry-add-phone').value || '').trim(),
      logo_url: state.advancedMode ? ($('lb-registry-add-logo').value || '').trim() : '',
      is_active: $('lb-registry-add-active').checked,
      private_listing_requires_review: !!($('lb-registry-add-private-requires-review') && $('lb-registry-add-private-requires-review').checked),
      fee_rate: $('lb-registry-add-fee-rate') ? ($('lb-registry-add-fee-rate').value || '').trim() : '',
      event_id_prefix: $('lb-registry-add-event-id-prefix') ? ($('lb-registry-add-event-id-prefix').value || '').trim() : '',
      company_name: $('lb-registry-add-company-name') ? ($('lb-registry-add-company-name').value || '').trim() : '',
      tax_id: $('lb-registry-add-tax-id') ? ($('lb-registry-add-tax-id').value || '').trim() : '',
      bank_name: $('lb-registry-add-bank-name') ? ($('lb-registry-add-bank-name').value || '').trim() : '',
      bank_account: $('lb-registry-add-bank-account') ? ($('lb-registry-add-bank-account').value || '').trim() : '',
    };

    var settlementErr = validateSettlementFields(fields);
    if (settlementErr) {
      setFlash(settlementErr.message, true);
      return;
    }

    var submitBtn = $('lb-registry-add-submit');
    setButtonLoading(submitBtn, true, '新增中…');

    var outcome;
    try {
      outcome = await submitRegistryWithOptionalLogo(fields, $('lb-registry-add-logo-file'), {
        submitBtn: submitBtn,
        openDrawerOnError: true,
      });
    } catch (buildErr) {
      setButtonLoading(submitBtn, false);
      setFlash('[' + (buildErr.code || 'ERROR') + '] ' + (buildErr.message || '無法建立請求'), true);
      return;
    }

    setButtonLoading(submitBtn, false);

    if (outcome.success && !outcome.logoFailed) {
      $('lb-registry-add-form').reset();
      $('lb-registry-add-active').checked = true;
    }
  }

  async function submitRegistryEditForm(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    var slug = state.registryEditSlug || ($('lb-registry-edit-slug').value || '').trim();
    var name = ($('lb-registry-edit-name').value || '').trim();
    if (!slug || !name) {
      setFlash('廠商代稱與名稱為必填', true);
      return;
    }

    var fields = {
      registry_id: state.registryEditSlug || slug,
      slug_handle: slug,
      name: name,
      contact_email: ($('lb-registry-edit-email').value || '').trim(),
      contact_phone: ($('lb-registry-edit-phone').value || '').trim(),
      logo_url: state.advancedMode ? ($('lb-registry-edit-logo').value || '').trim() : '',
      is_active: $('lb-registry-edit-active').checked,
      private_listing_requires_review: !!($('lb-registry-edit-private-requires-review') && $('lb-registry-edit-private-requires-review').checked),
      fee_rate: $('lb-registry-edit-fee-rate') ? ($('lb-registry-edit-fee-rate').value || '').trim() : '',
      event_id_prefix: $('lb-registry-edit-event-id-prefix') ? ($('lb-registry-edit-event-id-prefix').value || '').trim() : '',
      company_name: $('lb-registry-edit-company-name') ? ($('lb-registry-edit-company-name').value || '').trim() : '',
      tax_id: $('lb-registry-edit-tax-id') ? ($('lb-registry-edit-tax-id').value || '').trim() : '',
      bank_name: $('lb-registry-edit-bank-name') ? ($('lb-registry-edit-bank-name').value || '').trim() : '',
      bank_account: $('lb-registry-edit-bank-account') ? ($('lb-registry-edit-bank-account').value || '').trim() : '',
    };

    var settlementErr = validateSettlementFields(fields);
    if (settlementErr) {
      showDrawerActionError(settlementErr.code, settlementErr.message);
      setFlash(settlementErr.message, true);
      return;
    }

    var submitBtn = $('lb-registry-edit-submit');
    clearDrawerActionError();
    setButtonLoading(submitBtn, true, '儲存中…');

    try {
      // Settlement fields are DB-only; persist them first so App Proxy Shopify sync
      // timeouts cannot wipe out fee_rate / payout metadata after a partial UI failure.
      var dbBody = {
        slug_handle: fields.slug_handle,
        name: fields.name,
        contact_email: fields.contact_email,
        contact_phone: fields.contact_phone,
        logo_url: fields.logo_url || '',
        is_active: fields.is_active,
        private_listing_requires_review: fields.private_listing_requires_review,
        fee_rate: fields.fee_rate,
        event_id_prefix: fields.event_id_prefix,
        company_name: fields.company_name,
        tax_id: fields.tax_id,
        bank_name: fields.bank_name,
        bank_account: fields.bank_account,
      };
      var dbResult = await upsertRegistryVendor(dbBody);
      if (!dbResult.response.ok || !dbResult.payload || dbResult.payload.ok !== true) {
        var dbErr = extractApiError(dbResult);
        showDrawerActionError(dbErr.code, dbErr.message);
        setFlash('[' + (dbErr.code || 'ERROR') + '] ' + (dbErr.message || '儲存 DB 失敗'), true);
        setButtonLoading(submitBtn, false);
        return;
      }

      setButtonLoading(submitBtn, true, '同步至 LadyBae…');
      var outcome = await submitRegistryWithOptionalLogo(fields, $('lb-registry-edit-logo-file'), {
        submitBtn: submitBtn,
        showDrawerError: true,
        clearDrawerError: true,
        onItem: applyRegistryItemFromSave,
      });
      if (outcome && !outcome.success && !outcome.partial) {
        // Keep drawer open; settlement/basic fields were already saved above.
        setFlash('資料已寫入 DB，但 LadyBae 同步未完成。請稍後重新開啟編輯再按「儲存」。', true);
      }
    } catch (buildErr) {
      setButtonLoading(submitBtn, false);
      showDrawerActionError(buildErr.code, buildErr.message);
      setFlash('[' + (buildErr.code || 'ERROR') + '] ' + (buildErr.message || '無法建立請求'), true);
      return;
    }

    setButtonLoading(submitBtn, false);
  }

  async function submitRegistryDbOnly() {
    var slug = state.registryEditSlug || ($('lb-registry-edit-slug').value || '').trim();
    var name = ($('lb-registry-edit-name').value || '').trim();
    if (!slug || !name) {
      setFlash('廠商代稱與名稱為必填', true);
      return;
    }

    var body = {
      slug_handle: slug,
      name: name,
      contact_email: ($('lb-registry-edit-email').value || '').trim(),
      contact_phone: ($('lb-registry-edit-phone').value || '').trim(),
      logo_url: ($('lb-registry-edit-logo').value || '').trim(),
      is_active: $('lb-registry-edit-active').checked,
      private_listing_requires_review: !!($('lb-registry-edit-private-requires-review') && $('lb-registry-edit-private-requires-review').checked),
      fee_rate: $('lb-registry-edit-fee-rate') ? ($('lb-registry-edit-fee-rate').value || '').trim() : '',
      event_id_prefix: $('lb-registry-edit-event-id-prefix') ? ($('lb-registry-edit-event-id-prefix').value || '').trim() : '',
      company_name: $('lb-registry-edit-company-name') ? ($('lb-registry-edit-company-name').value || '').trim() : '',
      tax_id: $('lb-registry-edit-tax-id') ? ($('lb-registry-edit-tax-id').value || '').trim() : '',
      bank_name: $('lb-registry-edit-bank-name') ? ($('lb-registry-edit-bank-name').value || '').trim() : '',
      bank_account: $('lb-registry-edit-bank-account') ? ($('lb-registry-edit-bank-account').value || '').trim() : '',
    };

    var settlementErr = validateSettlementFields(body);
    if (settlementErr) {
      showDrawerActionError(settlementErr.code, settlementErr.message);
      setFlash(settlementErr.message, true);
      return;
    }

    var dbBtn = $('lb-registry-edit-db-only');
    setButtonLoading(dbBtn, true, '儲存中…');
    var result = await upsertRegistryVendor(body);
    setButtonLoading(dbBtn, false);

    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var code = result.payload && result.payload.error && result.payload.error.code;
      var msg = result.payload && result.payload.error && result.payload.error.message;
      showDrawerActionError(code, msg || '僅儲存 DB 失敗');
      setFlash((msg || '僅儲存 DB 失敗') + (code ? ' (' + code + ')' : ''), true);
      return;
    }

    var savedItem = result.payload.item || result.payload.vendor;
    setFlash('已儲存到資料庫（含結算欄位）：' + slug, false);
    clearDrawerActionError();
    if (savedItem) {
      applyRegistryItemFromSave(savedItem);
      openEditDrawer(savedItem);
    }
    await refreshRegistryList();
    await loadVendors(false);
  }

  async function reactivateRegistryRow(slug) {
    if (!slug) return;
    if (!window.confirm('確定恢復廠商 ' + slug + '？')) return;

    var result = await fetchJson(PATHS.vendorsReactivate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ slug_handle: slug }),
    });

    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var err = extractApiError(result);
      setFlash((err.message || '恢復廠商失敗') + (err.code ? ' (' + err.code + ')' : ''), true);
      return;
    }

    setFlash('已恢復廠商 ' + slug + '。若已有同步記錄，建議按「儲存並同步至 LadyBae」。', false);
    await refreshRegistryList();
    await loadVendors(false);
  }

  async function hardDeleteRegistryRow(slug) {
    if (!slug || !state.advancedMode) return;
    if (!/(test|probe)/i.test(slug)) {
      setFlash('硬刪除僅限測試用代稱', true);
      return;
    }
    if (!window.confirm('進階模式：確定硬刪除測試廠商 ' + slug + '？此動作不可復原。')) return;

    var result = await fetchJson(PATHS.vendorsHardDelete, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ slug_handle: slug }),
    });

    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var err = extractApiError(result);
      setFlash((err.message || '硬刪除失敗') + (err.code ? ' (' + err.code + ')' : ''), true);
      return;
    }

    setFlash('已硬刪除測試廠商 ' + slug, false);
    if (state.registryEditSlug === slug) closeEditDrawer();
    await refreshRegistryList();
    await loadVendors(false);
  }

  async function deactivateRegistryRow(slug) {
    if (!slug) return;
    if (!window.confirm('確定停用廠商 ' + slug + '？（停用，不刪除）')) return;

    var result = await fetchJson(PATHS.vendorsDeactivate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ slug_handle: slug }),
    });

    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var code = result.payload && result.payload.error && result.payload.error.code;
      var msg = result.payload && result.payload.error && result.payload.error.message;
      setFlash((msg || '停用廠商失敗') + (code ? ' (' + code + ')' : ''), true);
      return;
    }

    setFlash('已停用廠商 ' + slug, false);
    if (state.registryEditSlug === slug) closeEditDrawer();
    await refreshRegistryList();
    await loadVendors(false);
  }

  async function legacySyncSlugOnlyAdvanced() {
    if (!state.advancedMode) {
      setFlash('舊版同步僅限進階模式', true);
      return;
    }
    var slug = state.registryEditSlug || ($('lb-registry-edit-slug').value || '').trim();
    if (!slug) {
      setFlash('請先選擇要同步的廠商', true);
      return;
    }

    var syncBtn = $('lb-registry-edit-sync-legacy');
    clearDrawerActionError();
    setButtonLoading(syncBtn, true, '同步中…');

    var result = await fetchJson(PATHS.vendorsSyncShopifyLegacy, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ slug_handle: slug }),
    });

    setButtonLoading(syncBtn, false);

    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var err = extractApiError(result);
      showDrawerActionError(err.code, err.message);
      setFlash('[' + err.code + '] ' + (err.message || '舊版同步失敗'), true);
      if (err.item) {
        updateSyncPanel(err.item);
        applyRegistryItemToState(err.item);
      }
      return;
    }

    var item = result.payload.item;
    setFlash('舊版同步完成：' + slug, false);
    clearDrawerActionError();
    if (item) {
      updateSyncPanel(item);
      applyRegistryItemToState(item);
    }
    await refreshRegistryList();
    await loadVendors(false);
  }

  function wireLegacyDomCompat() {
    var legacySyncBtn = $('lb-registry-edit-sync');
    if (legacySyncBtn) {
      legacySyncBtn.type = 'button';
      legacySyncBtn.textContent = '儲存並同步至 LadyBae';
      legacySyncBtn.replaceWith(legacySyncBtn.cloneNode(true));
      var rewiredBtn = $('lb-registry-edit-sync');
      if (rewiredBtn) {
        rewiredBtn.addEventListener('click', function (event) {
          event.preventDefault();
          var form = $('lb-registry-edit-form');
          if (form) form.requestSubmit();
        });
      }
    }

    var legacyUploadBtn = $('lb-registry-edit-upload-logo');
    if (legacyUploadBtn) {
      hide(legacyUploadBtn);
    }
  }

  async function importRegistryFromShopify() {
    var slug = state.registryEditSlug || ($('lb-registry-edit-slug').value || '').trim();
    if (!slug) {
      setFlash('請先選擇廠商', true);
      return;
    }

    var importBtn = $('lb-registry-edit-import');
    clearDrawerActionError();
    setButtonLoading(importBtn, true, '匯入中…');

    var result = await fetchJson(PATHS.vendorsImportShopify, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ slug_handle: slug }),
    });

    setButtonLoading(importBtn, false);

    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var err = extractApiError(result);
      showDrawerActionError(err.code, err.message);
      setFlash((err.message || '從 LadyBae 匯入失敗') + (err.code ? ' (' + err.code + ')' : ''), true);
      if (err.item) {
        updateSyncPanel(err.item);
        applyRegistryItemToState(err.item);
      }
      return;
    }

    var item = result.payload.item;
    setFlash('已從 LadyBae 匯入：' + slug, false);
    clearDrawerActionError();
    if (item) {
      $('lb-registry-edit-name').value = item.name || '';
      $('lb-registry-edit-email').value = item.contact_email || '';
      $('lb-registry-edit-phone').value = item.contact_phone || '';
      if (item.logo_url) {
        $('lb-registry-edit-logo').value = item.logo_url;
      }
      applyLogoPreviewForItem($('lb-registry-edit-logo-preview'), item);
      updateSyncPanel(item);
      applyRegistryItemToState(item);
    }
    await refreshRegistryList();
    await loadVendors(false);
  }

  function renderBulkImportResult(result) {
    var panel = $('lb-registry-bulk-import-result');
    if (!panel) return;
    if (!result) {
      hide(panel);
      panel.innerHTML = '';
      return;
    }

    var errors = result.errors || [];
    var html = '<p><strong>LadyBae 批次匯入完成</strong></p>' +
      '<ul class="lb-admin-bulk-result__stats">' +
      '<li>匯入成功：<strong>' + (result.imported_count || 0) + '</strong></li>' +
      '<li>新增：<strong>' + (result.created_count || 0) + '</strong></li>' +
      '<li>更新：<strong>' + (result.updated_count || 0) + '</strong></li>' +
      '<li>略過：<strong>' + (result.skipped_count || 0) + '</strong></li>' +
      '<li>錯誤：<strong>' + errors.length + '</strong></li>' +
      '</ul>';

    if (errors.length) {
      html += '<details class="lb-admin-bulk-result__errors"><summary>錯誤明細</summary><ul>' +
        errors.map(function (err) {
          return '<li><code>' + escapeHtml(err.slug_handle || '—') + '</code> · ' +
            escapeHtml(hideShopifyNoun(err.code || 'ERROR')) + ' · ' + escapeHtml(hideShopifyNoun(err.message || '')) + '</li>';
        }).join('') +
        '</ul></details>';
    }

    panel.innerHTML = html;
    show(panel);
  }

  async function bulkImportRegistryFromShopify() {
    if (!window.confirm('將從 LadyBae 廠商資料批次匯入／對齊所有啟用中的廠商。繼續？')) {
      return;
    }

    var bulkBtn = $('lb-registry-bulk-import');
    clearDrawerActionError();
    setButtonLoading(bulkBtn, true, '匯入中…');
    renderBulkImportResult(null);

    var result = await fetchJson(PATHS.vendorsImportShopifyBulk, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({}),
    });

    setButtonLoading(bulkBtn, false);

    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var err = extractApiError(result);
      setFlash((err.message || '批次匯入失敗') + (err.code ? ' (' + err.code + ')' : ''), true);
      return;
    }

    var bulk = result.payload.bulk_import_result || {};
    renderBulkImportResult(bulk);
    setFlash(
      '批次匯入完成：成功 ' + (bulk.imported_count || 0) +
      '（新增 ' + (bulk.created_count || 0) + ' / 更新 ' + (bulk.updated_count || 0) + '）',
      false
    );
    await refreshRegistryList();
    await loadVendors(false);
  }

  async function loadList() {
    var params = new URLSearchParams();
    params.set('page', String(state.page));
    params.set('limit', String(state.limit));

    var q = ($('lb-admin-filter-q') && $('lb-admin-filter-q').value || '').trim();
    var slug = ($('lb-admin-filter-slug') && $('lb-admin-filter-slug').value || '').trim();
    var role = ($('lb-admin-filter-role') && $('lb-admin-filter-role').value || '').trim();
    var active = ($('lb-admin-filter-active') && $('lb-admin-filter-active').value || '').trim();

    if (q) params.set('q', q);
    if (slug) params.set('vendor_slug', slug);
    if (role) params.set('role', role);
    if (active) params.set('is_active', active);

    return fetchJson(PATHS.list + '?' + params.toString(), { method: 'GET' });
  }

  function renderTable(items) {
    var tbody = $('lb-admin-table-body');
    var cardsHost = $('lb-admin-users-cards');
    if (!tbody) return;
    state.listItems = items || [];
    if (!items || !items.length) {
      tbody.innerHTML = '<tr><td colspan="8">無資料</td></tr>';
      if (cardsHost) cardsHost.innerHTML = '<p class="lb-admin-muted" style="text-align:center;padding:1rem 0">無資料</p>';
      return;
    }

    var cardsHtml = '';
    tbody.innerHTML = items.map(function (row, index) {
      var activeBadge = row.is_active
        ? '<span class="lb-admin-badge lb-admin-badge--on">啟用</span>'
        : '<span class="lb-admin-badge lb-admin-badge--off">停用</span>';
      var customerLabel = escapeHtml(row.shopify_customer_id_masked || row.shopify_customer_id_last4 || '—');
      var customerName = escapeHtml(row.customer_display_name || '未取得會員姓名');
      var customerEmail = escapeHtml(row.customer_email || '未取得 Email');
      var customerIdentity =
        '<div class="lb-admin-customer-identity">' +
          '<strong class="lb-admin-customer-identity__name">' + customerName + '</strong>' +
          '<span class="lb-admin-customer-identity__email">' + customerEmail + '</span>' +
          '<small class="lb-admin-customer-identity__id">' + customerLabel + '</small>' +
        '</div>';
      var updated = row.updated_at ? new Date(row.updated_at).toLocaleString('zh-TW') : '—';
      var actions =
        '<button type="button" class="lb-admin-btn lb-admin-btn--ghost lb-admin-edit" data-index="' + index + '">編輯</button> ' +
        (row.is_active
          ? '<button type="button" class="lb-admin-btn lb-admin-btn--danger lb-admin-deactivate" data-index="' + index + '">停用</button>'
          : '<button type="button" class="lb-admin-btn lb-admin-btn--accent lb-admin-activate" data-index="' + index + '">啟用</button>');
      cardsHtml += '<article class="lb-admin-m-card">' +
        '<div class="lb-admin-m-card__head">' +
          '<div class="lb-admin-m-card__title">' + customerIdentity + '</div>' +
          activeBadge +
        '</div>' +
        '<div class="lb-admin-m-card__row"><span>廠商</span><code>' + escapeHtml(row.slug_handle) + '</code></div>' +
        '<div class="lb-admin-m-card__row"><span>角色</span><strong>' + escapeHtml(row.role) + '</strong></div>' +
        '<div class="lb-admin-m-card__row"><span>來源</span><span>' + escapeHtml(row.source || '—') + '</span></div>' +
        '<div class="lb-admin-m-card__row"><span>備註</span><span>' + escapeHtml(row.note || '—') + '</span></div>' +
        '<div class="lb-admin-m-card__row"><span>更新</span><span>' + escapeHtml(updated) + '</span></div>' +
        '<div class="lb-admin-m-card__actions">' + actions + '</div>' +
      '</article>';
      return '<tr>' +
        '<td>' + customerIdentity + '</td>' +
        '<td><code>' + escapeHtml(row.slug_handle) + '</code></td>' +
        '<td>' + escapeHtml(row.role) + '</td>' +
        '<td>' + activeBadge + '</td>' +
        '<td>' + escapeHtml(row.source || '—') + '</td>' +
        '<td>' + escapeHtml(row.note || '—') + '</td>' +
        '<td>' + escapeHtml(updated) + '</td>' +
        '<td class="lb-admin-table-actions">' + actions + '</td>' +
        '</tr>';
    }).join('');
    if (cardsHost) cardsHost.innerHTML = cardsHtml;

    function bindUserActions(root) {
      if (!root) return;
      root.querySelectorAll('.lb-admin-edit').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var index = parseInt(btn.getAttribute('data-index') || '-1', 10);
          var row = state.listItems[index];
          if (row) openUserEditDrawer(row);
        });
      });
      root.querySelectorAll('.lb-admin-deactivate').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var index = parseInt(btn.getAttribute('data-index') || '-1', 10);
          var row = state.listItems[index];
          if (row) deactivateUserRecord(row.shopify_customer_id, row.slug_handle, row.shopify_customer_id_last4);
        });
      });
      root.querySelectorAll('.lb-admin-activate').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var index = parseInt(btn.getAttribute('data-index') || '-1', 10);
          var row = state.listItems[index];
          if (row) reactivateUserRecord(row);
        });
      });
    }
    bindUserActions(tbody);
    bindUserActions(cardsHost);
  }

  function updatePagination() {
    var p = state.pagination || { page: 1, total_pages: 0, total: 0 };
    $('lb-admin-page-info').textContent = '第 ' + p.page + ' / ' + (p.total_pages || 1) + ' 頁（共 ' + (p.total || 0) + ' 筆）';
    $('lb-admin-prev').disabled = p.page <= 1;
    $('lb-admin-next').disabled = !p.total_pages || p.page >= p.total_pages;
  }

  async function refreshList() {
    setFlash('', false);
    var result = await loadList();
    if (result.response.status === 403 && result.payload && result.payload.error && result.payload.error.code === 'ADMIN_NOT_ALLOWED') {
      hide($('lb-admin-app'));
      show($('lb-admin-denied'));
      return;
    }
    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var code = result.payload && result.payload.error && result.payload.error.code;
      var msg = result.payload && result.payload.error && result.payload.error.message;
      setFlash((msg || '載入失敗') + (code ? ' (' + code + ')' : ''), true);
      return;
    }
    state.pagination = result.payload.pagination || null;
    renderTable(result.payload.items || []);
    updatePagination();
  }

  async function submitForm(event) {
    event.preventDefault();
    var customerId = resolveCustomerIdFromForm();
    if (!/^\d+$/.test(customerId)) {
      setFlash(state.advancedMode
        ? '會員編號格式不正確（請貼數字編號或 LadyBae 會員網址）'
        : '請先從「搜尋 LadyBae 會員」選擇一位顧客', true);
      return;
    }

    var slug = resolveSlugFromForm();
    applyOfficialScanRoleHint();
    var body = {
      shopify_customer_id: customerId,
      slug_handle: slug,
      role: getSelectedRole(),
      is_active: true,
      note: ($('lb-admin-note-input').value || '').trim(),
    };

    if (!body.slug_handle) {
      setFlash('請選擇啟用中的廠商（若無選項，請先在「廠商主檔」新增廠商）', true);
      return;
    }

    var result = await fetchJson(PATHS.upsert, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });

    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var code = result.payload && result.payload.error && result.payload.error.code;
      var msg = result.payload && result.payload.error && result.payload.error.message;
      if (code === 'VENDOR_NOT_FOUND') {
        setFlash('廠商不在啟用名單中', true);
        return;
      }
      if (code === 'VENDOR_INACTIVE') {
        setFlash('廠商已停用', true);
        return;
      }
      setFlash((msg || '儲存失敗') + (code ? ' (' + code + ')' : ''), true);
      return;
    }

    setFlash('已新增／更新權限：' + body.slug_handle + '（' + (ROLE_LABELS[body.role] || body.role) + '）', false);
    if (state.selectedCustomerId) await refreshSelectedMemberPermissions();
    else await refreshList();
  }

  function roleOptionsForVendorSlug(slug) {
    if (slug === OFFICIAL_SCAN_SLUG) return ['scan_only', 'staff'];
    if (slug === OFFICIAL_OPS_SLUG) return ['staff', 'owner'];
    if (slug === 'Admin0920' || slug === '__admin__') return ['admin'];
    return ['owner', 'staff', 'scan_only', 'admin'];
  }

  function populateUserDrawerRoleSelect(slug, selectedRole) {
    var selectEl = $('lb-user-drawer-role');
    if (!selectEl) return;
    var roles = roleOptionsForVendorSlug(slug);
    var role = roles.indexOf(selectedRole) >= 0 ? selectedRole : roles[0];
    selectEl.innerHTML = roles.map(function (item) {
      var selected = item === role ? ' selected' : '';
      var label = ROLE_LABELS[item] || item;
      return '<option value="' + escapeHtml(item) + '"' + selected + '>' + escapeHtml(label) + '</option>';
    }).join('');
  }

  function formatVendorSlugLabel(slug) {
    var bootstrap = OFFICIAL_OPS_BOOTSTRAP_VENDORS
      .concat(OFFICIAL_SCAN_BOOTSTRAP_VENDORS)
      .concat(ADMIN_BOOTSTRAP_VENDORS)
      .find(function (item) { return item.slug_handle === slug; });
    if (bootstrap) return formatVendorLabel(bootstrap);
    var registry = state.vendors.find(function (item) { return item.slug_handle === slug; });
    if (registry) return formatVendorLabel(registry);
    return slug;
  }

  function showUserDrawerActionError(message) {
    var el = $('lb-user-drawer-action-error');
    if (!el) return;
    if (!message) {
      hide(el);
      el.textContent = '';
      return;
    }
    el.textContent = hideShopifyNoun(message);
    show(el);
    try {
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } catch (e) { /* ignore */ }
  }

  function clearUserDrawerActionError() {
    showUserDrawerActionError('');
  }

  function openUserEditDrawer(row) {
    state.userEditRow = row;
    var drawer = $('lb-user-drawer');
    if (!drawer) return;

    clearUserDrawerActionError();
    $('lb-user-drawer-title').textContent = '編輯權限';
    $('lb-user-drawer-customer').innerHTML =
      '<strong class="lb-admin-drawer-customer__name">' + escapeHtml(row.customer_display_name || '未取得會員姓名') + '</strong>' +
      '<span class="lb-admin-drawer-customer__email">' + escapeHtml(row.customer_email || '未取得 Email') + '</span>' +
      '<small class="lb-admin-drawer-customer__id">' +
        escapeHtml(row.shopify_customer_id_masked || row.shopify_customer_id_last4 || '—') +
        '（ID ' + escapeHtml(row.shopify_customer_id || '—') + '）' +
      '</small>';
    $('lb-user-drawer-slug').textContent = formatVendorSlugLabel(row.slug_handle) + ' (' + row.slug_handle + ')｜不可更改廠商';
    populateUserDrawerRoleSelect(row.slug_handle, row.role);
    $('lb-user-drawer-active').checked = !!row.is_active;
    $('lb-user-drawer-note').value = row.note || '';

    var hint = $('lb-user-drawer-hint');
    if (row.slug_handle === OFFICIAL_SCAN_SLUG) {
      show(hint);
      hint.textContent = '廠商已鎖定。LadyBaeStaff 為內部全廠商掃碼代號，請使用僅掃碼（建議）或工作人員。';
    } else if (row.slug_handle === OFFICIAL_OPS_SLUG) {
      show(hint);
      hint.textContent = '廠商已鎖定。LadyBaeOps 為內部全廠商後台代號，請使用工作人員（不可匯出）或擁有者（可匯出）。';
    } else {
      show(hint);
      hint.textContent = '廠商已鎖定，只能改角色／啟用狀態／備註。若要換成別的廠商，請停用後重新「新增權限」。';
    }

    var toggleBtn = $('lb-user-drawer-deactivate');
    if (toggleBtn) {
      if (row.is_active) {
        toggleBtn.textContent = '停用權限';
        toggleBtn.className = 'lb-admin-btn lb-admin-btn--danger';
        toggleBtn.dataset.action = 'deactivate';
      } else {
        toggleBtn.textContent = '啟用權限';
        toggleBtn.className = 'lb-admin-btn lb-admin-btn--accent';
        toggleBtn.dataset.action = 'activate';
      }
    }

    mountDrawerToBody(drawer);
    show(drawer);
    drawer.setAttribute('aria-hidden', 'false');
    setDrawerOpenState(true);
    if ($('lb-user-drawer-role')) $('lb-user-drawer-role').focus();
  }

  function closeUserEditDrawer() {
    state.userEditRow = null;
    var drawer = $('lb-user-drawer');
    if (!drawer) return;
    hide(drawer);
    drawer.setAttribute('aria-hidden', 'true');
    setDrawerOpenState(false);
  }

  async function submitUserDrawerForm(event) {
    if (event) event.preventDefault();
    var row = state.userEditRow;
    var submitBtn = $('lb-user-drawer-submit');
    clearUserDrawerActionError();

    if (!row || !row.shopify_customer_id) {
      showUserDrawerActionError('無法儲存：缺少會員編號');
      setFlash('無法儲存：缺少會員編號', true);
      return;
    }

    var noteRaw = ($('lb-user-drawer-note') && $('lb-user-drawer-note').value || '').trim();
    var body = {
      shopify_customer_id: row.shopify_customer_id,
      slug_handle: row.slug_handle,
      role: ($('lb-user-drawer-role') && $('lb-user-drawer-role').value) || row.role,
      is_active: !!($('lb-user-drawer-active') && $('lb-user-drawer-active').checked),
      // Omit empty note (null fails older Zod optional-string schemas).
      note: noteRaw || undefined,
    };

    setButtonLoading(submitBtn, true, '儲存中…');
    var result;
    try {
      result = await fetchJson(PATHS.upsert, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
    } catch (err) {
      setButtonLoading(submitBtn, false);
      var netMsg = (err && err.message) || '網路錯誤，請稍後再試';
      showUserDrawerActionError(netMsg);
      setFlash(netMsg, true);
      return;
    }
    setButtonLoading(submitBtn, false);

    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var code = result.payload && result.payload.error && result.payload.error.code;
      var msg = result.payload && result.payload.error && result.payload.error.message;
      var failMsg =
        code === 'INVALID_ROLE'
          ? (msg || '角色不符合此廠商規則')
          : ((msg || '儲存失敗') + (code ? ' (' + code + ')' : ''));
      showUserDrawerActionError(failMsg);
      setFlash(failMsg, true);
      return;
    }

    clearUserDrawerActionError();
    setFlash('已更新 ' + body.slug_handle + '（' + (ROLE_LABELS[body.role] || body.role) + '）', false);
    closeUserEditDrawer();
    if (state.selectedCustomerId) await refreshSelectedMemberPermissions();
    else await refreshList();
  }

  async function deactivateUserRecord(customerId, slug, last4Hint) {
    var id = String(customerId || '').trim();
    if (!/^\d+$/.test(id)) {
      var customerRaw = window.prompt('停用需完整會員編號或網址（列表末四碼：' + (last4Hint || '?') + '）');
      if (!customerRaw) return;
      id = parseCustomerIdFromInput(customerRaw);
      if (!/^\d+$/.test(id)) {
        setFlash('會員編號格式不正確', true);
        return;
      }
    }
    if (!window.confirm(
      '確定停用「此會員」對「' + slug + '」的廠商後台權限？\n\n' +
      '只撤銷此人存取，不刪除紀錄。\n' +
      '不會停用廠商、也不會下架或取消任何課程／活動。'
    )) return;

    var result = await fetchJson(PATHS.deactivate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ shopify_customer_id: id, slug_handle: slug }),
    });

    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var code = result.payload && result.payload.error && result.payload.error.code;
      var msg = result.payload && result.payload.error && result.payload.error.message;
      if (code === 'LAST_ADMIN_CANNOT_BE_DISABLED') {
        setFlash('無法停用：這是最後一個啟用中的管理員授權', true);
        return;
      }
      setFlash((msg || '停用失敗') + (code ? ' (' + code + ')' : ''), true);
      return;
    }

    setFlash('已停用此會員對「' + slug + '」的權限（課程／活動不受影響）', false);
    closeUserEditDrawer();
    if (state.selectedCustomerId) await refreshSelectedMemberPermissions();
    else await refreshList();
  }

  async function reactivateUserRecord(row) {
    if (!row || !row.shopify_customer_id || !row.slug_handle) {
      setFlash('無法啟用：缺少會員或廠商資料', true);
      return;
    }
    if (!window.confirm(
      '確定重新啟用「此會員」對「' + row.slug_handle + '」的廠商後台權限？\n' +
      '角色將維持：' + (ROLE_LABELS[row.role] || row.role) + '。'
    )) return;

    var result = await fetchJson(PATHS.upsert, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        shopify_customer_id: row.shopify_customer_id,
        slug_handle: row.slug_handle,
        role: row.role,
        is_active: true,
        note: row.note || null,
      }),
    });

    if (!result.response.ok || !result.payload || result.payload.ok !== true) {
      var code = result.payload && result.payload.error && result.payload.error.code;
      var msg = result.payload && result.payload.error && result.payload.error.message;
      setFlash((msg || '啟用失敗') + (code ? ' (' + code + ')' : ''), true);
      return;
    }

    setFlash('已啟用此會員對「' + row.slug_handle + '」的權限', false);
    closeUserEditDrawer();
    if (state.selectedCustomerId) await refreshSelectedMemberPermissions();
    else await refreshList();
  }

  async function deactivateRow(slug, last4Hint) {
    await deactivateUserRecord('', slug, last4Hint);
  }

  async function bootstrap() {
    if (!config.loggedIn) {
      show($('lb-admin-login'));
      var link = $('lb-admin-login-link');
      if (link && config.returnPath) {
        link.href = config.loginUrl + '?return_url=' + encodeURIComponent(config.returnPath);
      }
      return;
    }

    var loadingText = $('lb-admin-loading-text');
    if (loadingText) loadingText.textContent = '載入人員與廠商…';
    show($('lb-admin-loading'));
    var pair = await Promise.all([loadList(), loadVendors(false)]);
    var probe = pair[0];
    var vendorsResult = pair[1];
    hide($('lb-admin-loading'));

    if (probe.response.status === 403 && probe.payload && probe.payload.error && probe.payload.error.code === 'ADMIN_NOT_ALLOWED') {
      show($('lb-admin-denied'));
      return;
    }

    if (!probe.response.ok || !probe.payload || probe.payload.ok !== true) {
      var code = probe.payload && probe.payload.error && probe.payload.error.code;
      var msg = probe.payload && probe.payload.error && probe.payload.error.message;
      show($('lb-admin-denied'));
      var deniedMuted = $('lb-admin-denied').querySelector('p.lb-admin-muted');
      if (deniedMuted) deniedMuted.textContent = (msg || '無法載入') + (code ? ' (' + code + ')' : '');
      return;
    }

    show($('lb-admin-app'));
    applyAdvancedModeUI();
    switchTab('registry');
    state.pagination = probe.payload.pagination || null;
    renderTable(probe.payload.items || []);
    updatePagination();
    renderRegistryTable(state.registryVendors);
    // Global module card lives on registry tab; refreshRegistryList loads it,
    // but first paint must not leave Liquid's「載入中…」forever.
    loadGlobalModuleStates();
    loadSlotAddonPurchaseSettings();

    if (vendorsResult.response.ok && state.registryMode === 'ticket_fallback') {
      setFlash('目前使用過渡機制。', false);
    }
  }

  function bindEvents() {
    $('lb-admin-tab-registry-btn').addEventListener('click', function () { switchTab('registry'); });
    $('lb-admin-tab-permissions-btn').addEventListener('click', function () { switchTab('permissions'); });
    if ($('lb-admin-tab-listings-btn')) {
      $('lb-admin-tab-listings-btn').addEventListener('click', function () { switchTab('listings'); });
    }
    if ($('lb-admin-tab-city-backfill-btn')) {
      $('lb-admin-tab-city-backfill-btn').addEventListener('click', function () { switchTab('city-backfill'); });
    }
    if ($('lb-admin-tab-taxonomy-btn')) {
      $('lb-admin-tab-taxonomy-btn').addEventListener('click', function () { switchTab('taxonomy'); });
    }
    var cityBackfillRefresh = $('lb-admin-city-backfill-refresh');
    if (cityBackfillRefresh) {
      cityBackfillRefresh.addEventListener('click', function () { loadCityBackfill(); });
    }
    var cityBackfillSource = $('lb-admin-city-backfill-source');
    if (cityBackfillSource) {
      cityBackfillSource.addEventListener('change', function () { loadCityBackfill(); });
    }
    if ($('lb-admin-tab-fee-plans-btn')) {
      $('lb-admin-tab-fee-plans-btn').addEventListener('click', function () { switchTab('fee-plans'); });
    }
    if ($('lb-admin-tab-private-apps-btn')) {
      $('lb-admin-tab-private-apps-btn').addEventListener('click', function () { switchTab('private-apps'); });
    }
    if ($('lb-admin-tab-settlements-btn')) {
      $('lb-admin-tab-settlements-btn').addEventListener('click', function () { switchTab('settlements'); });
    }
    if ($('lb-admin-tab-slot-refunds-btn')) {
      $('lb-admin-tab-slot-refunds-btn').addEventListener('click', function () { switchTab('slot-refunds'); });
    }

    $('lb-registry-add-form').addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
    $('lb-registry-edit-form').addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
    if ($('lb-registry-add-submit')) {
      $('lb-registry-add-submit').addEventListener('click', submitRegistryAddForm);
    }
    if ($('lb-registry-edit-submit')) {
      $('lb-registry-edit-submit').addEventListener('click', submitRegistryEditForm);
    }
    $('lb-registry-show-inactive').addEventListener('change', refreshRegistryList);
    $('lb-registry-bulk-import').addEventListener('click', bulkImportRegistryFromShopify);

    $('lb-registry-drawer-close').addEventListener('click', closeEditDrawer);
    $('lb-registry-drawer-cancel').addEventListener('click', closeEditDrawer);
    $('lb-registry-drawer-backdrop').addEventListener('click', closeEditDrawer);
    $('lb-registry-edit-logo').addEventListener('input', function () {
      updateLogoPreview($('lb-registry-edit-logo-preview'), $('lb-registry-edit-logo').value);
    });
    $('lb-registry-edit-import').addEventListener('click', importRegistryFromShopify);
    if ($('lb-registry-edit-sync-legacy')) {
      $('lb-registry-edit-sync-legacy').addEventListener('click', legacySyncSlugOnlyAdvanced);
    }
    wireLegacyDomCompat();
    if ($('lb-registry-edit-logo-file')) {
    $('lb-registry-edit-logo-file').addEventListener('change', function () {
      var file = $('lb-registry-edit-logo-file').files && $('lb-registry-edit-logo-file').files[0];
      if (file) {
        var previewUrl = URL.createObjectURL(file);
        updateLogoPreview($('lb-registry-edit-logo-preview'), previewUrl, { label: '待上傳商標' });
      }
    });
    }
    if ($('lb-admin-customer-search-btn')) {
      $('lb-admin-customer-search-btn').addEventListener('click', runCustomerSearch);
    }
    if ($('lb-admin-customer-search')) {
      $('lb-admin-customer-search').addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          runCustomerSearch();
        }
      });
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (!$('lb-admin-slot-drawer').hidden) closeSlotDrawer();
        else if (feePlanEditItem != null) closeFeePlanDrawer();
        else if (state.userEditRow) closeUserEditDrawer();
        else if (state.registryEditSlug) closeEditDrawer();
      }
    });

    if ($('lb-user-drawer-close')) $('lb-user-drawer-close').addEventListener('click', closeUserEditDrawer);
    if ($('lb-user-drawer-cancel')) $('lb-user-drawer-cancel').addEventListener('click', closeUserEditDrawer);
    if ($('lb-user-drawer-backdrop')) $('lb-user-drawer-backdrop').addEventListener('click', closeUserEditDrawer);
    if ($('lb-user-drawer-form')) $('lb-user-drawer-form').addEventListener('submit', submitUserDrawerForm);
    if ($('lb-user-drawer-deactivate')) {
      $('lb-user-drawer-deactivate').addEventListener('click', function () {
        var row = state.userEditRow;
        if (!row) return;
        var action = $('lb-user-drawer-deactivate').dataset.action || 'deactivate';
        if (action === 'activate') reactivateUserRecord(row);
        else deactivateUserRecord(row.shopify_customer_id, row.slug_handle, row.shopify_customer_id_last4);
      });
    }

    $('lb-admin-form').addEventListener('submit', submitForm);
    $('lb-admin-form-reset').addEventListener('click', function () {
      // 只清新增欄位，保留已選會員與上方「此會員目前權限」
      if ($('lb-admin-note-input')) $('lb-admin-note-input').value = '';
      syncSlugInputs();
      populateFormRoleSelect(resolveSlugFromForm(), 'owner');
    });
    if ($('lb-admin-slug-select')) {
      $('lb-admin-slug-select').addEventListener('change', function () {
        populateFormRoleSelect(resolveSlugFromForm(), getSelectedRole());
      });
    }
    if ($('lb-admin-slug-manual')) {
      $('lb-admin-slug-manual').addEventListener('change', function () {
        populateFormRoleSelect(resolveSlugFromForm(), getSelectedRole());
      });
    }
    $('lb-admin-reload').addEventListener('click', function () {
      refreshRegistryList().then(function () { return loadVendors(false); }).then(refreshList);
    });
    $('lb-admin-filter-apply').addEventListener('click', function () {
      state.page = 1;
      refreshList();
    });
    $('lb-admin-prev').addEventListener('click', function () {
      if (state.page > 1) {
        state.page -= 1;
        refreshList();
      }
    });
    $('lb-admin-next').addEventListener('click', function () {
      var p = state.pagination;
      if (p && state.page < p.total_pages) {
        state.page += 1;
        refreshList();
      }
    });
  }

  // ═══════════════════════════════════════════════════════
  // Listings review tab
  // ═══════════════════════════════════════════════════════

  var adminListingsAll = [];
  var adminListingDrawerItem = null;
  var adminListingsLoadSeq = 0;
  var listingReviewKeyHandler = null;

  var LISTING_STATUS_LABELS = {
    DRAFT: '草稿', PENDING_REVIEW: '待審核', REJECTED: '已駁回',
    APPROVED: '已核准', PUBLISHED: '已上架', UNPUBLISHED: '已下架',
  };

  var LISTING_STATUS_COLORS = {
    DRAFT: '#888', PENDING_REVIEW: '#e8a317', REJECTED: '#c0392b',
    APPROVED: '#27ae60', PUBLISHED: '#2980b9', UNPUBLISHED: '#95a5a6',
  };

  var LISTING_MODE_LABELS = {
    FULL: '宣傳刊登（含金流）',
    EXPOSURE: '純上架',
    PROMO: '宣傳刊登（不含金流）',
    PRIVATE: '資格限定課／私域年約',
  };

  var COURSE_DECISION_LABELS = {
    EXPOSURE_PENDING: '未到判斷日',
    VENDOR_REVIEW: '已達判斷日／待廠商決策',
    CONFIRMED: '已確認開課',
    CANCELLED: '已取消開課',
    DISABLED: '未啟用',
  };

  function adminCourseDecisionLabel(item) {
    if (!item || item.listing_mode !== 'EXPOSURE') return '—';
    var status = String(item.course_decision_status || '').toUpperCase();
    if (status) return COURSE_DECISION_LABELS[status] || status;
    return Number(item.course_min_attendees || 0) > 0 ? '已設定待上架' : '未啟用';
  }

  var LISTING_FEE_LABELS = {
    NOT_REQUIRED: '不需收費',
    PENDING: '待付款',
    PAID: '已付款',
    WAIVED: '已豁免',
  };

  function normalizeAdminListing(item) {
    if (!item || typeof item !== 'object') return item;
    var out = Object.assign({}, item);
    out.id = Number(out.id);
    if (typeof out.variants_json === 'string') {
      try { out.variants_json = JSON.parse(out.variants_json); } catch (e) { out.variants_json = []; }
    }
    if (!Array.isArray(out.variants_json)) out.variants_json = [];
    if (typeof out.images_json === 'string') {
      try { out.images_json = JSON.parse(out.images_json); } catch (e2) { out.images_json = []; }
    }
    if (!Array.isArray(out.images_json)) out.images_json = [];
    if (typeof out.description_images_json === 'string') {
      try { out.description_images_json = JSON.parse(out.description_images_json); } catch (e3) { out.description_images_json = []; }
    }
    if (!Array.isArray(out.description_images_json)) out.description_images_json = [];
    return out;
  }

  function extractAdminListingImageSourcesFromField(item, fieldKey, maxCount) {
    var out = [];
    if (!item) return out;
    var imgs = item[fieldKey];
    if (typeof imgs === 'string') {
      try { imgs = JSON.parse(imgs); } catch (e) { imgs = []; }
    }
    if (Array.isArray(imgs)) {
      imgs.forEach(function (img) {
        var src = typeof img === 'string' ? img : (img && img.src);
        if (!src || src === '[omitted-data-url]') return;
        if (String(src).indexOf('http') === 0 || String(src).indexOf('data:image/') === 0) {
          out.push(src);
        }
      });
    }
    return out.slice(0, maxCount);
  }

  function extractAdminListingImageSources(item) {
    var out = extractAdminListingImageSourcesFromField(item, 'images_json', 5);
    if (Array.isArray(item && item.image_urls)) {
      item.image_urls.forEach(function (u) {
        if (u && u !== '[omitted-data-url]' && out.indexOf(u) === -1) out.push(u);
      });
    }
    return out.slice(0, 5);
  }

  function extractAdminListingDescImageSources(item) {
    return extractAdminListingImageSourcesFromField(item, 'description_images_json', 3);
  }

  function findAdminListingById(listingId) {
    var id = Number(listingId);
    if (!id) return null;
    return adminListingsAll.find(function (i) { return Number(i.id) === id; }) || null;
  }

  function getAdminListingsFilterState() {
    var modeEl = $('lb-admin-listings-mode-filter');
    var statusEl = $('lb-admin-listings-status-filter');
    var decisionEl = $('lb-admin-listings-decision-filter');
    return {
      mode: modeEl ? modeEl.value : '',
      status: statusEl ? statusEl.value : '',
      decision: decisionEl ? decisionEl.value : '',
    };
  }

  function getFilteredAdminListings() {
    var filters = getAdminListingsFilterState();
    return adminListingsAll.filter(function (item) {
      if (filters.status && item.status !== filters.status) return false;
      if (filters.mode && item.listing_mode !== filters.mode) return false;
      if (filters.decision && item.course_decision_status !== filters.decision) return false;
      return true;
    });
  }

  function updateAdminListingsMeta(visibleCount, opts) {
    var meta = $('lb-admin-listings-meta');
    if (!meta) return;
    if (opts && opts.loading) {
      meta.textContent = '載入中…';
      return;
    }
    var filters = getAdminListingsFilterState();
    var modeText = filters.mode ? (LISTING_MODE_LABELS[filters.mode] || filters.mode) : '全部模式';
    var statusText = filters.status ? (LISTING_STATUS_LABELS[filters.status] || filters.status) : '全部狀態';
    var total = adminListingsAll.length;
    var count = typeof visibleCount === 'number' ? visibleCount : total;
    meta.textContent = '目前顯示 ' + count + ' 筆／全部 ' + total + ' 筆（狀態：' + statusText + '，模式：' + modeText + '）';
  }

  function applyAdminListingsFilter() {
    var filtered = getFilteredAdminListings();
    renderAdminListingsTable(filtered);
    updateAdminListingsMeta(filtered.length);
  }

  async function loadAdminListings() {
    var noticeEl = $('lb-admin-listings-notice');
    if (noticeEl) hide(noticeEl);
    var seq = ++adminListingsLoadSeq;
    updateAdminListingsMeta(0, { loading: true });

    try {
      // Always load full queue; status/mode filtered on client to avoid race & stale mismatch
      var res = await fetchJson(PATHS.listings + '?limit=200');
      if (seq !== adminListingsLoadSeq) return;
      if (res.payload && res.payload.ok) {
        adminListingsAll = (res.payload.items || []).map(normalizeAdminListing);
        applyAdminListingsFilter();
      } else {
        adminListingsAll = [];
        renderAdminListingsTable([]);
        updateAdminListingsMeta(0);
        var e = extractApiError(res);
        var msg = e.code ? '[' + e.code + '] ' + e.message : (e.message || '載入失敗');
        if (noticeEl) { noticeEl.textContent = hideShopifyNoun(msg); noticeEl.className = 'lb-admin-flash lb-admin-flash--err'; show(noticeEl); }
      }
    } catch (err) {
      if (seq !== adminListingsLoadSeq) return;
      adminListingsAll = [];
      renderAdminListingsTable([]);
      updateAdminListingsMeta(0);
      if (noticeEl) { noticeEl.textContent = hideShopifyNoun(err.message || '載入失敗'); noticeEl.className = 'lb-admin-flash lb-admin-flash--err'; show(noticeEl); }
    }
  }

  /** 廣告加購子單：共用母課商品，只審版位／檔期／廣告圖。 */
  function isAdminSlotAddon(item) {
    return !!(item && item.parent_listing_id != null && item.parent_listing_id !== '');
  }

  function adminAddonWindowLabel(item) {
    var start = String(item.exposure_start_at || '').slice(0, 10);
    var end = String(item.exposure_end_at || '').slice(0, 10);
    return start && end ? (start + ' ~ ' + end) : '檔期未設定';
  }

  function listingPendingDays(item) {
    if (!item || !item.submitted_at) return 0;
    var submittedAt = new Date(item.submitted_at);
    if (isNaN(submittedAt.getTime())) return 0;
    return Math.max(0, Math.floor((Date.now() - submittedAt.getTime()) / 86400000));
  }

  function renderAdminListingsTable(items) {
    var tbody = $('lb-admin-listings-table-body');
    var cardsHost = $('lb-admin-listings-cards');
    if (!tbody) return;
    if (!items.length) {
      tbody.innerHTML = '<tr><td colspan="9" style="text-align:center;color:#888">無符合篩選的資料</td></tr>';
      if (cardsHost) cardsHost.innerHTML = '<p class="lb-admin-muted" style="text-align:center;padding:1rem 0">無符合篩選的資料</p>';
      return;
    }
    var html = '';
    var cardsHtml = '';
    items.forEach(function (item) {
      var color = LISTING_STATUS_COLORS[item.status] || '#888';
      var variants = Array.isArray(item.variants_json) ? item.variants_json : [];
      var variantSummary = variants.map(function (v) { return escapeHtml(v.name) + ' $' + v.price + '×' + v.quantity; }).join('<br>');
      var variantPlain = variants.map(function (v) { return v.name + ' $' + v.price + '×' + v.quantity; }).join('、') || '—';
      var modeChip = item.listing_mode === 'PROMO'
        ? '<span class="lb-admin-chip lb-admin-chip--promo">宣傳刊登（不含金流）</span>'
        : item.listing_mode === 'EXPOSURE'
        ? '<span class="lb-admin-chip lb-admin-chip--exposure">純上架</span>'
        : item.listing_mode === 'PRIVATE'
        ? '<span class="lb-admin-chip lb-admin-chip--private">資格限定課</span>'
        : '<span class="lb-admin-chip lb-admin-chip--full">宣傳刊登（含金流）</span>';
      if (isAdminSlotAddon(item)) {
        modeChip += '<span class="lb-admin-chip lb-admin-chip--addon">廣告加購</span>';
      }
      var statusLabel = LISTING_STATUS_LABELS[item.status] || item.status;
      var decisionLabel = adminCourseDecisionLabel(item);
      var needsDecision = item.listing_mode === 'EXPOSURE' &&
        String(item.course_decision_status || '').toUpperCase() === 'VENDOR_REVIEW';
      var decisionChip = '<span class="lb-admin-chip' +
        (needsDecision ? ' lb-admin-chip--exposure' : '') +
        '">' + escapeHtml(decisionLabel) + '</span>';
      var submitted = item.submitted_at ? new Date(item.submitted_at).toLocaleString('zh-TW') : '—';
      var canReview = item.status === 'PENDING_REVIEW';
      var actionLabel = canReview ? '審核' : '檢視';
      // Pending review already reserves the slot, so a stale queue silently blocks
      // other vendors. Surface the age instead of expiring holds automatically.
      var pendingDays = canReview ? listingPendingDays(item) : 0;
      var statusNote = '';
      if (canReview && pendingDays >= 3) {
        statusNote = '<br><small style="color:' + (pendingDays >= 7 ? '#a61b3f' : '#b26a00') +
          '">已佔位 ' + pendingDays + ' 天</small>';
      } else if (item.unpublish_request_at && !item.unpublish_request_resolved_at) {
        statusNote = '<br><small style="color:#a61b3f">廠商申請下架</small>';
      }
      html += '<tr>' +
        '<td>' + adminTrackIdsHtml(item) + '</td>' +
        '<td>' + escapeHtml(item.slug_handle) + '</td>' +
        '<td>' + escapeHtml(item.title || '') + '</td>' +
        '<td>' + modeChip + '</td>' +
        '<td style="font-size:var(--lbt-sm, 15px)">' + (variantSummary || '—') + '</td>' +
        '<td><span style="color:' + color + ';font-weight:600">' + escapeHtml(statusLabel) + '</span>' + statusNote + '</td>' +
        '<td>' + decisionChip + '</td>' +
        '<td>' + escapeHtml(submitted) + '</td>' +
        '<td><button type="button" class="lb-admin-btn lb-admin-btn--sm' + (canReview ? ' lb-admin-btn--accent' : '') + '" data-review-listing="' + item.id + '">' + actionLabel + '</button></td>' +
        '</tr>';
      cardsHtml += '<article class="lb-admin-m-card">' +
        '<div class="lb-admin-m-card__head">' +
          '<div class="lb-admin-m-card__title">' + escapeHtml(item.title || ('課程 #' + item.id)) + '</div>' +
          '<span style="color:' + color + ';font-weight:700;font-size:var(--lbt-sm, 15px)">' + escapeHtml(statusLabel) + statusNote + '</span>' +
        '</div>' +
        '<div class="lb-admin-m-card__tags">' + modeChip +
          '<span class="lb-admin-m-card__soft">' + escapeHtml(item.slug_handle) + '</span></div>' +
        '<div class="lb-admin-m-card__row"><span>編號</span><span>' + adminTrackIdsHtml(item) + '</span></div>' +
        '<div class="lb-admin-m-card__row"><span>票種</span><span>' + escapeHtml(variantPlain) + '</span></div>' +
        '<div class="lb-admin-m-card__row"><span>未達開課人數決策</span><span>' + decisionChip + '</span></div>' +
        '<div class="lb-admin-m-card__row"><span>送審</span><span>' + escapeHtml(submitted) + '</span></div>' +
        '<div class="lb-admin-m-card__actions">' +
          '<button type="button" class="lb-admin-btn lb-admin-btn--accent" data-review-listing="' + item.id + '">' + actionLabel + '</button>' +
        '</div>' +
      '</article>';
    });
    tbody.innerHTML = html;
    if (cardsHost) cardsHost.innerHTML = cardsHtml;

    function bindListingReview(root) {
      if (!root) return;
      root.querySelectorAll('[data-review-listing]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openListingReviewModal(btn.getAttribute('data-review-listing'));
        });
      });
    }
    bindListingReview(tbody);
    bindListingReview(cardsHost);
  }

  // ── Vendor unpublish requests ──────────────────────────
  var unpublishRequestItems = [];

  function setUnpublishNotice(message, isError) {
    var el = $('lb-admin-unpublish-notice');
    if (!el) return;
    if (!message) {
      hide(el);
      return;
    }
    el.textContent = hideShopifyNoun(message);
    el.className = 'lb-admin-flash' + (isError ? ' lb-admin-flash--err' : '');
    show(el);
  }

  async function loadUnpublishRequests() {
    var meta = $('lb-admin-unpublish-meta');
    if (!$('lb-admin-unpublish-table-body')) return;
    setUnpublishNotice('');
    if (meta) meta.textContent = '載入中…';
    try {
      var res = await fetchJson(PATHS.unpublishRequests);
      if (res.payload && res.payload.ok) {
        unpublishRequestItems = res.payload.items || [];
        renderUnpublishRequests(unpublishRequestItems);
        if (meta) {
          meta.textContent = unpublishRequestItems.length
            ? ('待處理 ' + unpublishRequestItems.length + ' 件')
            : '目前沒有待處理的下架申請';
        }
      } else {
        unpublishRequestItems = [];
        renderUnpublishRequests([]);
        if (meta) meta.textContent = '';
        var e = extractApiError(res);
        setUnpublishNotice(e.code ? '[' + e.code + '] ' + e.message : (e.message || '載入失敗'), true);
      }
    } catch (err) {
      unpublishRequestItems = [];
      renderUnpublishRequests([]);
      if (meta) meta.textContent = '';
      setUnpublishNotice(err.message || '載入失敗', true);
    }
  }

  function renderUnpublishRequests(items) {
    var tbody = $('lb-admin-unpublish-table-body');
    var cardsHost = $('lb-admin-unpublish-cards');
    if (!tbody) return;
    if (!items.length) {
      tbody.innerHTML = '<tr><td colspan="7" style="text-align:center;color:#888">目前沒有待處理的下架申請</td></tr>';
      if (cardsHost) cardsHost.innerHTML = '';
      return;
    }
    var html = '';
    var cardsHtml = '';
    items.forEach(function (item) {
      var tickets = Number(item.active_ticket_count || 0);
      var requested = item.unpublish_request_at
        ? new Date(item.unpublish_request_at).toLocaleString('zh-TW')
        : '—';
      var reason = escapeHtml(item.unpublish_request_reason || '—');
      var ticketCell = tickets > 0
        ? '<span style="color:#a61b3f;font-weight:700">' + tickets + ' 張</span>'
        : '0 張';
      var actions =
        '<button type="button" class="lb-admin-btn lb-admin-btn--sm lb-admin-btn--danger" data-unpublish-approve="' + item.id + '">核准下架</button>' +
        '<button type="button" class="lb-admin-btn lb-admin-btn--sm lb-admin-btn--ghost" data-unpublish-reject="' + item.id + '">駁回</button>';
      html += '<tr>' +
        '<td>' + item.id + '</td>' +
        '<td>' + escapeHtml(item.slug_handle || '') + '</td>' +
        '<td>' + escapeHtml(item.title || '') + '</td>' +
        '<td>' + ticketCell + '</td>' +
        '<td>' + escapeHtml(requested) + '</td>' +
        '<td style="font-size:var(--lbt-sm, 15px)">' + reason + '</td>' +
        '<td>' + actions + '</td>' +
        '</tr>';
      cardsHtml += '<article class="lb-admin-m-card">' +
        '<div class="lb-admin-m-card__head">' +
          '<div class="lb-admin-m-card__title">' + escapeHtml(item.title || ('#' + item.id)) + '</div>' +
          '<span style="font-weight:700;font-size:var(--lbt-sm, 15px)">' + ticketCell + '</span>' +
        '</div>' +
        '<div class="lb-admin-m-card__tags"><span class="lb-admin-m-card__soft">' + escapeHtml(item.slug_handle || '') + '</span></div>' +
        '<div class="lb-admin-m-card__row"><span>申請時間</span><span>' + escapeHtml(requested) + '</span></div>' +
        '<div class="lb-admin-m-card__row"><span>原因</span><span>' + reason + '</span></div>' +
        '<div class="lb-admin-m-card__actions">' + actions + '</div>' +
      '</article>';
    });
    tbody.innerHTML = html;
    if (cardsHost) cardsHost.innerHTML = cardsHtml;

    function bindUnpublishActions(root) {
      if (!root) return;
      root.querySelectorAll('[data-unpublish-approve]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          approveUnpublishRequest(btn.getAttribute('data-unpublish-approve'));
        });
      });
      root.querySelectorAll('[data-unpublish-reject]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          rejectUnpublishRequest(btn.getAttribute('data-unpublish-reject'));
        });
      });
    }
    bindUnpublishActions(tbody);
    bindUnpublishActions(cardsHost);
  }

  function findUnpublishRequest(listingId) {
    var id = Number(listingId);
    return unpublishRequestItems.find(function (i) { return Number(i.id) === id; }) || null;
  }

  async function approveUnpublishRequest(listingId) {
    var id = parseInt(listingId, 10);
    if (!id) return;
    var item = findUnpublishRequest(id);
    var tickets = Number((item && item.active_ticket_count) || 0);
    var confirmMsg = tickets > 0
      ? '核准下架 #' + id + ' 將作廢 ' + tickets + ' 張有效票並通知已報名學員，退款請依規則處理。確定繼續？'
      : '確定核准下架 #' + id + '？';
    if (!window.confirm(confirmMsg)) return;
    setUnpublishNotice('');
    try {
      var res = await fetchJson(PATHS.unpublishApprove, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          listing_id: id,
          ack_vendor_refund_responsibility: true,
        }),
      });
      if (res.payload && res.payload.ok) {
        var voided = Number(res.payload.voided_count || 0);
        var extra = res.payload.manual_refund_required
          ? '（此模式未自動作廢票券，請人工處理退款與通知）'
          : (voided > 0 ? '（已作廢 ' + voided + ' 張票）' : '');
        setFlash('已核准下架 #' + id + extra);
        await loadUnpublishRequests();
        await loadAdminListings();
      } else {
        var e = extractApiError(res);
        setFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || '核准失敗'), true);
      }
    } catch (err) {
      setFlash(err.message || '核准失敗', true);
    }
  }

  async function rejectUnpublishRequest(listingId) {
    var id = parseInt(listingId, 10);
    if (!id) return;
    var reason = window.prompt('駁回原因（廠商會看到）：', '');
    if (reason == null) return;
    reason = String(reason).trim();
    if (!reason) {
      setFlash('請填寫駁回原因', true);
      return;
    }
    try {
      var res = await fetchJson(PATHS.unpublishReject, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ listing_id: id, reason: reason }),
      });
      if (res.payload && res.payload.ok) {
        setFlash('已駁回下架申請 #' + id);
        await loadUnpublishRequests();
      } else {
        var e = extractApiError(res);
        setFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || '駁回失敗'), true);
      }
    } catch (err) {
      setFlash(err.message || '駁回失敗', true);
    }
  }

  function reviewInfoRow(label, valueHtml) {
    return '<div class="lb-admin-review-grid__row"><dt>' + escapeHtml(label) + '</dt><dd>' + valueHtml + '</dd></div>';
  }

  function setListingRejectMode(on) {
    var box = $('lb-admin-listing-reject-box');
    var approveBtn = $('lb-admin-listing-approve');
    var rejectBtn = $('lb-admin-listing-reject');
    var confirmBtn = $('lb-admin-listing-reject-confirm');
    var cancelBtn = $('lb-admin-listing-reject-cancel');
    if (box) box.hidden = !on;
    if (approveBtn) approveBtn.hidden = !!on;
    if (rejectBtn) rejectBtn.hidden = !!on;
    if (confirmBtn) confirmBtn.hidden = !on;
    if (cancelBtn) cancelBtn.hidden = !on;
    if (!on) {
      var reasonEl = $('lb-admin-listing-reject-reason');
      if (reasonEl) reasonEl.value = '';
    }
  }

  var listingReviewBusy = false;

  function setListingReviewBusy(busy, message) {
    listingReviewBusy = !!busy;
    var busyEl = $('lb-admin-listing-busy');
    var busyText = $('lb-admin-listing-busy-text');
    var panel = document.querySelector('#lb-admin-listing-review-modal .lb-admin-modal__panel--review');
    if (busyText) busyText.textContent = message || '處理中，請稍候…';
    if (busyEl) {
      if (busy) show(busyEl);
      else hide(busyEl);
    }
    if (panel) panel.classList.toggle('is-busy', !!busy);

    var ids = [
      'lb-admin-listing-approve',
      'lb-admin-listing-reopen',
      'lb-admin-listing-reject',
      'lb-admin-listing-reject-confirm',
      'lb-admin-listing-reject-cancel',
      'lb-admin-listing-drawer-close',
      'lb-admin-course-force-confirm',
      'lb-admin-course-force-cancel',
      'lb-admin-course-retry-notify',
      'lb-admin-course-retry-meta',
      'lb-admin-course-remirror-sheets',
      'lb-admin-course-retry-seal',
    ];
    ids.forEach(function (id) {
      var btn = $(id);
      if (!btn) return;
      if (busy) {
        if (!btn.dataset.prevDisabled) btn.dataset.prevDisabled = btn.disabled ? '1' : '0';
        btn.disabled = true;
      } else if (btn.dataset.prevDisabled != null) {
        btn.disabled = btn.dataset.prevDisabled === '1';
        delete btn.dataset.prevDisabled;
      }
    });
  }

  async function refreshListingReviewModal(listingId) {
    await loadAdminListings();
    if (listingId != null) openListingReviewModal(listingId);
  }

  function collectCourseDecisionWarnings(payload, action) {
    var warnings = [];
    if (!payload) return warnings;
    if (action === 'CANCEL' && payload.seal_warning) {
      warnings.push(String(payload.seal_warning));
    }
    if (
      action === 'CANCEL' &&
      !(
        payload.product_sealed &&
        payload.inventory_denied &&
        payload.wall_removed
      )
    ) {
      warnings.push(
        '停售未完成：DRAFT=' +
          !!payload.product_sealed +
          '／庫存DENY=' +
          !!payload.inventory_denied +
          '／系列移除=' +
          !!payload.wall_removed
      );
    }
    if (payload.sheets_mirror && payload.sheets_mirror.failed > 0) {
      warnings.push('Sheets 備份失敗 ' + payload.sheets_mirror.failed + '（DB 權威，可重推）');
    }
    if (payload.metaobject_synced === false) {
      warnings.push('Metaobject 尚未同步');
    }
    if (payload.attendee_notified && payload.attendee_notified.failed > 0) {
      warnings.push('消費者通知失敗 ' + payload.attendee_notified.failed);
    }
    return warnings;
  }

  function closeListingReviewModal() {
    if (listingReviewBusy) return;
    var modal = $('lb-admin-listing-review-modal');
    if (modal) hide(modal);
    adminListingDrawerItem = null;
    setListingRejectMode(false);
    setListingReviewBusy(false);
    document.documentElement.classList.remove('lb-admin-modal-open');
    if (!state.registryEditSlug && !state.userEditRow) {
      setDrawerOpenState(false);
    }
    if (listingReviewKeyHandler) {
      document.removeEventListener('keydown', listingReviewKeyHandler);
      listingReviewKeyHandler = null;
    }
  }

  function openListingReviewModal(listingId) {
    if (listingReviewBusy) {
      setFlash('審核操作進行中，請稍候完成後再操作', true);
      return;
    }
    var item = findAdminListingById(listingId);
    if (!item) {
      setFlash('找不到此申請（#' + listingId + '），請重新整理後再試', true);
      return;
    }
    adminListingDrawerItem = item;
    setListingRejectMode(false);

    var titleEl = $('lb-admin-listing-review-title');
    if (titleEl) titleEl.textContent = item.title || ('申請 #' + item.id);

    var detail = $('lb-admin-listing-detail');
    if (detail) {
      var variants = Array.isArray(item.variants_json) ? item.variants_json : [];
      var modeLabel = LISTING_MODE_LABELS[item.listing_mode] || item.listing_mode || '—';
      var statusLabel = LISTING_STATUS_LABELS[item.status] || item.status;
      var feeLabel = LISTING_FEE_LABELS[item.listing_fee_status] || item.listing_fee_status || '—';
      var feeNote = item.listing_mode === 'EXPOSURE' || item.listing_mode === 'PROMO'
        ? '送審前已完成方案扣次／付款；審核時無需再改上架費。'
        : item.listing_mode === 'PRIVATE'
        ? '資格限定課：須有私域年約額度（DURATION grant）；依手續費率結算，同宣傳刊登（含金流）。'
        : '宣傳刊登（含金流）模式：須先取得上架費額度（可為免費方案），依手續費率抽成結算。';
      var modeChipClass = item.listing_mode === 'PROMO'
        ? 'lb-admin-chip--promo'
        : item.listing_mode === 'EXPOSURE'
          ? 'lb-admin-chip--exposure'
          : 'lb-admin-chip--full';

      var rows = '';
      rows += reviewInfoRow('課程編號', '<strong>課程 #' + escapeHtml(String(item.id)) + '</strong>');
      rows += reviewInfoRow('廠商', escapeHtml(item.slug_handle || '—'));
      rows += reviewInfoRow('上架模式', '<span class="lb-admin-chip ' + modeChipClass + '">' + escapeHtml(modeLabel) + '</span>');
      rows += reviewInfoRow('審核狀態', '<strong style="color:' + (LISTING_STATUS_COLORS[item.status] || '#333') + '">' + escapeHtml(statusLabel) + '</strong>');
      // 加購單只審版位／檔期／廣告圖：課程內容一律沿用母課，重複列出只會讓審核者
      // 誤以為可以在這裡改課程。
      var isAddonReview = isAdminSlotAddon(item);
      if (isAddonReview) {
        rows += reviewInfoRow(
          '廣告加購',
          '<span class="lb-admin-chip lb-admin-chip--addon">廣告版位加購</span>' +
          '<div class="lb-admin-review-note">共用母課的 LadyBae 商品，核准後只進出版位系列，不會建立新商品。</div>'
        );
        rows += reviewInfoRow(
          '母課',
          '<button type="button" class="lb-admin-btn lb-admin-btn--sm lb-admin-btn--ghost" data-open-parent-listing="' +
            escapeHtml(String(item.parent_listing_id)) + '">課程 #' + escapeHtml(String(item.parent_listing_id)) +
            ' ' + escapeHtml(item.parent_title || item.title || '') + '</button>'
        );
        rows += reviewInfoRow('廣告版位', escapeHtml(item.slot_name || ('版位 #' + (item.slot_id || '—'))));
        rows += reviewInfoRow('廣告檔期', escapeHtml(adminAddonWindowLabel(item)));
        rows += reviewInfoRow('送審時間', escapeHtml(
          item.submitted_at ? new Date(item.submitted_at).toLocaleString('zh-TW') : '—'
        ));
      }
      if (!isAddonReview) {
      if (item.listing_mode === 'PROMO') {
        rows += reviewInfoRow('主題系列', escapeHtml(item.subcategory || '—'));
        var promoDefaultUrlSafe = safeHttpUrl(item.external_purchase_url);
        rows += reviewInfoRow('預設前往連結', item.external_purchase_url
          ? (promoDefaultUrlSafe
            ? '<a href="' + escapeHtml(promoDefaultUrlSafe) + '" target="_blank" rel="noopener">' + escapeHtml(item.external_purchase_url) + '</a>'
            : escapeHtml(item.external_purchase_url))
          : '—');
        var cityCta = item.city_cta_urls_json;
        if (typeof cityCta === 'string') {
          try { cityCta = JSON.parse(cityCta); } catch (eCta) { cityCta = {}; }
        }
        if (cityCta && typeof cityCta === 'object') {
          var ctaLines = Object.keys(cityCta).map(function (k) {
            return escapeHtml(k) + ' → ' + escapeHtml(String(cityCta[k] || ''));
          }).join('<br>');
          if (ctaLines) rows += reviewInfoRow('縣市專用連結', ctaLines);
        }
        rows += reviewInfoRow(
          '成效（近 30 日）',
          '<span id="lb-admin-promo-stats" data-listing-id="' + escapeHtml(String(item.id)) + '">載入中…</span>'
        );
      }
      if (item.listing_mode === 'EXPOSURE') {
        rows += reviewInfoRow(
          '未達開課人數決策',
          '<strong>' + escapeHtml(adminCourseDecisionLabel(item)) + '</strong>'
        );
        rows += reviewInfoRow(
          '最低開課人數',
          escapeHtml(String(item.course_min_attendees_snapshot ?? item.course_min_attendees ?? 0)) + ' 人'
        );
        rows += reviewInfoRow(
          '已確認收款快照',
          escapeHtml(String(item.course_confirmed_count_snapshot ?? '—')) +
            (item.course_confirmed_count_snapshot != null ? ' 人' : '')
        );
        rows += reviewInfoRow(
          '判斷截止',
          escapeHtml(
            item.course_decision_due_at
              ? new Date(item.course_decision_due_at).toLocaleString('zh-TW')
              : '—'
          )
        );
        if (item.course_decision_reason) {
          var reasonLabel = item.course_decision_reason === 'OVERDUE_PAST_START'
            ? '已過開課日（待決策／逾期）'
            : String(item.course_decision_reason);
          rows += reviewInfoRow(
            '決策原因',
            '<strong style="color:' +
              (item.course_decision_reason === 'OVERDUE_PAST_START' ? '#a63d3d' : '#333') +
              '">' +
              escapeHtml(reasonLabel) +
              '</strong>'
          );
        }
        if (item.course_decided_at) {
          rows += reviewInfoRow(
            '決策紀錄',
            escapeHtml(new Date(item.course_decided_at).toLocaleString('zh-TW')) +
              (item.course_decided_by
                ? '<div class="lb-admin-review-note">操作者：' +
                  escapeHtml(item.course_decided_by) +
                  '</div>'
                : '')
          );
        }
      }
      if (item.shopify_product_id) {
        rows += reviewInfoRow('商品編號', adminProductIdReviewHtml(item));
      } else if (item.status === 'APPROVED' || item.status === 'PUBLISHED' || item.status === 'UNPUBLISHED') {
        rows += reviewInfoRow('商品編號', adminProductIdReviewHtml(item));
      } else {
        rows += reviewInfoRow('商品編號', '<span style="color:#888">審核通過後才會建立</span>');
      }
      rows += reviewInfoRow('送審時間', escapeHtml(item.submitted_at ? new Date(item.submitted_at).toLocaleString('zh-TW') : '—'));
      rows += reviewInfoRow('課程說明', escapeHtml(item.description || '—'));
      rows += reviewInfoRow('分類', escapeHtml((item.category || '—') + ' / ' + (item.subcategory || '—')));
      var descImageSources = extractAdminListingDescImageSources(item);
      if (descImageSources.length) {
        rows += reviewInfoRow(
          '說明圖片（' + descImageSources.length + '）',
          adminReviewImageHtml(descImageSources, '說明圖')
        );
      } else {
        rows += reviewInfoRow('說明圖片', '未上傳');
      }
      } // end !isAddonReview (course content)
      var imageSources = extractAdminListingImageSources(item);
      if (imageSources.length) {
        rows += reviewInfoRow(
          (isAddonReview ? '廣告圖片（' : '商品圖片（') + imageSources.length + '）',
          adminReviewImageHtml(imageSources, isAddonReview ? '廣告圖' : '商品圖')
        );
      } else {
        rows += reviewInfoRow(
          isAddonReview ? '廣告圖片' : '商品圖片',
          isAddonReview
            ? '沿用母課圖片'
            : '<span style="color:#a63d3d;font-weight:800">尚未上傳／無圖可預覽</span>'
        );
      }
      if (!isAddonReview) {
      rows += reviewInfoRow('開課時間', escapeHtml(
        (item.start_at ? new Date(item.start_at).toLocaleString('zh-TW') : '—') +
        ' ~ ' +
        (item.end_at ? new Date(item.end_at).toLocaleString('zh-TW') : '—')
      ));
      if (item.listing_mode === 'EXPOSURE' || item.listing_mode === 'PROMO' || item.listing_mode === 'PRIVATE') {
        rows += reviewInfoRow('曝光期間', escapeHtml(
          (item.exposure_start_at ? new Date(item.exposure_start_at).toLocaleDateString('zh-TW') : '—') +
          ' ~ ' +
          (item.exposure_end_at ? new Date(item.exposure_end_at).toLocaleDateString('zh-TW') : '—')
        ));
      }
      if (item.listing_mode === 'EXPOSURE' || item.listing_mode === 'PROMO') {
        var extPurchaseUrlSafe = safeHttpUrl(item.external_purchase_url);
        rows += reviewInfoRow(item.listing_mode === 'PROMO' ? '預設前往連結' : '外部購票連結', item.external_purchase_url
          ? (extPurchaseUrlSafe
            ? '<a href="' + escapeHtml(extPurchaseUrlSafe) + '" target="_blank" rel="noopener">' + escapeHtml(item.external_purchase_url) + '</a>'
            : escapeHtml(item.external_purchase_url))
          : '—');
      }
      rows += reviewInfoRow('場地', escapeHtml(item.venue_name || '—'));
      rows += reviewInfoRow(
        '開課縣市',
        cityCheckboxGridHtml(item.city_codes || [], 'lb-admin-listing-city') +
          '<div class="lb-admin-review-note">核准前可調整；至少選 1 個。改縣市只影響篩選標記，不會自動改下方地址文字。</div>'
      );
      rows += reviewInfoRow(
        '地址（完整）',
        escapeHtml(item.address || '—') +
          '<div class="lb-admin-review-note">Portal 以「縣市前綴 + 區路號」組成，消費者看到的是此完整字串。</div>'
      );
      if (item.maps_url) {
        var mapsUrlSafe = safeHttpUrl(item.maps_url);
        rows += reviewInfoRow('地圖', mapsUrlSafe
          ? '<a href="' + escapeHtml(mapsUrlSafe) + '" target="_blank" rel="noopener">開啟地圖</a>'
          : escapeHtml(item.maps_url));
      }
      rows += reviewInfoRow('票種', variants.length
        ? '<ul class="lb-admin-review-variants">' + variants.map(function (v) {
            return '<li><strong>' + escapeHtml(v.name) + '</strong> — NT$' + escapeHtml(String(v.price)) + ' × ' + escapeHtml(String(v.quantity)) + '</li>';
          }).join('') + '</ul>'
        : '—');
      // FULL／PRIVATE 也支援未達開課人數決策；EXPOSURE 已在上方區塊顯示「最低開課人數」。
      if (item.listing_mode === 'FULL' || item.listing_mode === 'PRIVATE') {
        var fullMinAtt = Number(item.course_min_attendees_snapshot ?? item.course_min_attendees ?? 0);
        rows += reviewInfoRow(
          '最低開課人數',
          fullMinAtt > 0 ? (escapeHtml(String(fullMinAtt)) + ' 人') : '不設限'
        );
      }
      if (item.listing_mode !== 'EXPOSURE') {
        rows += reviewInfoRow('取消政策', '開課前 3 天退 90%；3 天內不退；截止 23:59');
        rows += reviewInfoRow('手續費率 snapshot', item.fee_rate_snapshot != null
          ? escapeHtml((Number(item.fee_rate_snapshot) * 100).toFixed(1) + '%')
          : '未設定');
      }
      } // end !isAddonReview (course logistics)
      var canWaiveFee =
        item.status === 'PENDING_REVIEW' &&
        (item.listing_mode === 'FULL' || item.listing_mode === 'PRIVATE') &&
        item.listing_fee_status !== 'WAIVED' &&
        item.listing_fee_status !== 'PAID';
      var waiveBtnHtml = canWaiveFee
        ? '<div style="margin-top:8px"><button type="button" id="lb-admin-listing-waive-btn" class="lb-admin-btn lb-admin-btn--ghost lb-admin-btn--sm">豁免上架費（需填原因）</button></div>'
        : '';
      rows += reviewInfoRow('上架費狀態', '<strong>' + escapeHtml(feeLabel) + '</strong><div class="lb-admin-review-note">' + escapeHtml(feeNote) + '</div>' + waiveBtnHtml);
      if (item.listing_fee_status === 'WAIVED' && (item.waived_reason || item.waived_by)) {
        rows += reviewInfoRow('豁免紀錄',
          (item.waived_reason ? escapeHtml(item.waived_reason) : '（未填原因）') +
          '<div class="lb-admin-review-note">' +
            (item.waived_by ? '操作人：' + escapeHtml(item.waived_by) : '') +
            (item.waived_at ? '　時間：' + escapeHtml(String(item.waived_at)) : '') +
          '</div>');
      }
      if (item.rejected_reason) {
        rows += reviewInfoRow('駁回原因', '<span style="color:#c0392b">' + escapeHtml(item.rejected_reason) + '</span>');
      }

      var canReview = item.status === 'PENDING_REVIEW';
      var canReopen = item.status === 'APPROVED' || item.status === 'PUBLISHED';
      var bannerText = canReview && isAddonReview
        ? '廣告版位加購：請確認版位、檔期與廣告圖。核准後共用母課商品，只在檔期內進出版位系列。'
        : canReview
        ? '請核對課程資訊後，於下方選擇「確認上架」或「駁回」。'
        : canReopen
          ? (item.shopify_product_id
            ? '此申請已上架。可按「退回待審核」刪除 LadyBae 商品草稿並重跑審核。'
            : '此申請已核准但尚未建立 LadyBae 商品。請按「退回待審核」後再重新「確認上架」。')
          : '此申請目前為唯讀檢視。';
      detail.innerHTML =
        '<div class="lb-admin-review-banner">' + bannerText + '</div>' +
        '<dl class="lb-admin-review-grid">' + rows + '</dl>';
      var waiveBtn = $('lb-admin-listing-waive-btn');
      if (waiveBtn) {
        waiveBtn.addEventListener('click', function () { waiveCurrentListingFee(); });
      }
      detail.querySelectorAll('[data-open-parent-listing]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          openListingReviewModal(btn.getAttribute('data-open-parent-listing'));
        });
      });
    }

    var canReview = item.status === 'PENDING_REVIEW';
    var canReopen = item.status === 'APPROVED' || item.status === 'PUBLISHED';
    var decisionStatus = String(item.course_decision_status || '').toUpperCase();
    var canCourseForce =
      item.listing_mode === 'EXPOSURE' &&
      item.status === 'PUBLISHED' &&
      (decisionStatus === 'VENDOR_REVIEW' || decisionStatus === 'EXPOSURE_PENDING');
    var canRetryNotify =
      item.listing_mode === 'EXPOSURE' &&
      (decisionStatus === 'VENDOR_REVIEW' || decisionStatus === 'CONFIRMED');
    var canRetryMeta =
      item.listing_mode === 'EXPOSURE' &&
      (decisionStatus === 'VENDOR_REVIEW' ||
        decisionStatus === 'CONFIRMED' ||
        decisionStatus === 'CANCELLED');
    var canRemirrorSheets =
      item.listing_mode === 'EXPOSURE' && decisionStatus === 'CANCELLED';
    var canRetrySeal =
      item.listing_mode === 'EXPOSURE' && decisionStatus === 'CANCELLED';
    var approveBtn = $('lb-admin-listing-approve');
    var rejectBtn = $('lb-admin-listing-reject');
    var reopenBtn = $('lb-admin-listing-reopen');
    var forceConfirmBtn = $('lb-admin-course-force-confirm');
    var forceCancelBtn = $('lb-admin-course-force-cancel');
    var retryNotifyBtn = $('lb-admin-course-retry-notify');
    var retryMetaBtn = $('lb-admin-course-retry-meta');
    var remirrorSheetsBtn = $('lb-admin-course-remirror-sheets');
    var retrySealBtn = $('lb-admin-course-retry-seal');
    if (approveBtn) {
      approveBtn.disabled = !canReview;
      approveBtn.hidden = !canReview;
      approveBtn.textContent = '確認上架';
    }
    if (rejectBtn) {
      rejectBtn.disabled = !canReview;
      rejectBtn.hidden = !canReview;
    }
    if (reopenBtn) {
      reopenBtn.hidden = !canReopen;
      reopenBtn.disabled = !canReopen;
    }
    if (forceConfirmBtn) {
      forceConfirmBtn.hidden = !canCourseForce;
      forceConfirmBtn.disabled = !canCourseForce;
    }
    if (forceCancelBtn) {
      forceCancelBtn.hidden = !canCourseForce;
      forceCancelBtn.disabled = !canCourseForce;
    }
    if (retryNotifyBtn) {
      retryNotifyBtn.hidden = !canRetryNotify;
      retryNotifyBtn.disabled = !canRetryNotify;
    }
    if (retryMetaBtn) {
      retryMetaBtn.hidden = !canRetryMeta;
      retryMetaBtn.disabled = !canRetryMeta;
    }
    if (remirrorSheetsBtn) {
      remirrorSheetsBtn.hidden = !canRemirrorSheets;
      remirrorSheetsBtn.disabled = !canRemirrorSheets;
    }
    if (retrySealBtn) {
      retrySealBtn.hidden = !canRetrySeal;
      retrySealBtn.disabled = !canRetrySeal;
    }

    var modal = $('lb-admin-listing-review-modal');
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    show(modal);
    document.documentElement.classList.add('lb-admin-modal-open');
    setDrawerOpenState(true);

    if (item.listing_mode === 'PROMO') {
      loadPromoStatsIntoReview(item.id);
    }

    if (listingReviewKeyHandler) document.removeEventListener('keydown', listingReviewKeyHandler);
    listingReviewKeyHandler = function (e) {
      if (e.key === 'Escape') closeListingReviewModal();
    };
    document.addEventListener('keydown', listingReviewKeyHandler);
  }

  async function loadPromoStatsIntoReview(listingId) {
    var el = $('lb-admin-promo-stats');
    if (!el) return;
    try {
      var res = await fetchJson(
        PATHS.promoStats +
          '?days=30&listing_id=' +
          encodeURIComponent(String(listingId))
      );
      if (!isSuccessfulJson(res) || !Array.isArray(res.payload.rows) || !res.payload.rows.length) {
        el.textContent = '尚無資料（牆曝光／點擊／詳情／外連）';
        return;
      }
      var row = res.payload.rows[0] || {};
      el.textContent =
        '牆曝光 ' + (row.wall_impression || 0) +
        ' · 牆點擊 ' + (row.wall_click || 0) +
        ' · 詳情 ' + (row.detail_view || 0) +
        ' · 外連 ' + (row.cta_click || 0);
    } catch (err) {
      el.textContent = '成效載入失敗';
    }
  }

  function openListingDrawer(listingId) { openListingReviewModal(listingId); }
  function closeListingDrawer() { closeListingReviewModal(); }

  async function waiveCurrentListingFee() {
    if (!adminListingDrawerItem || listingReviewBusy) return;
    if (adminListingDrawerItem.status !== 'PENDING_REVIEW') {
      setFlash('僅能於待審核狀態豁免上架費', true);
      return;
    }
    var reason = (window.prompt('請填寫「豁免上架費」的原因（將記錄操作人與時間以供稽核）：', '') || '').trim();
    if (!reason) {
      setFlash('已取消：豁免上架費必須填寫原因', true);
      return;
    }
    var waiveBtn = $('lb-admin-listing-waive-btn');
    setListingReviewBusy(true, '正在豁免上架費…');
    setButtonLoading(waiveBtn, true, '處理中…');
    try {
      var res = await fetchJson(PATHS.listingsFeeUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          listing_id: adminListingDrawerItem.id,
          fee_status: 'WAIVED',
          waived_reason: reason,
        }),
      });
      if (res.payload && res.payload.ok) {
        setFlash('已豁免上架費 #' + adminListingDrawerItem.id + '，可繼續核准上架');
        setListingReviewBusy(false);
        setButtonLoading(waiveBtn, false);
        closeListingReviewModal();
        loadAdminListings();
      } else {
        var e = extractApiError(res);
        setFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || '豁免失敗'), true);
        setListingReviewBusy(false);
        setButtonLoading(waiveBtn, false);
      }
    } catch (err) {
      setFlash(err.message || '豁免失敗', true);
      setListingReviewBusy(false);
      setButtonLoading(waiveBtn, false);
    }
  }

  async function approveCurrentListing() {
    if (!adminListingDrawerItem || listingReviewBusy) return;
    if (adminListingDrawerItem.status !== 'PENDING_REVIEW') {
      setFlash('此申請不是待審核狀態', true);
      return;
    }
    var detailRoot = $('lb-admin-listing-detail');
    var isAddonApprove = isAdminSlotAddon(adminListingDrawerItem);
    // 加購審核 UI 不顯示縣市勾選（沿用母課）；勿把空陣列送上去覆寫／擋核准
    var cityCodes = isAddonApprove
      ? (Array.isArray(adminListingDrawerItem.city_codes)
        ? adminListingDrawerItem.city_codes.filter(Boolean)
        : [])
      : collectCityCodesFrom(detailRoot, 'lb-admin-listing-city');
    if (!isAddonApprove && !cityCodes.length) {
      setFlash('請至少選擇一個開課縣市後再核准', true);
      return;
    }
    var approveBtn = $('lb-admin-listing-approve');
    setListingReviewBusy(true, isAddonApprove
      ? '正在確認廣告加購上架，請稍候…'
      : '正在確認上架並建立 LadyBae 商品，請稍候（可能需要數十秒）…');
    setButtonLoading(approveBtn, true, '建立中…');
    setFlash('正在確認上架 #' + adminListingDrawerItem.id + '，請勿關閉視窗…', false);
    try {
      var approveBody = { listing_id: adminListingDrawerItem.id };
      if (!isAddonApprove) {
        approveBody.city_codes = cityCodes;
      } else if (cityCodes.length) {
        approveBody.city_codes = cityCodes;
      }
      var res = await fetchJson(PATHS.listingsApprove, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(approveBody),
      });
      if (res.payload && res.payload.ok && res.payload.publish && res.payload.publish.ok) {
        setFlash('已確認上架 #' + adminListingDrawerItem.id + ' — LadyBae 商品已建立');
        setListingReviewBusy(false);
        setButtonLoading(approveBtn, false);
        closeListingReviewModal();
        loadAdminListings();
      } else {
        var e = extractApiError(res);
        var errMsg = (res.payload && res.payload.error && res.payload.error.message)
          ? '[' + e.code + '] ' + e.message
          : ((res.payload && res.payload.publish && res.payload.publish.error) || '核准失敗');
        setFlash(errMsg, true);
        setListingReviewBusy(false);
        setButtonLoading(approveBtn, false);
        loadAdminListings();
      }
    } catch (err) {
      setFlash(err.message || '核准失敗', true);
      setListingReviewBusy(false);
      setButtonLoading(approveBtn, false);
    }
  }

  async function reopenCurrentListing() {
    if (!adminListingDrawerItem || listingReviewBusy) return;
    if (adminListingDrawerItem.status !== 'APPROVED' && adminListingDrawerItem.status !== 'PUBLISHED') {
      setFlash('僅能退回「已核准／已上架」的申請', true);
      return;
    }
    var hasProduct = !!adminListingDrawerItem.shopify_product_id;
    var msg = hasProduct
      ? '確定將 #' + adminListingDrawerItem.id + ' 退回待審核？\n將刪除對應的 LadyBae 商品（草稿／啟用皆會刪），之後可再按「確認上架」重試。'
      : '確定將 #' + adminListingDrawerItem.id + ' 退回待審核？之後可再按「確認上架」重試。';
    if (!confirm(msg)) {
      return;
    }
    var reopenBtn = $('lb-admin-listing-reopen');
    setListingReviewBusy(true, hasProduct
      ? '正在刪除 LadyBae 商品並退回待審核，請稍候…'
      : '正在退回待審核，請稍候…');
    setButtonLoading(reopenBtn, true, '退回中…');
    setFlash('正在退回待審核 #' + adminListingDrawerItem.id + '，請勿關閉視窗…', false);
    try {
      var res = await fetchJson(PATHS.listingsReopen, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ listing_id: adminListingDrawerItem.id }),
      });
      if (res.payload && res.payload.ok) {
        var extra = res.payload.shopify_product_deleted === true
          ? '（已刪除 LadyBae 商品）'
          : (res.payload.shopify_product_deleted === false ? '（LadyBae 商品已不存在）' : '');
        setFlash('已退回待審核 #' + adminListingDrawerItem.id + extra);
        setListingReviewBusy(false);
        setButtonLoading(reopenBtn, false);
        closeListingReviewModal();
        loadAdminListings();
      } else {
        var e = extractApiError(res);
        setFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || '退回失敗'), true);
        setListingReviewBusy(false);
        setButtonLoading(reopenBtn, false);
      }
    } catch (err) {
      setFlash(err.message || '退回失敗', true);
      setListingReviewBusy(false);
      setButtonLoading(reopenBtn, false);
    }
  }

  async function rejectCurrentListing() {
    if (!adminListingDrawerItem || listingReviewBusy) return;
    var reasonEl = $('lb-admin-listing-reject-reason');
    var reason = reasonEl ? reasonEl.value.trim() : '';
    if (!reason) {
      setFlash('請填寫駁回原因', true);
      setListingRejectMode(true);
      if (reasonEl) reasonEl.focus();
      return;
    }
    var confirmBtn = $('lb-admin-listing-reject-confirm');
    setListingReviewBusy(true, '正在駁回申請，請稍候…');
    setButtonLoading(confirmBtn, true, '駁回中…');
    try {
      var res = await fetchJson(PATHS.listingsReject, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ listing_id: adminListingDrawerItem.id, reason: reason }),
      });
      if (res.payload && res.payload.ok) {
        setFlash('已駁回 #' + adminListingDrawerItem.id);
        setListingReviewBusy(false);
        setButtonLoading(confirmBtn, false);
        closeListingReviewModal();
        loadAdminListings();
      } else {
        var e = extractApiError(res);
        setFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || '駁回失敗'), true);
        setListingReviewBusy(false);
        setButtonLoading(confirmBtn, false);
      }
    } catch (err) {
      setFlash(err.message || '駁回失敗', true);
      setListingReviewBusy(false);
      setButtonLoading(confirmBtn, false);
    }
  }

  async function adminForceCourseDecision(action) {
    if (!adminListingDrawerItem || listingReviewBusy) return;
    var listingId = adminListingDrawerItem.id;
    setListingReviewBusy(true, action === 'CANCEL' ? '強制取消開課中…' : '強制確認開課中…');
    try {
      var res = await fetchJson(PATHS.courseDecisionForce, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          listing_id: listingId,
          action: action,
          note: 'admin_force',
          ack_vendor_refund_responsibility: action === 'CANCEL' ? true : undefined,
        }),
      });
      if (isSuccessfulJson(res)) {
        var warnings = collectCourseDecisionWarnings(res.payload, action);
        var msg =
          action === 'CANCEL'
            ? '已強制取消開課 #' + listingId +
              '（作廢 ' + ((res.payload && res.payload.voided_count) || 0) + ' 張）'
            : '已強制確認開課 #' + listingId;
        if (warnings.length) {
          msg += '；部分未完成：' + warnings.join('；');
          setFlash(msg, true);
          setListingReviewBusy(false);
          await refreshListingReviewModal(listingId);
          return;
        }
        setFlash(msg, false);
        setListingReviewBusy(false);
        closeListingReviewModal();
        await loadAdminListings();
      } else {
        var e = extractApiError(res);
        setFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || '操作失敗'), true);
        setListingReviewBusy(false);
      }
    } catch (err) {
      setFlash(err.message || '操作失敗', true);
      setListingReviewBusy(false);
    }
  }

  async function adminRetryCourseNotify() {
    if (!adminListingDrawerItem || listingReviewBusy) return;
    setListingReviewBusy(true, '重寄通知中…');
    try {
      var res = await fetchJson(PATHS.courseDecisionRetryNotify, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ listing_id: adminListingDrawerItem.id }),
      });
      if (isSuccessfulJson(res)) {
        setFlash(res.payload && res.payload.notified ? '已重寄廠商決策通知' : '已嘗試重寄（可能無 contact_email）');
      } else {
        var e = extractApiError(res);
        setFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || '重寄失敗'), true);
      }
    } catch (err) {
      setFlash(err.message || '重寄失敗', true);
    } finally {
      setListingReviewBusy(false);
    }
  }

  async function adminRetryCourseMeta() {
    if (!adminListingDrawerItem || listingReviewBusy) return;
    setListingReviewBusy(true, '同步 Metaobject 中…');
    try {
      var res = await fetchJson(PATHS.courseDecisionRetryMeta, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ listing_id: adminListingDrawerItem.id }),
      });
      if (isSuccessfulJson(res) && res.payload && res.payload.synced) {
        setFlash('Metaobject 已同步（' + (res.payload.status || '') + '）', false);
      } else if (isSuccessfulJson(res)) {
        setFlash('Meta 同步未完成：' + ((res.payload && res.payload.error) || 'unknown'), true);
      } else {
        var e = extractApiError(res);
        setFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || 'Meta 同步失敗'), true);
      }
    } catch (err) {
      setFlash(err.message || 'Meta 同步失敗', true);
    } finally {
      setListingReviewBusy(false);
    }
  }

  async function adminRemirrorCourseSheets() {
    if (!adminListingDrawerItem || listingReviewBusy) return;
    if (!confirm('將依 DB（權威）重推 VOID 票到 Sheets 備份。確定？')) return;
    setListingReviewBusy(true, '重推 Sheets 備份中…');
    try {
      var res = await fetchJson(PATHS.courseDecisionRemirrorSheets, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ listing_id: adminListingDrawerItem.id }),
      });
      if (isSuccessfulJson(res) && res.payload.sheets_mirror) {
        var m = res.payload.sheets_mirror;
        setFlash(
          'Sheets 備份：成功 ' + m.ok + '／失敗 ' + m.failed + '／略過 ' + m.skipped +
            '（共 ' + m.total + '）' +
            (m.failed ? ' — DB 仍為權威，可再重試' : ''),
          m.failed > 0
        );
      } else {
        var e = extractApiError(res);
        setFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || '重推失敗'), true);
      }
    } catch (err) {
      setFlash(err.message || '重推失敗', true);
    } finally {
      setListingReviewBusy(false);
    }
  }

  async function adminRetryCourseSeal() {
    if (!adminListingDrawerItem || listingReviewBusy) return;
    setListingReviewBusy(true, '重試停售（DRAFT／系列移除）…');
    try {
      var res = await fetchJson(PATHS.courseDecisionRetrySeal, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ listing_id: adminListingDrawerItem.id }),
      });
      if (isSuccessfulJson(res)) {
        var sealedComplete = Boolean(
          res.payload &&
          res.payload.product_sealed &&
          res.payload.inventory_denied &&
          res.payload.wall_removed
        );
        setFlash(
          sealedComplete
            ? '已重試停售完成：DRAFT／庫存DENY／系列移除皆成功'
            : '停售未完成：DRAFT=' +
                !!(res.payload && res.payload.product_sealed) +
                '／庫存DENY=' +
                !!(res.payload && res.payload.inventory_denied) +
                '／系列移除=' +
                !!(res.payload && res.payload.wall_removed) +
                (res.payload && res.payload.error ? ' — ' + res.payload.error : ''),
          !sealedComplete
        );
      } else {
        var e = extractApiError(res);
        setFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || '重試停售失敗'), true);
      }
    } catch (err) {
      setFlash(err.message || '重試停售失敗', true);
    } finally {
      setListingReviewBusy(false);
    }
  }

  function bindListingsEvents() {
    var refreshBtn = $('lb-admin-listings-refresh');
    if (refreshBtn) refreshBtn.addEventListener('click', function () {
      loadAdminListings();
      loadUnpublishRequests();
    });
    var unpublishRefreshBtn = $('lb-admin-unpublish-refresh');
    if (unpublishRefreshBtn) unpublishRefreshBtn.addEventListener('click', loadUnpublishRequests);

    var statusFilter = $('lb-admin-listings-status-filter');
    if (statusFilter) statusFilter.addEventListener('change', applyAdminListingsFilter);
    var modeFilter = $('lb-admin-listings-mode-filter');
    if (modeFilter) modeFilter.addEventListener('change', applyAdminListingsFilter);
    var decisionFilter = $('lb-admin-listings-decision-filter');
    if (decisionFilter) decisionFilter.addEventListener('change', function () {
      if (decisionFilter.value) {
        if (statusFilter) statusFilter.value = '';
        if (modeFilter) modeFilter.value = 'EXPOSURE';
      }
      applyAdminListingsFilter();
    });

    var approveBtn = $('lb-admin-listing-approve');
    if (approveBtn) approveBtn.addEventListener('click', function () {
      if (!adminListingDrawerItem || adminListingDrawerItem.status !== 'PENDING_REVIEW') return;
      if (confirm('確定確認上架此申請？將自動建立 LadyBae 商品與相關設定。')) approveCurrentListing();
    });

    var reopenBtn = $('lb-admin-listing-reopen');
    if (reopenBtn) reopenBtn.addEventListener('click', function () {
      reopenCurrentListing();
    });

    var rejectBtn = $('lb-admin-listing-reject');
    if (rejectBtn) rejectBtn.addEventListener('click', function () {
      setListingRejectMode(true);
      var reasonEl = $('lb-admin-listing-reject-reason');
      if (reasonEl) reasonEl.focus();
    });

    var forceConfirmBtn = $('lb-admin-course-force-confirm');
    if (forceConfirmBtn) forceConfirmBtn.addEventListener('click', function () {
      if (!adminListingDrawerItem) return;
      if (!confirm('確定強制確認開課？將標記為 CONFIRMED 並通知已確認收款消費者。')) return;
      adminForceCourseDecision('CONFIRM');
    });
    var forceCancelBtn = $('lb-admin-course-force-cancel');
    if (forceCancelBtn) forceCancelBtn.addEventListener('click', function () {
      if (!adminListingDrawerItem) return;
      if (!confirm('確定強制取消開課？將作廢票券、DRAFT 商品，且平台不退款。')) return;
      adminForceCourseDecision('CANCEL');
    });
    var retryNotifyBtn = $('lb-admin-course-retry-notify');
    if (retryNotifyBtn) retryNotifyBtn.addEventListener('click', function () {
      adminRetryCourseNotify();
    });
    var retryMetaBtn = $('lb-admin-course-retry-meta');
    if (retryMetaBtn) retryMetaBtn.addEventListener('click', function () {
      adminRetryCourseMeta();
    });
    var remirrorSheetsBtn = $('lb-admin-course-remirror-sheets');
    if (remirrorSheetsBtn) remirrorSheetsBtn.addEventListener('click', function () {
      adminRemirrorCourseSheets();
    });
    var retrySealBtn = $('lb-admin-course-retry-seal');
    if (retrySealBtn) retrySealBtn.addEventListener('click', function () {
      adminRetryCourseSeal();
    });

    var rejectConfirm = $('lb-admin-listing-reject-confirm');
    if (rejectConfirm) rejectConfirm.addEventListener('click', rejectCurrentListing);

    var rejectCancel = $('lb-admin-listing-reject-cancel');
    if (rejectCancel) rejectCancel.addEventListener('click', function () {
      setListingRejectMode(false);
    });

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-close-listing-review]')) closeListingReviewModal();
    });
  }

  // ═══════════════════════════════════════════════════════
  // Fee Plans tab
  // ═══════════════════════════════════════════════════════

  var feePlansData = [];
  var feePlanEditItem = null;

  function setFeePlansFlash(message, isError) {
    var el = $('lb-admin-fee-plans-notice');
    if (!el) return;
    if (!message) { hide(el); el.textContent = ''; el.className = 'lb-admin-flash'; return; }
    show(el);
    el.textContent = hideShopifyNoun(message);
    el.className = 'lb-admin-flash ' + (isError ? 'lb-admin-flash--err' : 'lb-admin-flash--ok');
  }

  async function loadFeePlans() {
    setFeePlansFlash('');
    try {
      var res = await fetchJson(PATHS.feePlans);
      if (res.payload && res.payload.ok) {
        feePlansData = res.payload.plans || [];
        renderFeePlansTable(feePlansData);
        populateBonusGrantSelects();
      } else {
        var e = extractApiError(res);
        var msg = e.code ? '[' + e.code + '] ' + e.message : (e.message || '載入失敗');
        setFeePlansFlash(msg, true);
      }
    } catch (err) {
      setFeePlansFlash(err.message || '載入失敗', true);
    }
  }

  function renderFeePlansTable(plans) {
    var tbody = $('lb-admin-fee-plans-table-body');
    var cardsHost = $('lb-admin-fee-plans-cards');
    if (!tbody) return;
    if (!plans || !plans.length) {
      tbody.innerHTML = '<tr><td colspan="8" style="text-align:center;color:#888">無資料</td></tr>';
      if (cardsHost) cardsHost.innerHTML = '<p class="lb-admin-muted" style="text-align:center;padding:1rem 0">無資料</p>';
      return;
    }
    var html = '';
    var cardsHtml = '';
    plans.forEach(function (plan) {
      var mode = plan.listing_mode || plan.mode;
      var type = plan.plan_type || plan.type;
      var modeBadge = mode === 'PROMO'
        ? '<span class="lb-admin-chip lb-admin-chip--promo">宣傳刊登（不含金流）</span>'
        : mode === 'EXPOSURE'
        ? '<span class="lb-admin-chip lb-admin-chip--exposure">純上架</span>'
        : mode === 'PRIVATE'
        ? '<span class="lb-admin-chip lb-admin-chip--private">資格限定課／私域年約</span>'
        : '<span class="lb-admin-chip lb-admin-chip--full">宣傳刊登（含金流）</span>';
      var typeLabel = type === 'DURATION' ? '期間制（通行證）' : '單次';
      if (type === 'SINGLE' && plan.duration_days) {
        typeLabel = '短檔 ' + plan.duration_days + ' 天';
      }
      var durationLabel = '—';
      if (type === 'DURATION') {
        if (plan.validity_days) {
          durationLabel = plan.validity_days + ' 天';
        } else if (plan.duration_months) {
          durationLabel = plan.duration_months + ' 個月';
        }
        if (plan.max_booking_interval_days) {
          durationLabel += '（單次≤' + plan.max_booking_interval_days + '天）';
        }
      }
      var priceLabel = (plan.price != null ? 'NT$' + plan.price : '—');
      if ((parseFloat(plan.price) || 0) === 0) {
        // 免費次數上限設在版位桶，不在方案；這裡只標「免費」，數字看版位管理。
        priceLabel += '（免費）';
      }
      var activeBadge = plan.is_active
        ? '<span class="lb-admin-badge lb-admin-badge--on">啟用</span>'
        : '<span class="lb-admin-badge lb-admin-badge--off">停用</span>';
      var shopifyBadge = plan.shopify_variant_id
        ? '<span style="color:#27ae60;font-size:0.85em;">已連結</span>'
        : '<span style="color:#c0392b;font-size:0.85em;">未連結</span>';
      var deactivateBtn = plan.is_active
        ? '<button type="button" class="lb-admin-btn lb-admin-btn--ghost lb-fee-plan-deactivate" data-plan-id="' + escapeHtml(plan.id) + '" style="color:#c0392b;">停用</button>'
        : '';
      html += '<tr>' +
        '<td>' + escapeHtml(plan.id) + '</td>' +
        '<td>' + escapeHtml(plan.name) + '</td>' +
        '<td>' + modeBadge + '</td>' +
        '<td>' + escapeHtml(typeLabel) + '</td>' +
        '<td>' + escapeHtml(durationLabel) + '</td>' +
        '<td>' + escapeHtml(priceLabel) + '</td>' +
        '<td>' + activeBadge + '<div>' + shopifyBadge + '</div></td>' +
        '<td>' +
          '<button type="button" class="lb-admin-btn lb-admin-btn--ghost lb-fee-plan-edit" data-plan-id="' + escapeHtml(plan.id) + '">編輯</button>' +
          deactivateBtn +
        '</td>' +
        '</tr>';

      cardsHtml += '<article class="lb-admin-m-card">' +
        '<div class="lb-admin-m-card__head">' +
          '<div class="lb-admin-m-card__title">' + escapeHtml(plan.name) + '</div>' +
          activeBadge +
        '</div>' +
        '<div class="lb-admin-m-card__tags">' + modeBadge + '<span class="lb-admin-m-card__soft">' + escapeHtml(typeLabel) + '</span></div>' +
        '<div class="lb-admin-m-card__row"><span>期間</span><strong>' + escapeHtml(durationLabel) + '</strong></div>' +
        '<div class="lb-admin-m-card__row"><span>價格</span><strong>' + escapeHtml(priceLabel) + '</strong></div>' +
        '<div class="lb-admin-m-card__row"><span>LadyBae</span>' + shopifyBadge + '</div>' +
        '<div class="lb-admin-m-card__actions">' +
          '<button type="button" class="lb-admin-btn lb-admin-btn--accent lb-fee-plan-edit" data-plan-id="' + escapeHtml(plan.id) + '">編輯</button>' +
          deactivateBtn +
        '</div>' +
      '</article>';
    });
    tbody.innerHTML = html;
    if (cardsHost) cardsHost.innerHTML = cardsHtml;

    function bindFeePlanCardActions(root) {
      if (!root) return;
      root.querySelectorAll('.lb-fee-plan-edit').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var planId = btn.getAttribute('data-plan-id');
          var plan = feePlansData.find(function (p) { return String(p.id) === String(planId); });
          if (plan) openFeePlanDrawer(plan);
        });
      });
      root.querySelectorAll('.lb-fee-plan-deactivate').forEach(function (btn) {
        btn.addEventListener('click', function () {
          deactivateFeePlanById(btn.getAttribute('data-plan-id'));
        });
      });
    }
    bindFeePlanCardActions(tbody);
    bindFeePlanCardActions(cardsHost);
  }

  function setFeePlanModeValue(mode, opts) {
    var hidden = $('lb-admin-fee-plan-mode');
    var m = String(mode || '').toUpperCase();
    var value = m === 'FULL' ? 'FULL'
      : m === 'PROMO' ? 'PROMO'
      : m === 'PRIVATE' ? 'PRIVATE'
      : 'EXPOSURE';
    if (hidden) hidden.value = value;
    document.querySelectorAll('input[name="lb-admin-fee-plan-mode-radio"]').forEach(function (radio) {
      radio.checked = radio.value === value;
    });
    // 私域年約：偏好期間制 + 365 天效期
    if (value === 'PRIVATE' && opts && opts.preferYearPlan) {
      setFeePlanTypeValue('DURATION');
      var validityEl = $('lb-admin-fee-plan-validity-days');
      if (validityEl && !String(validityEl.value || '').trim()) {
        validityEl.value = '365';
      }
    }
    toggleFeePlanDurationField();
  }

  function setFeePlanTypeValue(type) {
    var hidden = $('lb-admin-fee-plan-type');
    var value = type === 'DURATION' ? 'DURATION' : 'SINGLE';
    if (hidden) hidden.value = value;
    document.querySelectorAll('input[name="lb-admin-fee-plan-type-radio"]').forEach(function (radio) {
      radio.checked = radio.value === value;
    });
    toggleFeePlanDurationField();
  }

  /** PRIVATE year-plan: only DURATION, no slot bind; hide irrelevant controls. */
  function applyFeePlanPrivateUiConstraints() {
    var modeEl = $('lb-admin-fee-plan-mode');
    var typeEl = $('lb-admin-fee-plan-type');
    var isPrivate = !!(modeEl && modeEl.value === 'PRIVATE');
    var singleOpt = $('lb-admin-fee-plan-type-single-opt');
    var privateHint = $('lb-admin-fee-plan-type-private-hint');
    var slotWrap = $('lb-admin-fee-plan-slot-wrap');
    var singleRadio = document.querySelector(
      'input[name="lb-admin-fee-plan-type-radio"][value="SINGLE"]'
    );
    var durationRadio = document.querySelector(
      'input[name="lb-admin-fee-plan-type-radio"][value="DURATION"]'
    );

    if (singleOpt) {
      if (isPrivate) hide(singleOpt);
      else show(singleOpt);
    }
    if (singleRadio) singleRadio.disabled = isPrivate;
    if (privateHint) {
      if (isPrivate) show(privateHint);
      else hide(privateHint);
    }
    if (slotWrap) {
      if (isPrivate) {
        hide(slotWrap);
        setFeePlanSlotValue('');
      } else {
        show(slotWrap);
      }
    }
    if (isPrivate) {
      if (typeEl) typeEl.value = 'DURATION';
      if (durationRadio) durationRadio.checked = true;
      if (singleRadio) singleRadio.checked = false;
      var validityEl = $('lb-admin-fee-plan-validity-days');
      if (validityEl && !String(validityEl.value || '').trim()) {
        validityEl.value = '365';
      }
    }
  }

  function toggleFeePlanDurationField() {
    var typeEl = $('lb-admin-fee-plan-type');
    var modeEl = $('lb-admin-fee-plan-mode');
    var durationWrap = $('lb-admin-fee-plan-duration-wrap');
    var durationDaysWrap = $('lb-admin-fee-plan-duration-days-wrap');
    var validityDaysWrap = $('lb-admin-fee-plan-validity-days-wrap');
    var maxSeatsWrap = $('lb-admin-fee-plan-max-seats-wrap');
    var maxPerSlotWrap = $('lb-admin-fee-plan-max-per-slot-wrap');
    var maxIntervalWrap = $('lb-admin-fee-plan-max-interval-wrap');
    if (!typeEl) return;

    applyFeePlanPrivateUiConstraints();

    var isDuration = typeEl.value === 'DURATION';
    var isSingle = typeEl.value === 'SINGLE';
    var isPrivate = modeEl && modeEl.value === 'PRIVATE';

    // 單次：只顯示短檔天數；期間制：效期天數；曝光通行證才需要席次／排程上限
    if (durationWrap) hide(durationWrap); // 期間月數改由效期天數取代，避免填錯
    if (durationDaysWrap) isSingle && !isPrivate ? show(durationDaysWrap) : hide(durationDaysWrap);
    if (validityDaysWrap) isDuration || isPrivate ? show(validityDaysWrap) : hide(validityDaysWrap);
    if (maxSeatsWrap) isDuration && !isPrivate ? show(maxSeatsWrap) : hide(maxSeatsWrap);
    if (maxPerSlotWrap) isDuration && !isPrivate ? show(maxPerSlotWrap) : hide(maxPerSlotWrap);
    if (maxIntervalWrap) isDuration && !isPrivate ? show(maxIntervalWrap) : hide(maxIntervalWrap);
    toggleFeePlanFreeLimitField();
  }

  /**
   * 免費方案才需要看到「上限設在版位」的指路提示；付費／PRIVATE 不吃免費桶。
   * 這裡沒有輸入框——數字統一在「版位管理 → 免費贈送上限」設定。
   */
  function toggleFeePlanFreeLimitField() {
    var wrap = $('lb-admin-fee-plan-free-limit-wrap');
    if (!wrap) return;
    var modeEl = $('lb-admin-fee-plan-mode');
    var priceEl = $('lb-admin-fee-plan-price');
    var isPrivate = modeEl && modeEl.value === 'PRIVATE';
    var priceRaw = priceEl ? String(priceEl.value || '').trim() : '';
    var isFree = priceRaw !== '' && (parseFloat(priceRaw) || 0) === 0;
    isFree && !isPrivate ? show(wrap) : hide(wrap);
  }

  async function openFeePlanDrawer(plan) {
    var titleEl = $('lb-admin-fee-plan-drawer-title');
    if (plan) {
      feePlanEditItem = plan;
      if (titleEl) titleEl.textContent = '編輯上架費方案 #' + plan.id;
      $('lb-admin-fee-plan-name').value = plan.name || '';
      setFeePlanModeValue(plan.listing_mode || plan.mode || 'EXPOSURE');
      setFeePlanTypeValue(plan.plan_type || plan.type || 'SINGLE');
      $('lb-admin-fee-plan-duration').value = plan.duration_months || '';
      $('lb-admin-fee-plan-duration-days').value = plan.duration_days || '';
      $('lb-admin-fee-plan-validity-days').value = plan.validity_days || '';
      $('lb-admin-fee-plan-max-seats').value = plan.max_concurrent_seats != null ? plan.max_concurrent_seats : 1;
      $('lb-admin-fee-plan-max-per-slot').value = plan.max_per_slot_per_vendor != null ? plan.max_per_slot_per_vendor : 1;
      $('lb-admin-fee-plan-max-interval').value = plan.max_booking_interval_days || '';
      $('lb-admin-fee-plan-price').value = plan.price != null ? plan.price : '';
      $('lb-admin-fee-plan-sort').value = plan.sort_order != null ? plan.sort_order : 0;
      $('lb-admin-fee-plan-active').checked = plan.is_active !== false;
    } else {
      feePlanEditItem = null;
      if (titleEl) titleEl.textContent = '新增上架費方案';
      $('lb-admin-fee-plan-name').value = '';
      setFeePlanModeValue('EXPOSURE');
      setFeePlanTypeValue('SINGLE');
      $('lb-admin-fee-plan-duration').value = '';
      $('lb-admin-fee-plan-duration-days').value = '';
      $('lb-admin-fee-plan-validity-days').value = '';
      $('lb-admin-fee-plan-max-seats').value = '1';
      $('lb-admin-fee-plan-max-per-slot').value = '1';
      $('lb-admin-fee-plan-max-interval').value = '';
      $('lb-admin-fee-plan-price').value = '';
      $('lb-admin-fee-plan-sort').value = '0';
      $('lb-admin-fee-plan-active').checked = true;
    }
    toggleFeePlanFreeLimitField();
    var drawer = $('lb-admin-fee-plan-drawer');
    mountDrawerToBody(drawer);
    show(drawer);
    setDrawerOpenState(true);
    var desiredSlotId = feePlanEditItem ? (feePlanEditItem.slot_id || '') : '';
    setFeePlanSlotValue(desiredSlotId);
    populateSlotSelect(desiredSlotId);
    await loadSlotOptions(desiredSlotId);
    $('lb-admin-fee-plan-name').focus();
  }

  async function deactivateFeePlanById(planId) {
    var plan = feePlansData.find(function (p) { return String(p.id) === String(planId); });
    var label = plan && plan.name ? plan.name : ('#' + planId);
    if (!confirm('確定停用「' + label + '」？\n停用後廠商不可購買，LadyBae 商品會改為草稿。\n（不是硬刪除，之後可再編輯重新啟用）')) {
      return;
    }
    try {
      var res = await fetchJson(PATHS.feePlanDeactivate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: parseInt(planId, 10) }),
      });
      if (res.payload && res.payload.ok) {
        var warn = res.payload.shopifyWarning || res.payload.shopify_warning;
        setFlash(warn ? ('方案已停用（' + hideShopifyNoun(warn) + '）') : '方案已停用', false);
        loadFeePlans();
      } else {
        var e = extractApiError(res);
        setFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || '停用失敗'), true);
      }
    } catch (err) {
      setFlash(err.message || '停用失敗', true);
    }
  }

  function closeFeePlanDrawer() {
    feePlanEditItem = null;
    var drawer = $('lb-admin-fee-plan-drawer');
    hide(drawer);
    if (!state.registryEditSlug && !state.userEditRow) {
      setDrawerOpenState(false);
    }
  }

  async function saveFeePlan() {
    var name = ($('lb-admin-fee-plan-name').value || '').trim();
    var mode = $('lb-admin-fee-plan-mode').value;
    var type = $('lb-admin-fee-plan-type').value;
    var duration = ($('lb-admin-fee-plan-duration').value || '').trim();
    var durationDays = ($('lb-admin-fee-plan-duration-days').value || '').trim();
    var validityDays = ($('lb-admin-fee-plan-validity-days').value || '').trim();
    var maxSeats = ($('lb-admin-fee-plan-max-seats').value || '1').trim();
    var maxPerSlot = ($('lb-admin-fee-plan-max-per-slot').value || '1').trim();
    var maxInterval = ($('lb-admin-fee-plan-max-interval').value || '').trim();
    var price = ($('lb-admin-fee-plan-price').value || '').trim();
    var sortOrder = ($('lb-admin-fee-plan-sort').value || '0').trim();
    var isActive = $('lb-admin-fee-plan-active').checked;

    if (!name) {
      setFlash('方案名稱為必填', true);
      return;
    }
    if (price === '') {
      setFlash('價格為必填', true);
      return;
    }
    if (mode === 'PRIVATE' && type !== 'DURATION') {
      setFlash('私域年約請使用「期間制」，並建議效期天數 365', true);
      return;
    }
    if (type === 'DURATION' && !validityDays) {
      setFlash('期間制須填寫「效期天數」（例：季 90／年 365）', true);
      return;
    }
    if (type === 'DURATION' && mode !== 'PRIVATE' && !maxInterval) {
      setFlash('期間制須填寫「單次排程最長天數」（例：季 30／年 60）', true);
      return;
    }
    if (type === 'SINGLE' && !durationDays) {
      setFlash('單次短檔須填寫「短檔天數」（例：3／7／14）', true);
      return;
    }

    var body = {
      name: name,
      listing_mode: mode,
      plan_type: type,
      price: parseFloat(price),
      sort_order: parseInt(sortOrder, 10) || 0,
      is_active: isActive,
    };
    var slotRaw = ($('lb-admin-fee-plan-slot') || {}).value;
    // PRIVATE year-plan never binds a public slot wall.
    body.slot_id = mode === 'PRIVATE' ? null : (slotRaw ? parseInt(slotRaw, 10) : null);
    if (type === 'DURATION') {
      body.duration_months = null;
      body.validity_days = parseInt(validityDays, 10);
      body.max_concurrent_seats = mode === 'PRIVATE' ? 1 : (parseInt(maxSeats, 10) || 1);
      body.max_per_slot_per_vendor = mode === 'PRIVATE' ? 1 : (parseInt(maxPerSlot, 10) || 1);
      body.max_booking_interval_days = mode === 'PRIVATE'
        ? null
        : parseInt(maxInterval, 10);
      body.duration_days = null;
    } else {
      body.duration_months = null;
      body.validity_days = null;
      body.max_concurrent_seats = 1;
      body.max_per_slot_per_vendor = 1;
      body.max_booking_interval_days = null;
      body.duration_days = parseInt(durationDays, 10);
    }
    if (feePlanEditItem) {
      body.id = feePlanEditItem.id;
    }

    var saveBtn = $('lb-admin-fee-plan-save');
    setButtonLoading(saveBtn, true, '儲存中…');

    try {
      var res = await fetchJson(PATHS.feePlanSave, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      setButtonLoading(saveBtn, false);

      if (res.payload && res.payload.ok) {
        if (res.payload.shopify_warning) {
          setFeePlansFlash(hideShopifyNoun(res.payload.shopify_warning), true);
        } else {
          setFlash(feePlanEditItem ? '方案已更新（含 LadyBae 商品）' : '方案已新增（含 LadyBae 商品）', false);
        }
        closeFeePlanDrawer();
        loadFeePlans();
      } else {
        var apiErr = extractApiError(res);
        var msg = (apiErr && apiErr.message) || '儲存失敗';
        var code = (apiErr && apiErr.code) || '';
        setFlash(code ? ('[' + code + '] ' + msg) : msg, true);
      }
    } catch (err) {
      setButtonLoading(saveBtn, false);
      setFlash(err.message || '儲存失敗', true);
    }
  }

  // ── Slot Management ──

  var slotsData = [];
  var slotEditItem = null;

  function setSlotFlash(msg, type) {
    var el = $('lb-admin-slots-notice');
    if (!el) return;
    el.textContent = hideShopifyNoun(msg);
    el.className = 'lb-admin-flash' + (type === 'error' ? ' lb-admin-flash--error' : '');
    el.hidden = false;
    setTimeout(function () { el.hidden = true; }, 5000);
  }

  async function loadSlots() {
    try {
      var res = await fetchJson(PATHS.slots);
      if (res.payload && res.payload.ok) {
        slotsData = res.payload.slots || [];
        renderSlotsTable(slotsData);
      } else {
        setSlotFlash('載入失敗', 'error');
      }
    } catch (err) {
      setSlotFlash('載入失敗: ' + (err.message || err), 'error');
    }
  }

  function renderSlotsTable(slots) {
    var tbody = $('lb-admin-slots-table-body');
    var cardsHost = $('lb-admin-slots-cards');
    if (!tbody) return;
    if (!slots || slots.length === 0) {
      tbody.innerHTML = '<tr><td colspan="8" style="text-align:center;color:#888;">無資料</td></tr>';
      if (cardsHost) cardsHost.innerHTML = '<p class="lb-admin-muted" style="text-align:center;padding:1rem 0">無資料</p>';
      return;
    }
    var html = '';
    var cardsHtml = '';
    slots.forEach(function (s) {
      var capText = s.max_capacity > 0 ? String(s.max_capacity) : '不限';
      var activeBadge = s.is_active
        ? '<span class="lb-admin-badge lb-admin-badge--on">啟用</span>'
        : '<span class="lb-admin-badge lb-admin-badge--off">停用</span>';
      var editBtn = '<button type="button" class="lb-admin-btn lb-admin-btn--sm" data-slot-edit="' + s.id + '">編輯</button>';
      html += '<tr>' +
        '<td>' + s.id + '</td>' +
        '<td>' + escapeHtml(s.name) + '</td>' +
        '<td><code>' + escapeHtml(s.slug) + '</code></td>' +
        '<td>' + capText + '</td>' +
        '<td>' + escapeHtml(s.shopify_collection_title || '—') + '</td>' +
        '<td><code>' + escapeHtml(s.shopify_tag || '—') + '</code></td>' +
        '<td>' + activeBadge + '</td>' +
        '<td>' + editBtn + '</td>' +
        '</tr>';
      cardsHtml += '<article class="lb-admin-m-card">' +
        '<div class="lb-admin-m-card__head">' +
          '<div class="lb-admin-m-card__title">' + escapeHtml(s.name) + '</div>' +
          activeBadge +
        '</div>' +
        '<div class="lb-admin-m-card__row"><span>代稱</span><code>' + escapeHtml(s.slug) + '</code></div>' +
        '<div class="lb-admin-m-card__row"><span>容量</span><strong>' + escapeHtml(capText) + '</strong></div>' +
        '<div class="lb-admin-m-card__row"><span>商品系列</span><span>' + escapeHtml(s.shopify_collection_title || '—') + '</span></div>' +
        '<div class="lb-admin-m-card__row"><span>標籤</span><code>' + escapeHtml(s.shopify_tag || '—') + '</code></div>' +
        '<div class="lb-admin-m-card__actions">' + editBtn + '</div>' +
      '</article>';
    });
    tbody.innerHTML = html;
    if (cardsHost) cardsHost.innerHTML = cardsHtml;
    function bindSlotEdit(root) {
      if (!root) return;
      root.querySelectorAll('[data-slot-edit]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var slotId = this.getAttribute('data-slot-edit');
          var slot = slotsData.find(function (s) { return String(s.id) === String(slotId); });
          if (slot) openSlotDrawer(slot);
        });
      });
    }
    bindSlotEdit(tbody);
    bindSlotEdit(cardsHost);
  }

  // ── 免費贈送上限（桶 ＝ 廠商 × 版位；「不綁定」自成一桶） ──────
  var freeQuotaLimitMax = 999;

  function setFreeQuotaFlash(msg, type) {
    var el = $('lb-admin-free-quota-notice');
    if (!el) return;
    el.textContent = hideShopifyNoun(msg);
    el.className = 'lb-admin-flash' + (type === 'error' ? ' lb-admin-flash--error' : '');
    el.hidden = false;
    setTimeout(function () { el.hidden = true; }, 5000);
  }

  async function loadFreeQuotaPolicies() {
    var tbody = $('lb-admin-free-quota-table-body');
    if (!tbody) return;
    try {
      var res = await fetchJson(PATHS.freeQuotaPolicies);
      if (res.payload && res.payload.ok) {
        if (res.payload.limit_max) freeQuotaLimitMax = parseInt(res.payload.limit_max, 10) || 999;
        renderFreeQuotaPolicies(res.payload.buckets || []);
      } else {
        setFreeQuotaFlash('載入失敗', 'error');
      }
    } catch (err) {
      setFreeQuotaFlash('載入失敗: ' + (err.message || err), 'error');
    }
  }

  function freeQuotaBucketLabel(row) {
    if (row.slot_id == null) return '不綁定版位';
    return row.slot_name || ('版位 #' + row.slot_id);
  }

  function renderFreeQuotaPolicies(rows) {
    var tbody = $('lb-admin-free-quota-table-body');
    var cardsHost = $('lb-admin-free-quota-cards');
    if (!tbody) return;
    if (!rows || rows.length === 0) {
      tbody.innerHTML = '<tr><td colspan="6" style="text-align:center;color:#888;">無資料</td></tr>';
      if (cardsHost) cardsHost.innerHTML = '<p class="lb-admin-muted" style="text-align:center;padding:1rem 0">無資料</p>';
      return;
    }
    var html = '';
    var cardsHtml = '';
    rows.forEach(function (row) {
      var key = row.slot_id == null ? 'unbound' : String(row.slot_id);
      var label = escapeHtml(freeQuotaBucketLabel(row));
      var inactive = row.slot_id != null && row.slot_is_active === false;
      var labelHtml = label + (inactive ? ' <span class="lb-admin-badge lb-admin-badge--off">停用</span>' : '');
      var slugHtml = row.slot_id == null ? '—' : '<code>' + escapeHtml(row.slot_slug || '—') + '</code>';
      var planCount = row.free_plan_count || 0;
      var planCountHtml = planCount > 0
        ? String(planCount)
        : '<span class="lb-admin-muted">0（此版位目前沒有免費方案）</span>';
      var input = '<input type="number" class="lb-admin-input" style="max-width:7rem" min="0" max="' +
        freeQuotaLimitMax + '" step="1" value="' + (parseInt(row.limit, 10) || 0) +
        '" data-free-quota-input="' + key + '">';
      var saveBtn = '<button type="button" class="lb-admin-btn lb-admin-btn--sm lb-admin-btn--accent" data-free-quota-save="' + key + '">儲存</button>';
      var updated = row.updated_at
        ? escapeHtml(String(row.updated_at).slice(0, 16).replace('T', ' '))
        : '—';

      html += '<tr>' +
        '<td>' + labelHtml + '</td>' +
        '<td>' + slugHtml + '</td>' +
        '<td>' + planCountHtml + '</td>' +
        '<td>' + input + '</td>' +
        '<td>' + updated + '</td>' +
        '<td>' + saveBtn + '</td>' +
        '</tr>';

      cardsHtml += '<article class="lb-admin-m-card">' +
        '<div class="lb-admin-m-card__head">' +
          '<div class="lb-admin-m-card__title">' + labelHtml + '</div>' +
        '</div>' +
        '<div class="lb-admin-m-card__row"><span>代稱</span>' + slugHtml + '</div>' +
        '<div class="lb-admin-m-card__row"><span>已上架免費方案</span><span>' + planCountHtml + '</span></div>' +
        '<div class="lb-admin-m-card__row"><span>上限（0＝不限）</span>' + input + '</div>' +
        '<div class="lb-admin-m-card__actions">' + saveBtn + '</div>' +
      '</article>';
    });
    tbody.innerHTML = html;
    if (cardsHost) cardsHost.innerHTML = cardsHtml;
    bindFreeQuotaSave(tbody);
    bindFreeQuotaSave(cardsHost);
  }

  function bindFreeQuotaSave(root) {
    if (!root) return;
    root.querySelectorAll('[data-free-quota-save]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.getAttribute('data-free-quota-save');
        var input = root.querySelector('[data-free-quota-input="' + key + '"]');
        if (!input) return;
        saveFreeQuotaPolicy(key, input.value, this);
      });
    });
  }

  async function saveFreeQuotaPolicy(key, rawValue, btn) {
    var limit = parseInt(rawValue, 10);
    if (!isFinite(limit) || limit < 0) limit = 0;
    if (limit > freeQuotaLimitMax) limit = freeQuotaLimitMax;
    var slotId = key === 'unbound' ? null : parseInt(key, 10);
    if (slotId !== null && !isFinite(slotId)) return;

    var label = key === 'unbound' ? '不綁定版位' : ('版位 #' + slotId);
    var confirmMsg = limit > 0
      ? label + '：每家廠商累計免費 ' + limit + ' 次。\n\n此上限由該版位所有免費方案（純上架／宣傳刊登（不含金流）／宣傳刊登（含金流）、各種天數）共用。確定儲存？'
      : label + '：設為 0 ＝ 免費次數不限。確定儲存？';
    if (!window.confirm(confirmMsg)) return;

    if (btn) btn.disabled = true;
    try {
      var res = await fetchJson(PATHS.freeQuotaPolicySave, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ slot_id: slotId, free_grant_limit_per_vendor: limit }),
      });
      if (res.payload && res.payload.ok) {
        setFreeQuotaFlash('已儲存：' + label + '（' + (limit > 0 ? limit + ' 次' : '不限') + '）', 'success');
        loadFreeQuotaPolicies();
      } else {
        var e = extractApiError(res);
        setFreeQuotaFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || '儲存失敗'), 'error');
      }
    } catch (err) {
      setFreeQuotaFlash('儲存失敗: ' + (err.message || err), 'error');
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  function syncSlotTagPreview() {
    var tagEl = $('lb-admin-slot-tag');
    if (!tagEl) return;
    if (slotEditItem && slotEditItem.shopify_tag) {
      tagEl.value = slotEditItem.shopify_tag;
      return;
    }
    var slug = (($('lb-admin-slot-slug') || {}).value || '').trim();
    tagEl.value = slug ? ('slot:' + slug) : '';
  }

  function openSlotDrawer(editSlot) {
    slotEditItem = editSlot || null;
    var drawer = $('lb-admin-slot-drawer');
    if (!drawer) return;
    var titleEl = $('lb-admin-slot-drawer-title');
    if (titleEl) titleEl.textContent = editSlot ? '編輯版位 #' + editSlot.id : '新增版位';
    var nameEl = $('lb-admin-slot-name');
    var slugEl = $('lb-admin-slot-slug');
    var descEl = $('lb-admin-slot-desc');
    var capEl = $('lb-admin-slot-capacity');
    var collEl = $('lb-admin-slot-collection');
    var sortEl = $('lb-admin-slot-sort');
    var activeEl = $('lb-admin-slot-active');

    if (editSlot) {
      if (nameEl) nameEl.value = editSlot.name || '';
      if (slugEl) { slugEl.value = editSlot.slug || ''; slugEl.disabled = true; }
      if (descEl) descEl.value = editSlot.description || '';
      if (capEl) capEl.value = editSlot.max_capacity || 0;
      if (collEl) collEl.value = editSlot.shopify_collection_title || '';
      if (sortEl) sortEl.value = editSlot.sort_order || 0;
      if (activeEl) activeEl.checked = editSlot.is_active !== false;
    } else {
      if (nameEl) nameEl.value = '';
      if (slugEl) { slugEl.value = ''; slugEl.disabled = false; }
      if (descEl) descEl.value = '';
      if (capEl) capEl.value = '0';
      if (collEl) collEl.value = '';
      if (sortEl) sortEl.value = '0';
      if (activeEl) activeEl.checked = true;
    }
    syncSlotTagPreview();
    mountDrawerToBody(drawer);
    show(drawer);
    setDrawerOpenState(true);
    if (nameEl) nameEl.focus();
  }

  function closeSlotDrawer() {
    var drawer = $('lb-admin-slot-drawer');
    if (drawer) hide(drawer);
    slotEditItem = null;
    if (!state.registryEditSlug && !state.userEditRow && !feePlanEditItem) {
      setDrawerOpenState(false);
    }
  }

  async function saveSlot() {
    var name = ($('lb-admin-slot-name') || {}).value || '';
    var slug = ($('lb-admin-slot-slug') || {}).value || '';
    if (!name.trim()) { setSlotFlash('名稱必填', 'error'); return; }
    if (!slotEditItem && !slug.trim()) { setSlotFlash('代稱必填', 'error'); return; }

    // shopify_tag 由後端依 slug 自動產生（slot:{slug}），前端不送、不可改
    var payload = {
      name: name.trim(),
      slug: slug.trim(),
      description: ($('lb-admin-slot-desc') || {}).value || '',
      max_capacity: parseInt(($('lb-admin-slot-capacity') || {}).value || '0', 10) || 0,
      shopify_collection_title: ($('lb-admin-slot-collection') || {}).value || '',
      sort_order: parseInt(($('lb-admin-slot-sort') || {}).value || '0', 10) || 0,
      is_active: ($('lb-admin-slot-active') || {}).checked !== false,
    };
    if (slotEditItem) payload.id = slotEditItem.id;

    try {
      var res = await fetchJson(PATHS.slotSave, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (res.payload && res.payload.ok) {
        setSlotFlash(slotEditItem ? '已更新' : '已新增', 'success');
        closeSlotDrawer();
        loadSlots();
        loadSlotOptions();
      } else {
        var e = extractApiError(res);
        setSlotFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || '儲存失敗'), 'error');
      }
    } catch (err) {
      setSlotFlash('儲存失敗: ' + (err.message || err), 'error');
    }
  }

  function bindSlotEvents() {
    var refreshBtn = $('lb-admin-slots-refresh');
    if (refreshBtn) refreshBtn.addEventListener('click', loadSlots);
    var quotaRefreshBtn = $('lb-admin-free-quota-refresh');
    if (quotaRefreshBtn) quotaRefreshBtn.addEventListener('click', loadFreeQuotaPolicies);
    var addBtn = $('lb-admin-slot-add-btn');
    if (addBtn) addBtn.addEventListener('click', function () { openSlotDrawer(null); });
    var saveBtn = $('lb-admin-slot-save');
    if (saveBtn) saveBtn.addEventListener('click', saveSlot);
    var closeBtn = $('lb-admin-slot-drawer-close');
    if (closeBtn) closeBtn.addEventListener('click', closeSlotDrawer);
    var backdrop = $('lb-admin-slot-drawer');
    if (backdrop) {
      var bd = backdrop.querySelector('[data-close-drawer]');
      if (bd) bd.addEventListener('click', closeSlotDrawer);
    }
    var slugEl = $('lb-admin-slot-slug');
    if (slugEl) {
      slugEl.addEventListener('input', syncSlotTagPreview);
      slugEl.addEventListener('change', syncSlotTagPreview);
    }
    if ($('lb-admin-tab-slots-btn')) {
      $('lb-admin-tab-slots-btn').addEventListener('click', function () { switchTab('slots'); });
    }
  }

  function setFeePlanSlotValue(slotId) {
    var hidden = $('lb-admin-fee-plan-slot');
    if (hidden) hidden.value = slotId != null ? String(slotId) : '';
  }

  function populateSlotSelect(selectedId) {
    var list = $('lb-admin-fee-plan-slot-list');
    var hidden = $('lb-admin-fee-plan-slot');
    if (!list || !hidden) return;

    var keep = selectedId != null && selectedId !== undefined && selectedId !== ''
      ? String(selectedId)
      : '';
    if (!keep) keep = hidden.value || '';

    var html = '';
    html += '<label class="lb-admin-slot-option">' +
      '<input type="radio" name="lb-admin-fee-plan-slot-radio" value=""' + (keep === '' ? ' checked' : '') + '>' +
      '<span>不綁定</span></label>';

    var activeCount = 0;
    (slotsData || []).forEach(function (s) {
      if (s.is_active === false || s.is_active === 'false' || s.is_active === 0) return;
      activeCount += 1;
      var id = String(s.id);
      html += '<label class="lb-admin-slot-option">' +
        '<input type="radio" name="lb-admin-fee-plan-slot-radio" value="' + id + '"' + (keep === id ? ' checked' : '') + '>' +
        '<span>' + escapeHtml(s.name || '') + ' <code>(' + escapeHtml(s.slug || '') + ')</code></span></label>';
    });

    if (activeCount === 0) {
      html += '<p class="lb-admin-hint" style="margin:0.35rem 0 0;">目前沒有啟用中的版位。請先到「版位管理」新增並啟用。</p>';
    }

    list.innerHTML = html;
    setFeePlanSlotValue(keep);

    list.querySelectorAll('input[name="lb-admin-fee-plan-slot-radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (this.checked) setFeePlanSlotValue(this.value);
      });
    });
  }

  async function loadSlotOptions(selectedId) {
    try {
      var res = await fetchJson(PATHS.slots);
      if (res.payload && res.payload.ok) {
        slotsData = res.payload.slots || [];
      } else {
        console.warn('[lb-admin] loadSlotOptions bad payload', res && res.payload);
      }
      populateSlotSelect(selectedId);
    } catch (e) {
      console.warn('[lb-admin] loadSlotOptions failed', e);
      populateSlotSelect(selectedId);
    }
  }

  // ── 活動額度（手動發放；不計入免費永久桶） ──────────────────

  function populateBonusGrantSelects() {
    var vendorSel = $('lb-admin-bonus-grant-vendor');
    if (vendorSel) {
      var current = vendorSel.value;
      var vendors = state.vendors.filter(function (v) { return v.is_active !== false; });
      vendorSel.innerHTML = '<option value="">— 選擇廠商 —</option>' + vendors.map(function (v) {
        var selected = current === v.slug_handle ? ' selected' : '';
        return '<option value="' + escapeHtml(v.slug_handle) + '"' + selected + '>' +
          escapeHtml(formatVendorLabel(v)) + '</option>';
      }).join('');
    }

    var planSel = $('lb-admin-bonus-grant-plan');
    if (planSel) {
      var currentPlan = planSel.value;
      // 活動額度不走 PRIVATE（年約另有申請核准流程）
      var plans = (feePlansData || []).filter(function (p) {
        var mode = String(p.listing_mode || p.mode || '').toUpperCase();
        return p.is_active !== false && mode !== 'PRIVATE';
      });
      planSel.innerHTML = '<option value="">— 選擇方案（決定版位與模式）—</option>' + plans.map(function (p) {
        var selected = String(currentPlan) === String(p.id) ? ' selected' : '';
        var slotBit = p.slot_id ? '' : '（不綁定）';
        return '<option value="' + escapeHtml(p.id) + '"' + selected + '>' +
          escapeHtml(p.name + slotBit) + '</option>';
      }).join('');
    }
  }

  async function issueBonusGrants() {
    var slug = (($('lb-admin-bonus-grant-vendor') || {}).value || '').trim();
    var planId = (($('lb-admin-bonus-grant-plan') || {}).value || '').trim();
    var qty = (($('lb-admin-bonus-grant-qty') || {}).value || '1').trim();
    var expiresOn = (($('lb-admin-bonus-grant-expires') || {}).value || '').trim();
    var reason = (($('lb-admin-bonus-grant-reason') || {}).value || '').trim();

    if (!slug) { setFlash('請選擇廠商', true); return; }
    if (!planId) { setFlash('請選擇方案', true); return; }
    if (!reason) { setFlash('請填寫發放原因（稽核用）', true); return; }

    var count = parseInt(qty, 10) || 0;
    if (count < 1 || count > 50) { setFlash('發放筆數須為 1～50', true); return; }

    var plan = (feePlansData || []).find(function (p) { return String(p.id) === String(planId); });
    var planLabel = plan && plan.name ? plan.name : ('#' + planId);
    var isDurationPlan = plan && String(plan.plan_type || '').toUpperCase() === 'DURATION';
    // 期間制沒有到期日等於永久通行證，後端也會擋
    if (isDurationPlan && !expiresOn) {
      setFlash('期間制（通行證）必須設定到期日', true);
      return;
    }
    if (!confirm(
      '發放活動額度給「' + formatVendorSlugLabel(slug) + '」\n方案：' + planLabel +
      '\n筆數：' + (isDurationPlan ? '1（期間制固定一張通行證）' : count) +
      (expiresOn ? '\n到期日：' + expiresOn : '\n到期日：不到期') +
      '\n\n此額度不佔用該廠商的免費贈送次數。確定發放？'
    )) return;

    var btn = $('lb-admin-bonus-grant-submit');
    setButtonLoading(btn, true, '發放中…');
    try {
      var res = await fetchJson(PATHS.bonusGrantIssue, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          slug_handle: slug,
          fee_plan_id: parseInt(planId, 10),
          quantity: count,
          expires_on: expiresOn || null,
          reason: reason,
        }),
      });
      setButtonLoading(btn, false);
      if (res.payload && res.payload.ok) {
        setFlash('已發放 ' + (res.payload.issued || count) + ' 筆活動額度', false);
        var reasonEl = $('lb-admin-bonus-grant-reason');
        if (reasonEl) reasonEl.value = '';
      } else {
        var e = extractApiError(res);
        setFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || '發放失敗'), true);
      }
    } catch (err) {
      setButtonLoading(btn, false);
      setFlash(err.message || '發放失敗', true);
    }
  }

  function bindBonusGrantEvents() {
    var btn = $('lb-admin-bonus-grant-submit');
    if (btn) btn.addEventListener('click', issueBonusGrants);
  }

  function bindFeePlanEvents() {
    var refreshBtn = $('lb-admin-fee-plans-refresh');
    if (refreshBtn) refreshBtn.addEventListener('click', loadFeePlans);

    var addBtn = $('lb-admin-fee-plan-add-btn');
    if (addBtn) addBtn.addEventListener('click', function () { openFeePlanDrawer(null); });

    var saveBtn = $('lb-admin-fee-plan-save');
    if (saveBtn) saveBtn.addEventListener('click', saveFeePlan);

    var closeBtn = $('lb-admin-fee-plan-drawer-close');
    if (closeBtn) closeBtn.addEventListener('click', closeFeePlanDrawer);

    var backdrop = document.querySelector('#lb-admin-fee-plan-drawer [data-close-fee-plan-drawer]');
    if (backdrop) backdrop.addEventListener('click', closeFeePlanDrawer);

    document.querySelectorAll('input[name="lb-admin-fee-plan-mode-radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (this.checked) {
          setFeePlanModeValue(this.value, {
            preferYearPlan: this.value === 'PRIVATE' && !feePlanEditItem,
          });
        }
      });
    });
    document.querySelectorAll('input[name="lb-admin-fee-plan-type-radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (this.checked) setFeePlanTypeValue(this.value);
      });
    });
    var priceInput = $('lb-admin-fee-plan-price');
    if (priceInput) priceInput.addEventListener('input', toggleFeePlanFreeLimitField);

    bindBonusGrantEvents();
  }

  // ═══════════════════════════════════════════════════════
  // Private year-plan applications tab
  // ═══════════════════════════════════════════════════════

  var privateAppsData = [];
  var privateAppReviewBusy = false;

  function setPrivateAppsFlash(message, isError) {
    var el = $('lb-admin-private-apps-notice');
    if (!el) return;
    if (!message) { hide(el); el.textContent = ''; el.className = 'lb-admin-flash'; return; }
    show(el);
    el.textContent = hideShopifyNoun(message);
    el.className = 'lb-admin-flash ' + (isError ? 'lb-admin-flash--err' : 'lb-admin-flash--ok');
  }

  async function loadPrivateApplications() {
    setPrivateAppsFlash('');
    var tbody = $('lb-admin-private-apps-table-body');
    var cardsHost = $('lb-admin-private-apps-cards');
    if (tbody) tbody.innerHTML = '<tr><td colspan="7" style="text-align:center;color:#888">載入中…</td></tr>';
    try {
      var res = await fetchJson(PATHS.privateApplications + '?status=PENDING');
      if (res.payload && res.payload.ok) {
        privateAppsData = res.payload.items || [];
        renderPrivateApplicationsTable(privateAppsData);
      } else {
        var e = extractApiError(res);
        setPrivateAppsFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || '載入失敗'), true);
        if (tbody) tbody.innerHTML = '<tr><td colspan="7" style="text-align:center;color:#888">載入失敗</td></tr>';
        if (cardsHost) cardsHost.innerHTML = '';
      }
    } catch (err) {
      setPrivateAppsFlash(err.message || '載入失敗', true);
      if (tbody) tbody.innerHTML = '<tr><td colspan="7" style="text-align:center;color:#888">載入失敗</td></tr>';
      if (cardsHost) cardsHost.innerHTML = '';
    }
  }

  function privateAppDetailHtml(item) {
    function row(label, value) {
      return '<div class="lb-admin-m-card__row"><span>' + escapeHtml(label) +
        '</span><strong style="white-space:pre-wrap;word-break:break-word">' +
        escapeHtml(value || '—') + '</strong></div>';
    }
    return row('編號', '#' + item.id) +
      row('廠商代稱', item.slug_handle) +
      row('訂單', item.shopify_order_name || hideShopifyNoun(item.shopify_order_id) || '—') +
      row('公司行號', item.company_name) +
      row('品牌名稱', item.brand_name) +
      row('負責人姓名', item.owner_name) +
      row('聯絡人姓名', item.contact_name) +
      row('聯絡人電話', item.contact_phone) +
      row('業務內容', item.business_description) +
      row('課程形式', item.course_format) +
      row('申請時間', item.created_at ? new Date(item.created_at).toLocaleString('zh-TW') : '—') +
      row('送出時間', item.details_submitted_at ? new Date(item.details_submitted_at).toLocaleString('zh-TW') : '—') +
      row('年約到期', item.grant_expires_at ? new Date(item.grant_expires_at).toLocaleString('zh-TW') : '—');
  }

  function showPrivateAppDetail(id) {
    var item = (privateAppsData || []).find(function (x) { return String(x.id) === String(id); });
    var panel = $('lb-admin-private-app-detail');
    var body = $('lb-admin-private-app-detail-body');
    if (!item || !panel || !body) return;
    body.innerHTML = privateAppDetailHtml(item);
    panel.hidden = false;
    try { panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) { /* ignore */ }
  }

  function renderPrivateApplicationsTable(items) {
    var tbody = $('lb-admin-private-apps-table-body');
    var cardsHost = $('lb-admin-private-apps-cards');
    var detailPanel = $('lb-admin-private-app-detail');
    if (detailPanel) detailPanel.hidden = true;
    if (!tbody) return;
    if (!items || !items.length) {
      tbody.innerHTML = '<tr><td colspan="7" style="text-align:center;color:#888">目前沒有待審核申請</td></tr>';
      if (cardsHost) cardsHost.innerHTML = '<p class="lb-admin-muted" style="text-align:center;padding:1rem 0">目前沒有待審核申請</p>';
      return;
    }
    var html = '';
    var cardsHtml = '';
    items.forEach(function (item) {
      var orderLabel = item.shopify_order_name || hideShopifyNoun(item.shopify_order_id) || '—';
      var created = item.created_at ? new Date(item.created_at).toLocaleString('zh-TW') : '—';
      var brand = item.brand_name || '—';
      var contact = ((item.contact_name || '') + (item.contact_phone ? ' ' + item.contact_phone : '')).trim() || '—';
      var actions =
        '<button type="button" class="lb-admin-btn lb-private-app-detail" data-id="' + escapeHtml(item.id) + '">詳細內容</button> ' +
        '<button type="button" class="lb-admin-btn lb-admin-btn--accent lb-private-app-approve" data-id="' + escapeHtml(item.id) + '">核准</button> ' +
        '<button type="button" class="lb-admin-btn lb-admin-btn--danger lb-private-app-reject" data-id="' + escapeHtml(item.id) + '">駁回</button>';
      html += '<tr>' +
        '<td>' + escapeHtml(item.id) + '</td>' +
        '<td><code>' + escapeHtml(item.slug_handle || '—') + '</code></td>' +
        '<td>' + escapeHtml(orderLabel) + '</td>' +
        '<td>' + escapeHtml(brand) + '</td>' +
        '<td>' + escapeHtml(contact) + '</td>' +
        '<td>' + escapeHtml(created) + '</td>' +
        '<td>' + actions + '</td>' +
        '</tr>';
      cardsHtml += '<article class="lb-admin-m-card">' +
        '<div class="lb-admin-m-card__head">' +
          '<div class="lb-admin-m-card__title"><code>' + escapeHtml(item.slug_handle || '—') + '</code></div>' +
          '<span class="lb-admin-m-card__soft">#' + escapeHtml(item.id) + '</span>' +
        '</div>' +
        '<div class="lb-admin-m-card__row"><span>訂單</span><strong>' + escapeHtml(orderLabel) + '</strong></div>' +
        '<div class="lb-admin-m-card__row"><span>品牌</span><strong>' + escapeHtml(brand) + '</strong></div>' +
        '<div class="lb-admin-m-card__row"><span>聯絡人</span><strong>' + escapeHtml(contact) + '</strong></div>' +
        '<div class="lb-admin-m-card__row"><span>申請時間</span><strong>' + escapeHtml(created) + '</strong></div>' +
        '<div class="lb-admin-m-card__actions">' + actions + '</div>' +
      '</article>';
    });
    tbody.innerHTML = html;
    if (cardsHost) cardsHost.innerHTML = cardsHtml;

    function bindPrivateAppActions(root) {
      if (!root) return;
      root.querySelectorAll('.lb-private-app-detail').forEach(function (btn) {
        btn.addEventListener('click', function () {
          showPrivateAppDetail(btn.getAttribute('data-id'));
        });
      });
      root.querySelectorAll('.lb-private-app-approve').forEach(function (btn) {
        btn.addEventListener('click', function () {
          reviewPrivateApplication(btn.getAttribute('data-id'), 'approve', btn);
        });
      });
      root.querySelectorAll('.lb-private-app-reject').forEach(function (btn) {
        btn.addEventListener('click', function () {
          reviewPrivateApplication(btn.getAttribute('data-id'), 'reject', btn);
        });
      });
    }
    bindPrivateAppActions(tbody);
    bindPrivateAppActions(cardsHost);
    var detailClose = $('lb-admin-private-app-detail-close');
    if (detailClose && !detailClose._lbBound) {
      detailClose._lbBound = true;
      detailClose.addEventListener('click', function () {
        if (detailPanel) detailPanel.hidden = true;
      });
    }
  }

  async function reviewPrivateApplication(id, action, btn) {
    if (privateAppReviewBusy) return;
    var appId = parseInt(id, 10);
    if (!appId) return;
    var isApprove = action === 'approve';
    var notePrompt = isApprove
      ? '核准備註（選填，可留空直接確定）：'
      : '駁回原因（必填，會顯示給廠商）：';
    var note = window.prompt(notePrompt, '');
    if (note === null) return; // cancelled
    note = String(note || '').trim();
    if (!isApprove && !note) {
      setPrivateAppsFlash('駁回時必須填寫原因', true);
      return;
    }
    if (!confirm(isApprove
      ? '確定核准此私域年約申請？核准後將開通年約通行證。'
      : '確定駁回此私域年約申請？廠商可依同訂單修改後重新送審（無需再付款）。')) {
      return;
    }
    var url = isApprove ? PATHS.privateApplicationApprove : PATHS.privateApplicationReject;
    var body = { id: appId };
    if (note) body.review_note = note;
    privateAppReviewBusy = true;
    // Disable BOTH approve/reject buttons for this row (table + card renders) to prevent double-submit.
    var rowButtons = document.querySelectorAll(
      '.lb-private-app-approve[data-id="' + id + '"], .lb-private-app-reject[data-id="' + id + '"]'
    );
    rowButtons.forEach(function (b) { if (b !== btn) b.disabled = true; });
    setButtonLoading(btn, true, isApprove ? '核准中…' : '駁回中…');
    try {
      var res = await fetchJson(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      setButtonLoading(btn, false);
      if (res.payload && res.payload.ok) {
        setPrivateAppsFlash(isApprove ? '已核准，年約通行證已開通' : '已駁回申請', false);
        await loadPrivateApplications();
      } else {
        var e = extractApiError(res);
        setPrivateAppsFlash(e.code ? '[' + e.code + '] ' + e.message : (e.message || (isApprove ? '核准失敗' : '駁回失敗')), true);
      }
    } catch (err) {
      setButtonLoading(btn, false);
      setPrivateAppsFlash(err.message || (isApprove ? '核准失敗' : '駁回失敗'), true);
    } finally {
      privateAppReviewBusy = false;
      rowButtons.forEach(function (b) { if (b !== btn) b.disabled = false; });
    }
  }

  function bindPrivateAppsEvents() {
    var refreshBtn = $('lb-admin-private-apps-refresh');
    if (refreshBtn) refreshBtn.addEventListener('click', loadPrivateApplications);
  }

  function renderTaxonomyCheckboxGrid(containerId, items, name) {
    var el = $(containerId);
    if (!el) return;
    if (!items || !items.length) {
      el.innerHTML = '<p class="lb-admin-muted">目前沒有項目</p>';
      return;
    }
    var html = '';
    items.forEach(function (item, idx) {
      var value = item && item.value != null ? String(item.value) : '';
      if (!value) return;
      var id = name + '-' + idx;
      var checked = item.allowed ? ' checked' : '';
      html +=
        '<label class="lb-admin-taxonomy-item" for="' + id + '">' +
        '<input type="checkbox" id="' + id + '" name="' + name + '" value="' + escapeHtml(value) + '"' + checked + '>' +
        '<span>' + escapeHtml(value) + '</span>' +
        '</label>';
    });
    el.innerHTML = html || '<p class="lb-admin-muted">目前沒有項目</p>';
  }

  var ADMIN_COLLECTION_GROUP_ORDER = ['mode', 'class', 'age', 'fee', 'cat', 'other'];
  var ADMIN_COLLECTION_GROUP_LABELS = {
    mode: '授課方式',
    class: '班別',
    age: '年齡區間',
    fee: '費用',
    cat: '主題分類',
    other: '其他系列',
  };
  var ADMIN_CITY_SERIES_LABELS = {
    '臺北市': 1, '台北市': 1, '新北市': 1, '桃園市': 1,
    '臺中市': 1, '台中市': 1, '臺南市': 1, '台南市': 1, '高雄市': 1,
    '基隆市': 1, '新竹市': 1, '新竹縣': 1, '苗栗縣': 1, '彰化縣': 1,
    '南投縣': 1, '雲林縣': 1, '嘉義市': 1, '嘉義縣': 1, '屏東縣': 1,
    '宜蘭縣': 1, '花蓮縣': 1, '臺東縣': 1, '台東縣': 1, '澎湖縣': 1,
    '金門縣': 1, '連江縣': 1,
  };

  function isAdminCitySeriesTitle(title) {
    return !!ADMIN_CITY_SERIES_LABELS[String(title || '').trim()];
  }

  function classifyAdminCollectionGroup(item) {
    if (item && item.group && ADMIN_COLLECTION_GROUP_LABELS[item.group]) {
      return item.group;
    }
    var h = String((item && item.handle) || '').trim().toLowerCase();
    if (h.indexOf('mode-') === 0) return 'mode';
    if (h.indexOf('class-') === 0) return 'class';
    if (h.indexOf('age-') === 0 || h.indexOf('aged-') === 0) return 'age';
    if (h.indexOf('fee-') === 0) return 'fee';
    if (h.indexOf('cat-') === 0) return 'cat';
    return 'other';
  }

  function renderTaxonomyCollectionsGrouped(containerId, items, name) {
    var el = $(containerId);
    if (!el) return;
    var list = Array.isArray(items) ? items : [];
    var buckets = {};
    ADMIN_COLLECTION_GROUP_ORDER.forEach(function (k) { buckets[k] = []; });
    list.forEach(function (item) {
      var value = item && item.value != null ? String(item.value) : '';
      if (!value || isAdminCitySeriesTitle(value)) return;
      var handle = String((item && item.handle) || '').trim().toLowerCase();
      if (handle.indexOf('city-') === 0) return;
      var group = classifyAdminCollectionGroup(item);
      buckets[group].push(item);
    });

    var html = '';
    var idx = 0;
    ADMIN_COLLECTION_GROUP_ORDER.forEach(function (key) {
      var groupItems = buckets[key] || [];
      if (!groupItems.length) return;
      groupItems.sort(function (a, b) {
        return String(a.value || '').localeCompare(String(b.value || ''), 'zh-Hant');
      });
      html += '<div class="lb-admin-taxonomy-group" data-group="' + key + '">';
      html += '<div class="lb-admin-taxonomy-group__head">';
      html += '<strong>' + escapeHtml(ADMIN_COLLECTION_GROUP_LABELS[key] || key) + '</strong>';
      html += '<div class="lb-admin-taxonomy-actions">';
      html += '<button type="button" class="lb-admin-btn lb-admin-btn--sm" data-taxonomy-group-check="' + key + '" data-check="all">全選</button>';
      html += '<button type="button" class="lb-admin-btn lb-admin-btn--sm" data-taxonomy-group-check="' + key + '" data-check="none">全不選</button>';
      html += '</div></div>';
      html += '<div class="lb-admin-taxonomy-group__grid">';
      groupItems.forEach(function (item) {
        var value = String(item.value);
        var id = name + '-' + idx++;
        var checked = item.allowed ? ' checked' : '';
        html +=
          '<label class="lb-admin-taxonomy-item" for="' + id + '">' +
          '<input type="checkbox" id="' + id + '" name="' + name + '" value="' + escapeHtml(value) + '"' + checked + '>' +
          '<span>' + escapeHtml(value) + '</span>' +
          '</label>';
      });
      html += '</div></div>';
    });
    if (!html) {
      el.innerHTML = '<p class="lb-admin-muted">目前沒有可選商品系列（縣市系列已排除，請用上架頁「開課縣市」）</p>';
      return;
    }
    el.classList.add('lb-admin-taxonomy-grid--grouped');
    el.innerHTML = html;
    el.querySelectorAll('[data-taxonomy-group-check]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var groupKey = btn.getAttribute('data-taxonomy-group-check');
        var mode = btn.getAttribute('data-check');
        var section = el.querySelector('.lb-admin-taxonomy-group[data-group="' + groupKey + '"]');
        if (!section) return;
        section.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
          input.checked = mode === 'all';
        });
      });
    });
  }

  function collectCheckedValues(containerId) {
    var el = $(containerId);
    if (!el) return [];
    return Array.prototype.map.call(el.querySelectorAll('input[type="checkbox"]:checked'), function (input) {
      return input.value;
    });
  }

  function setTaxonomyCheckAll(kind, checked) {
    var containerId = kind === 'collections'
      ? 'lb-admin-taxonomy-collections'
      : 'lb-admin-taxonomy-types';
    var el = $(containerId);
    if (!el) return;
    el.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.checked = !!checked;
    });
  }

  async function loadTaxonomySettings() {
    var statusEl = $('lb-admin-taxonomy-status');
    var noticeEl = $('lb-admin-taxonomy-notice');
    if (noticeEl) hide(noticeEl);
    if (statusEl) statusEl.textContent = '載入 LadyBae 分類／系列中…';

    try {
      var res = await fetchJson(PATHS.listingTaxonomySettings);
      if (!res.payload || res.payload.ok !== true) {
        var e = extractApiError(res);
        var msg = e.code ? '[' + e.code + '] ' + e.message : (e.message || '載入失敗');
        if (statusEl) statusEl.textContent = hideShopifyNoun(msg);
        if (noticeEl) { noticeEl.textContent = hideShopifyNoun(msg); noticeEl.className = 'lb-admin-flash lb-admin-flash--err'; show(noticeEl); }
        return;
      }

      var data = res.payload;
      renderTaxonomyCheckboxGrid('lb-admin-taxonomy-types', data.product_types || [], 'taxonomy-type');
      renderTaxonomyCollectionsGrouped('lb-admin-taxonomy-collections', data.collections || [], 'taxonomy-collection');

      var typeCount = (data.product_types || []).length;
      var colCount = (data.collections || []).length;
      var allowedTypes = (data.product_types || []).filter(function (i) { return i.allowed; }).length;
      var allowedCols = (data.collections || []).filter(function (i) { return i.allowed; }).length;

      if (statusEl) {
        statusEl.textContent = data.configured
          ? ('已設定白名單：類型勾選 ' + allowedTypes + '/' + typeCount + '，系列勾選 ' + allowedCols + '/' + colCount + '（已排除縣市系列）')
          : ('尚未儲存白名單（廠商後台仍顯示全部）。LadyBae 目前類型 ' + typeCount + '、系列 ' + colCount + '（已排除縣市系列）');
      }
      if (data.warning && noticeEl) {
        noticeEl.textContent = hideShopifyNoun(data.warning);
        noticeEl.className = 'lb-admin-flash lb-admin-flash--ok';
        show(noticeEl);
      }
    } catch (err) {
      if (statusEl) statusEl.textContent = hideShopifyNoun(err.message || '載入失敗');
      if (noticeEl) { noticeEl.textContent = hideShopifyNoun(err.message || '載入失敗'); noticeEl.className = 'lb-admin-flash lb-admin-flash--err'; show(noticeEl); }
    }
  }

  async function saveTaxonomySettings() {
    var noticeEl = $('lb-admin-taxonomy-notice');
    var productTypes = collectCheckedValues('lb-admin-taxonomy-types');
    var collections = collectCheckedValues('lb-admin-taxonomy-collections').filter(function (t) {
      return t && !isAdminCitySeriesTitle(t);
    });

    if (!confirm('確定儲存白名單？儲存後廠商後台課程上架將只顯示已勾選的分類與商品系列。')) {
      return;
    }

    try {
      var res = await fetchJson(PATHS.listingTaxonomySettings, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          product_types: productTypes,
          collections: collections,
        }),
      });
      if (!res.payload || res.payload.ok !== true) {
        var e = extractApiError(res);
        var msg = e.code ? '[' + e.code + '] ' + e.message : (e.message || '儲存失敗');
        setFlash(msg, true);
        if (noticeEl) { noticeEl.textContent = hideShopifyNoun(msg); noticeEl.className = 'lb-admin-flash lb-admin-flash--err'; show(noticeEl); }
        return;
      }
      setFlash('白名單已儲存。廠商後台將只顯示已勾選項目。', false);
      await loadTaxonomySettings();
    } catch (err) {
      setFlash(err.message || '儲存失敗', true);
    }
  }

  function bindTaxonomyEvents() {
    var reloadBtn = $('lb-admin-taxonomy-reload');
    if (reloadBtn) reloadBtn.addEventListener('click', loadTaxonomySettings);
    var saveBtn = $('lb-admin-taxonomy-save');
    if (saveBtn) saveBtn.addEventListener('click', saveTaxonomySettings);
    document.querySelectorAll('[data-taxonomy-check]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var kind = btn.getAttribute('data-taxonomy-check');
        var mode = btn.getAttribute('data-check');
        setTaxonomyCheckAll(kind, mode === 'all');
      });
    });
  }

  var settlementState = { items: [], selectedBatchId: null, markPaidSlug: null };

  function setSettlementNotice(message, isError) {
    var el = $('lb-admin-settlements-notice');
    if (!el) return;
    if (!message) { hide(el); return; }
    show(el);
    el.textContent = hideShopifyNoun(message);
    el.className = 'lb-admin-flash ' + (isError ? 'lb-admin-flash--err' : 'lb-admin-flash--ok');
  }

  function formatSettlementMoney(n) {
    var num = Number(n || 0);
    return 'NT$' + Math.round(num).toLocaleString('en-US');
  }

  /** Display dates in Chinese: 2099年1月28日 (never "Wed Jan 28"). */
  function formatSettlementDateZh(raw) {
    if (raw == null || raw === '') return '—';
    var s = String(raw).trim();
    var iso = s.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (!iso) {
      var d = new Date(s);
      if (!isNaN(d.getTime())) {
        return d.getUTCFullYear() + '年' + (d.getUTCMonth() + 1) + '月' + d.getUTCDate() + '日';
      }
      return s;
    }
    return Number(iso[1]) + '年' + Number(iso[2]) + '月' + Number(iso[3]) + '日';
  }

  function formatSettlementPeriodZh(start, end) {
    return formatSettlementDateZh(start) + ' ～ ' + formatSettlementDateZh(end);
  }

  function settlementBatchDisplayStatus(item) {
    var s = String((item && item.status) || '').toUpperCase();
    var paid = Number((item && item.paid_vendor_count) || 0);
    var pending = Number((item && item.pending_vendor_count) || 0);
    if (s === 'READY' && paid > 0 && pending > 0) return 'PARTIAL';
    return s || '—';
  }

  function settlementStatusLabel(status) {
    var s = String(status || '').toUpperCase();
    if (s === 'READY') return '待匯款';
    if (s === 'PARTIAL') return '部分已匯';
    if (s === 'PAID') return '已匯款';
    if (s === 'DRAFT') return '草稿';
    if (s === 'CANCELLED' || s === 'CANCELED') return '已取消';
    if (s === 'PENDING') return '待匯款';
    return status || '—';
  }

  function settlementStatusClass(status) {
    var s = String(status || '').toUpperCase();
    if (s === 'READY' || s === 'PARTIAL') return 'lb-admin-settlement-status lb-admin-settlement-status--ready';
    if (s === 'PAID') return 'lb-admin-settlement-status lb-admin-settlement-status--paid';
    return 'lb-admin-settlement-status';
  }

  function settlementAnomalyLabel(reason) {
    var r = String(reason || '');
    if (r === 'missing_event_end_at') return '缺活動結束日';
    if (r === 'listing_mode_not_full' || r === 'listing_mode_not_settlement') {
      return '非結算模式（需 FULL／PRIVATE）';
    }
    if (r === 'missing_fee_rate') return '缺手續費率';
    if (r === 'missing_bank_account') return '缺銀行帳號';
    if (r === 'missing_contact_email') return '缺聯絡 Email';
    if (r === 'refund_present_manual_review') return '有部分退款需複核';
    if (r === 'fully_refunded_excluded') return '全額退款已排除';
    if (r === 'refund_status_missing_amount') return '狀態顯示退款但金額未寫入';
    if (r.indexOf('already_in_batch:') === 0) return '已在其他批次';
    return r;
  }

  async function loadSettlements() {
    setSettlementNotice('');
    try {
      var res = await fetchJson(PATHS.settlements);
      if (!res.payload || res.payload.ok !== true) {
        var e = extractApiError(res);
        setSettlementNotice(e.code ? '[' + e.code + '] ' + e.message : (e.message || '載入結算批次失敗'), true);
        return;
      }
      settlementState.items = res.payload.items || [];
      renderSettlementsTable();
    } catch (err) {
      setSettlementNotice(err.message || '載入結算批次失敗', true);
    }
  }

  function renderSettlementsTable() {
    var tbody = $('lb-admin-settlements-table-body');
    var cards = $('lb-admin-settlements-cards');
    if (!tbody) return;
    if (!settlementState.items.length) {
      tbody.innerHTML = '<tr><td colspan="7">尚無結算批次。請選擇撥款日後預覽並建立。</td></tr>';
      if (cards) cards.innerHTML = '<p class="lb-admin-hint">尚無結算批次</p>';
      return;
    }
    tbody.innerHTML = settlementState.items.map(function (item) {
      var st = settlementBatchDisplayStatus(item);
      var vendorLabel = item.vendor_count != null
        ? String(item.vendor_count) +
          (item.paid_vendor_count != null
            ? '（已匯 ' + item.paid_vendor_count + '）'
            : '')
        : '—';
      return '<tr>' +
        '<td><code>' + escapeHtml(item.batch_key) + '</code></td>' +
        '<td>' + escapeHtml(formatSettlementPeriodZh(item.period_start, item.period_end)) + '</td>' +
        '<td>' + escapeHtml(formatSettlementDateZh(item.payout_date)) + '</td>' +
        '<td><span class="' + settlementStatusClass(st) + '">' + escapeHtml(settlementStatusLabel(st)) + '</span></td>' +
        '<td>' + escapeHtml(vendorLabel) + '</td>' +
        '<td>' + formatSettlementMoney(item.total_vendor_payout) + '</td>' +
        '<td><button type="button" class="lb-admin-btn lb-admin-btn--sm" data-settlement-open="' + escapeHtml(item.id) + '">明細</button></td>' +
        '</tr>';
    }).join('');
    if (cards) {
      cards.innerHTML = settlementState.items.map(function (item) {
        var st = settlementBatchDisplayStatus(item);
        return '<article class="lb-admin-m-card">' +
          '<strong>' + escapeHtml(item.batch_key) + '</strong>' +
          '<div>' + escapeHtml(formatSettlementPeriodZh(item.period_start, item.period_end)) + '</div>' +
          '<div><span class="' + settlementStatusClass(st) + '">' + escapeHtml(settlementStatusLabel(st)) + '</span> · ' +
            formatSettlementMoney(item.total_vendor_payout) + '</div>' +
          '<button type="button" class="lb-admin-btn lb-admin-btn--sm" data-settlement-open="' + escapeHtml(item.id) + '">明細</button>' +
          '</article>';
      }).join('');
    }
    document.querySelectorAll('[data-settlement-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openSettlementDetail(btn.getAttribute('data-settlement-open'));
      });
    });
  }

  function settlementPayoutYmd(y, m, day) {
    return y + '-' + String(m).padStart(2, '0') + '-' + String(day).padStart(2, '0');
  }

  /** Next valid payout date (13 or 28) on/after today in Taipei. */
  function nearestSettlementPayoutParts() {
    var today = settlementTodayYmd().split('-').map(Number);
    var y = today[0];
    var m = today[1];
    var d = today[2];
    if (d <= 13) return { y: y, m: m, day: 13 };
    if (d <= 28) return { y: y, m: m, day: 28 };
    m += 1;
    if (m > 12) { m = 1; y += 1; }
    return { y: y, m: m, day: 13 };
  }

  function syncSettlementPayoutPick() {
    var hidden = $('lb-admin-settlement-payout-date');
    var monthSel = $('lb-admin-settlement-payout-month');
    var pick = $('lb-admin-settlement-payout-pick');
    if (!hidden || !monthSel || !pick) return '';
    var ym = String(monthSel.value || '').split('-').map(Number);
    if (ym.length !== 2 || !ym[0] || !ym[1]) {
      hidden.value = '';
      return '';
    }
    var dayBtn = pick.querySelector('.lb-admin-payout-pick__day.is-selected');
    var day = dayBtn ? Number(dayBtn.getAttribute('data-payout-day')) : 0;
    if (day !== 13 && day !== 28) {
      hidden.value = '';
      return '';
    }
    hidden.value = settlementPayoutYmd(ym[0], ym[1], day);
    return hidden.value;
  }

  function bindSettlementPayoutPick() {
    var pick = $('lb-admin-settlement-payout-pick');
    var monthSel = $('lb-admin-settlement-payout-month');
    var hidden = $('lb-admin-settlement-payout-date');
    if (!pick || !monthSel || !hidden || pick.__lbPayoutBound) return;
    pick.__lbPayoutBound = true;

    var nearest = nearestSettlementPayoutParts();
    var startY = nearest.y;
    var startM = nearest.m - 8;
    while (startM < 1) { startM += 12; startY -= 1; }
    var opts = '';
    var y = startY;
    var m = startM;
    var i;
    for (i = 0; i < 18; i += 1) {
      var val = y + '-' + String(m).padStart(2, '0');
      var label = y + ' 年 ' + m + ' 月';
      var selected = (y === nearest.y && m === nearest.m) ? ' selected' : '';
      opts += '<option value="' + val + '"' + selected + '>' + label + '</option>';
      m += 1;
      if (m > 12) { m = 1; y += 1; }
    }
    monthSel.innerHTML = opts;

    function selectPayoutDay(btn) {
      pick.querySelectorAll('.lb-admin-payout-pick__day').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      syncSettlementPayoutPick();
    }
    pick.querySelectorAll('.lb-admin-payout-pick__day').forEach(function (btn) {
      var isSel = Number(btn.getAttribute('data-payout-day')) === nearest.day;
      btn.classList.toggle('is-selected', isSel);
      btn.setAttribute('aria-pressed', isSel ? 'true' : 'false');
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        selectPayoutDay(btn);
      });
      btn.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          selectPayoutDay(btn);
        }
      });
    });
    monthSel.addEventListener('change', syncSettlementPayoutPick);
    syncSettlementPayoutPick();
  }

  async function previewSettlement() {
    var payoutDate = syncSettlementPayoutPick() ||
      (($('lb-admin-settlement-payout-date') && $('lb-admin-settlement-payout-date').value) || '');
    if (!payoutDate) {
      setSettlementNotice('請先選擇撥款月份，並點選 13 日或 28 日', true);
      return;
    }
    setSettlementNotice('預覽中…', false);
    try {
      var res = await fetchJson(PATHS.settlementsPreview, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ payout_date: payoutDate }),
      });
      if (!res.payload || res.payload.ok !== true) {
        var e = extractApiError(res);
        setSettlementNotice(e.code ? '[' + e.code + '] ' + e.message : (e.message || '預覽失敗'), true);
        return;
      }
      var p = res.payload;
      var host = $('lb-admin-settlement-preview');
      if (host) {
        show(host);
        var vendorsHtml = (p.vendor_preview || []).map(function (v) {
          return '<li><strong>' + escapeHtml(v.slug_handle) + '</strong> · 票 ' + v.ticket_count +
            ' · 應付 ' + formatSettlementMoney(v.vendor_payout) +
            ' · 平台費 ' + formatSettlementMoney(v.platform_fee) +
            ' · 實退 ' + formatSettlementMoney(v.refund_amount) +
            ' · 折扣成本 ' + formatSettlementMoney(v.platform_discount_cost) +
            (v.missing_bank ? ' · <span style="color:#b45309;">缺銀行帳號</span>' : '') +
            '</li>';
        }).join('');
        var anomalies = p.anomalies || [];
        var anomalyHtml = anomalies.slice(0, 40).map(function (a) {
          return '<li><code>' + escapeHtml(a.ticket_uid) + '</code> · ' +
            escapeHtml(a.slug_handle) + ' · ' + escapeHtml(settlementAnomalyLabel(a.reason)) +
            (a.event_id ? ' · event ' + escapeHtml(a.event_id) : '') +
            '</li>';
        }).join('');
        if (anomalies.length > 40) {
          anomalyHtml += '<li>…其餘 ' + (anomalies.length - 40) + ' 筆略</li>';
        }
        host.innerHTML =
          '<h4 style="margin:0 0 0.5rem;">預覽 ' + escapeHtml(p.period.batch_key) + '</h4>' +
          '<p style="margin:0 0 0.5rem;">期間 ' + escapeHtml(formatSettlementPeriodZh(p.period.period_start, p.period.period_end)) +
          '｜可納入 ' + escapeHtml(p.eligible_count) + ' 張｜異常 ' + escapeHtml(p.anomaly_count) + ' 筆</p>' +
          '<p style="margin:0 0 0.35rem;"><strong>廠商彙總</strong></p>' +
          '<ul style="margin:0 0 0.75rem;padding-left:1.2rem;">' + (vendorsHtml || '<li>無可結算廠商</li>') + '</ul>' +
          '<p style="margin:0 0 0.35rem;"><strong>異常／需人工處理</strong></p>' +
          '<ul style="margin:0;padding-left:1.2rem;max-height:220px;overflow:auto;">' +
            (anomalyHtml || '<li>無</li>') + '</ul>';
      }
      setSettlementNotice('預覽完成', false);
    } catch (err) {
      setSettlementNotice(err.message || '預覽失敗', true);
    }
  }

  async function createSettlement() {
    var payoutDate = syncSettlementPayoutPick() ||
      (($('lb-admin-settlement-payout-date') && $('lb-admin-settlement-payout-date').value) || '');
    if (!payoutDate) {
      setSettlementNotice('請先選擇撥款月份，並點選 13 日或 28 日', true);
      return;
    }
    if (!window.confirm('確定建立撥款日 ' + formatSettlementDateZh(payoutDate) + ' 的結算批次？建立後票券會綁定批次並進入 READY。')) return;
    setSettlementNotice('建立中…', false);
    try {
      var body = { payout_date: payoutDate };
      var res = await fetchJson(PATHS.settlementsCreate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      var errCode = res.payload && res.payload.error && res.payload.error.code;
      var errMsg = (res.payload && res.payload.error && res.payload.error.message) || '建立失敗';
      if ((!res.payload || res.payload.ok !== true) && errCode === 'REFUND_REVIEW_REQUIRED') {
        if (!window.confirm(errMsg + '\n\n已人工複核部分退款金額無誤？確定仍要納入並建立批次？')) {
          setSettlementNotice('已取消建立（尚有部分退款待複核）', true);
          return;
        }
        body.force_include_refunds = true;
        res = await fetchJson(PATHS.settlementsCreate, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        errMsg = (res.payload && res.payload.error && res.payload.error.message) || '建立失敗';
      }
      if (!res.payload || res.payload.ok !== true) {
        setSettlementNotice(errCode ? '[' + errCode + '] ' + errMsg : errMsg, true);
        return;
      }
      setSettlementNotice(
        '已建立批次 ' + res.payload.batch.batch_key +
          '（廠商 ' + res.payload.vendor_count + '／票 ' + res.payload.ticket_count + '）',
        false
      );
      await loadSettlements();
      openSettlementDetail(res.payload.batch.id);
    } catch (err) {
      setSettlementNotice(err.message || '建立失敗', true);
    }
  }

  /** Taipei calendar day as YYYY-MM-DD — avoid native date picker (footer / table overflow clips it). */
  function settlementTodayYmd() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Taipei',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(new Date());
    } catch (e) {
      var d = new Date();
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return y + '-' + m + '-' + day;
    }
  }

  function normalizeSettlementPaidDate(raw) {
    var s = String(raw || '').trim().replace(/\//g, '-');
    if (!s) return '';
    if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return null;
    var parts = s.split('-');
    var y = Number(parts[0]);
    var m = Number(parts[1]);
    var d = Number(parts[2]);
    if (m < 1 || m > 12 || d < 1 || d > 31) return null;
    var dt = new Date(Date.UTC(y, m - 1, d));
    if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== m - 1 || dt.getUTCDate() !== d) return null;
    return s;
  }

  function daysInSettlementMonth(y, m1) {
    return new Date(y, m1, 0).getDate();
  }

  function settlementPaidDateParts(raw) {
    var v = normalizeSettlementPaidDate(raw) || settlementTodayYmd();
    var p = v.split('-').map(Number);
    return { y: p[0], m: p[1], d: p[2], ymd: v };
  }

  function settlementYearOptionsHtml(selectedY) {
    var cy = Number(settlementTodayYmd().slice(0, 4));
    var html = '';
    var yi;
    for (yi = cy - 3; yi <= cy + 2; yi += 1) {
      html += '<option value="' + yi + '"' + (yi === selectedY ? ' selected' : '') + '>' + yi + ' 年</option>';
    }
    return html;
  }

  function settlementMonthOptionsHtml(selectedM) {
    var html = '';
    var mi;
    for (mi = 1; mi <= 12; mi += 1) {
      html += '<option value="' + mi + '"' + (mi === selectedM ? ' selected' : '') + '>' + mi + ' 月</option>';
    }
    return html;
  }

  function settlementDayOptionsHtml(y, m, selectedD) {
    var max = daysInSettlementMonth(y, m);
    var d = Math.min(Math.max(1, selectedD || 1), max);
    var html = '';
    var di;
    for (di = 1; di <= max; di += 1) {
      html += '<option value="' + di + '"' + (di === d ? ' selected' : '') + '>' + di + ' 日</option>';
    }
    return html;
  }

  function syncSettlementDateSelect(wrap) {
    if (!wrap) return '';
    var hidden = wrap.querySelector('[data-settlement-paid-date]');
    var ySel = wrap.querySelector('[data-date-part="y"]');
    var mSel = wrap.querySelector('[data-date-part="m"]');
    var dSel = wrap.querySelector('[data-date-part="d"]');
    if (!hidden || !ySel || !mSel || !dSel) return '';
    var y = Number(ySel.value);
    var m = Number(mSel.value);
    var d = Number(dSel.value);
    var max = daysInSettlementMonth(y, m);
    if (d > max) d = max;
    var curMax = dSel.options.length;
    if (curMax !== max || Number(dSel.options[dSel.options.length - 1].value) !== max) {
      dSel.innerHTML = settlementDayOptionsHtml(y, m, d);
    } else {
      dSel.value = String(d);
    }
    var ymd = y + '-' + String(m).padStart(2, '0') + '-' + String(d).padStart(2, '0');
    hidden.value = ymd;
    return ymd;
  }

  function fillSettlementPaidDateDefaults(root, force) {
    if (!root) return;
    var today = settlementTodayYmd();
    root.querySelectorAll('.lb-admin-dateselect').forEach(function (wrap) {
      var hidden = wrap.querySelector('[data-settlement-paid-date]');
      if (!hidden) return;
      if (force || !normalizeSettlementPaidDate(hidden.value)) {
        var parts = settlementPaidDateParts(today);
        var ySel = wrap.querySelector('[data-date-part="y"]');
        var mSel = wrap.querySelector('[data-date-part="m"]');
        var dSel = wrap.querySelector('[data-date-part="d"]');
        if (ySel) ySel.value = String(parts.y);
        if (mSel) mSel.value = String(parts.m);
        if (dSel) dSel.innerHTML = settlementDayOptionsHtml(parts.y, parts.m, parts.d);
        hidden.value = parts.ymd;
      } else {
        syncSettlementDateSelect(wrap);
      }
    });
  }

  function bindSettlementDatePickers(root) {
    if (!root) return;
    var batchHost = root.querySelector
      ? root.querySelector('#lb-admin-settlement-paid-date-host')
      : null;
    if (batchHost && !batchHost.querySelector('[data-settlement-paid-date]')) {
      batchHost.innerHTML = settlementPaidDateFieldHtml(
        settlementTodayYmd(),
        'lb-admin-settlement-paid-date'
      );
    }
    root.querySelectorAll('.lb-admin-dateselect').forEach(function (wrap) {
      if (wrap.__lbDateSelectBound) return;
      wrap.__lbDateSelectBound = true;
      ['y', 'm', 'd'].forEach(function (part) {
        var sel = wrap.querySelector('[data-date-part="' + part + '"]');
        if (!sel) return;
        sel.addEventListener('change', function () {
          syncSettlementDateSelect(wrap);
        });
      });
      syncSettlementDateSelect(wrap);
    });
  }

  function settlementPaidDateFieldHtml(value, inputId) {
    var parts = settlementPaidDateParts(value);
    var idAttr = inputId ? ' id="' + escapeHtml(inputId) + '"' : '';
    return '<div class="lb-admin-dateselect" role="group" aria-label="匯款日">' +
      '<input type="hidden"' + idAttr + ' data-settlement-paid-date value="' + escapeHtml(parts.ymd) + '">' +
      '<select class="lb-admin-input lb-admin-dateselect__part" data-date-part="y" aria-label="年">' +
        settlementYearOptionsHtml(parts.y) +
      '</select>' +
      '<select class="lb-admin-input lb-admin-dateselect__part" data-date-part="m" aria-label="月">' +
        settlementMonthOptionsHtml(parts.m) +
      '</select>' +
      '<select class="lb-admin-input lb-admin-dateselect__part" data-date-part="d" aria-label="日">' +
        settlementDayOptionsHtml(parts.y, parts.m, parts.d) +
      '</select>' +
      '</div>';
  }

  async function openSettlementDetail(batchId) {
    settlementState.selectedBatchId = batchId;
    var detail = $('lb-admin-settlement-detail');
    var vendorsHost = $('lb-admin-settlement-vendors');
    var title = $('lb-admin-settlement-detail-title');
    var exportLink = $('lb-admin-settlement-export-payout');
    var markBox = $('lb-admin-settlement-mark-paid-box');
    if (!detail || !vendorsHost) return;
    show(detail);
    vendorsHost.innerHTML = '<p class="lb-admin-hint">載入中…</p>';
    try {
      var res = await fetchJson(PATHS.settlements + '/' + encodeURIComponent(batchId));
      if (!res.payload || res.payload.ok !== true) {
        vendorsHost.innerHTML = '<p class="lb-admin-hint">載入明細失敗</p>';
        return;
      }
      var batch = res.payload.batch;
      var vendors = res.payload.vendors || [];
      var displayStatus = settlementBatchDisplayStatus(batch);
      if (title) {
        title.innerHTML = '批次 ' + escapeHtml(batch.batch_key) +
          ' <span class="' + settlementStatusClass(displayStatus) + '">' +
          escapeHtml(settlementStatusLabel(displayStatus)) + '</span>';
      }
      if (exportLink) {
        exportLink.href = PATHS.settlements + '/' + encodeURIComponent(batch.id) + '/export/payout.csv';
      }
      var cancelBtn = $('lb-admin-settlement-cancel-btn');
      var paidVendorCount = Number(batch.paid_vendor_count || 0);
      var pendingVendors = vendors.filter(function (v) {
        return String(v.status || '').toUpperCase() !== 'PAID';
      });
      var pendingSum = pendingVendors.reduce(function (s, v) {
        return s + (Number(v.vendor_payout) || 0);
      }, 0);
      if (cancelBtn) {
        if ((batch.status === 'READY' || batch.status === 'DRAFT') && paidVendorCount === 0) show(cancelBtn);
        else hide(cancelBtn);
      }
      if (markBox) {
        if (batch.status === 'READY' && pendingVendors.length > 0) {
          show(markBox);
          var paidAmountInput = $('lb-admin-settlement-paid-amount');
          if (paidAmountInput) paidAmountInput.value = String(Math.round(pendingSum));
          bindSettlementDatePickers(markBox);
          fillSettlementPaidDateDefaults(markBox, false);
        } else {
          hide(markBox);
        }
      }

      var paidSummary = '';
      if (batch.status === 'PAID') {
        paidSummary =
          '<div class="lb-admin-settlement-paid-summary">' +
            '<strong>整批已確認匯款</strong> · ' +
            '匯款日 ' + escapeHtml(formatSettlementDateZh(batch.paid_transfer_date)) +
            ' · 金額 ' + (batch.paid_amount != null ? formatSettlementMoney(batch.paid_amount) : '—') +
            ' · 參考號 ' + escapeHtml(batch.paid_ref || '—') +
            (batch.paid_note ? ' · ' + escapeHtml(batch.paid_note) : '') +
          '</div>';
      } else if (paidVendorCount > 0) {
        paidSummary =
          '<div class="lb-admin-settlement-paid-summary">' +
            '<strong>部分已匯</strong> · 已確認 ' + paidVendorCount +
            '／' + (batch.vendor_count || vendors.length) + ' 家廠商' +
          '</div>';
      }

      var totalPayout = vendors.reduce(function (sum, v) { return sum + Math.round(Number(v.vendor_payout || 0)); }, 0);
      var totalFee = vendors.reduce(function (sum, v) { return sum + Math.round(Number(v.platform_fee || 0)); }, 0);
      var totalDiscount = vendors.reduce(function (sum, v) { return sum + Math.round(Number(v.platform_discount_cost || 0)); }, 0);
      var totalRefund = vendors.reduce(function (sum, v) { return sum + Math.round(Number(v.refund_amount || 0)); }, 0);
      var expandedSlug = settlementState.markPaidSlug;

      vendorsHost.innerHTML =
        paidSummary +
        '<div class="lb-admin-settlement-meta">' +
          '<span>期間 <strong>' + escapeHtml(formatSettlementPeriodZh(batch.period_start, batch.period_end)) + '</strong></span>' +
          '<span>撥款日 <strong>' + escapeHtml(formatSettlementDateZh(batch.payout_date)) + '</strong></span>' +
          '<span>廠商 <strong>' + vendors.length + '</strong></span>' +
          '<span>應匯合計 <strong>' + formatSettlementMoney(totalPayout) + '</strong></span>' +
          '<span>平台費 <strong>' + formatSettlementMoney(totalFee) + '</strong></span>' +
          '<span>實退 <strong>' + formatSettlementMoney(totalRefund) + '</strong></span>' +
          '<span>折扣成本 <strong>' + formatSettlementMoney(totalDiscount) + '</strong></span>' +
        '</div>' +
        '<div class="lb-admin-table-wrap lb-admin-table-wrap--settlement"><table class="lb-admin-table lb-admin-table--settlement"><thead><tr>' +
        '<th>廠商</th><th>銀行</th><th>帳號</th><th>票數</th><th>分潤基數</th><th>平台費</th><th>實退</th><th>折扣成本</th><th>應匯</th><th>狀態／匯款</th><th>下載</th>' +
        '</tr></thead><tbody>' +
        (vendors.length ? vendors.map(function (v) {
          var eventsUrl = PATHS.settlements + '/' + encodeURIComponent(batch.id) +
            '/export/vendor/' + encodeURIComponent(v.slug_handle) + '/events.csv';
          var ticketsUrl = PATHS.settlements + '/' + encodeURIComponent(batch.id) +
            '/export/vendor/' + encodeURIComponent(v.slug_handle) + '/tickets.csv';
          var isPaid = String(v.status || '').toUpperCase() === 'PAID';
          var actionCell;
          if (isPaid) {
            actionCell =
              '<div class="lb-admin-settlement-vendor-paid">' +
                '<span class="' + settlementStatusClass('PAID') + '">已匯款</span><br>' +
                '<small>批次 ' + escapeHtml(batch.batch_key) +
                '<br>匯款日 ' + escapeHtml(formatSettlementDateZh(v.paid_transfer_date)) +
                ' · ' + (v.paid_amount != null ? formatSettlementMoney(v.paid_amount) : '—') +
                ' · 參考號 ' + escapeHtml(v.paid_ref || '—') +
                (v.paid_at ? '<br>紀錄 ' + escapeHtml(String(v.paid_at).slice(0, 19).replace('T', ' ')) : '') +
                (v.paid_by ? ' · by ' + escapeHtml(v.paid_by) : '') +
                (v.paid_note ? '<br>' + escapeHtml(v.paid_note) : '') +
                '</small>' +
              '</div>';
          } else if (batch.status === 'READY') {
            var open = expandedSlug === v.slug_handle;
            actionCell =
              '<button type="button" class="lb-admin-btn lb-admin-btn--sm lb-admin-btn--accent" data-settlement-mark-open="' +
                escapeHtml(v.slug_handle) + '">' + (open ? '收合' : '確認已匯款') + '</button>';
          } else {
            actionCell = '<span class="' + settlementStatusClass(v.status) + '">' +
              escapeHtml(settlementStatusLabel(v.status)) + '</span>';
          }
          var formRow = '';
          if (!isPaid && batch.status === 'READY' && expandedSlug === v.slug_handle) {
            formRow =
              '<tr class="lb-admin-settlement-mark-row" data-mark-slug="' + escapeHtml(v.slug_handle) + '">' +
                '<td colspan="11">' +
                  '<div class="lb-admin-settlement-mark-paid">' +
                    '<div class="lb-admin-settlement-mark-paid__title">確認匯款給 ' +
                      escapeHtml(v.vendor_name || v.slug_handle) + '</div>' +
                    '<p class="lb-admin-hint">將寫入此廠商匯款紀錄、寄送通知，並開放該廠商下載結算單。</p>' +
                    '<div class="lb-admin-settlement-mark-grid">' +
                      '<label class="lb-admin-field"><span>匯款日</span>' +
                        settlementPaidDateFieldHtml(settlementTodayYmd()) + '</label>' +
                      '<label class="lb-admin-field"><span>匯款金額</span>' +
                        '<input type="number" class="lb-admin-input" data-settlement-paid-amount min="0" step="1" value="' +
                          Math.round(Number(v.vendor_payout) || 0) + '"></label>' +
                      '<label class="lb-admin-field"><span>匯款末五碼／參考號</span>' +
                        '<input type="text" class="lb-admin-input" data-settlement-paid-ref maxlength="128" placeholder="例：12345"></label>' +
                      '<label class="lb-admin-field"><span>備註</span>' +
                        '<input type="text" class="lb-admin-input" data-settlement-paid-note maxlength="500" placeholder="選填"></label>' +
                      '<div class="lb-admin-settlement-mark-grid__actions">' +
                        '<button type="button" class="lb-admin-btn lb-admin-btn--accent" data-settlement-mark-submit="' +
                          escapeHtml(v.slug_handle) + '">確認已匯款並通知</button>' +
                      '</div>' +
                    '</div>' +
                  '</div>' +
                '</td>' +
              '</tr>';
          }
          return '<tr>' +
            '<td><div class="lb-admin-settlement-vendor-cell"><strong>' +
              escapeHtml(v.vendor_name || v.slug_handle) + '</strong><small>' +
              escapeHtml(v.slug_handle) + '</small></div></td>' +
            '<td>' + escapeHtml(v.bank_name || '—') + '</td>' +
            '<td><code>' + escapeHtml(v.bank_account || '—') + '</code></td>' +
            '<td class="lb-admin-num">' + escapeHtml(v.ticket_count) + '</td>' +
            '<td class="lb-admin-num">' + formatSettlementMoney(v.share_base) + '</td>' +
            '<td class="lb-admin-num">' + formatSettlementMoney(v.platform_fee) + '</td>' +
            '<td class="lb-admin-num">' + formatSettlementMoney(v.refund_amount) + '</td>' +
            '<td class="lb-admin-num">' + formatSettlementMoney(v.platform_discount_cost) + '</td>' +
            '<td class="lb-admin-num"><strong>' + formatSettlementMoney(v.vendor_payout) + '</strong></td>' +
            '<td class="lb-admin-settlement-action-cell">' + actionCell + '</td>' +
            '<td class="lb-admin-settlement-dl-cell"><a href="' + eventsUrl +
              '" target="_blank" rel="noopener">活動</a><a href="' + ticketsUrl +
              '" target="_blank" rel="noopener">明細</a></td>' +
            '</tr>' + formRow;
        }).join('') : '<tr><td colspan="11">此批次尚無廠商列</td></tr>') +
        '</tbody></table></div>';

      vendorsHost.querySelectorAll('[data-settlement-mark-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var slug = btn.getAttribute('data-settlement-mark-open');
          settlementState.markPaidSlug =
            settlementState.markPaidSlug === slug ? null : slug;
          openSettlementDetail(batchId);
        });
      });
      vendorsHost.querySelectorAll('[data-settlement-mark-submit]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          markSettlementVendorPaid(btn.getAttribute('data-settlement-mark-submit'));
        });
      });
      fillSettlementPaidDateDefaults(vendorsHost, false);
      bindSettlementDatePickers(vendorsHost);
    } catch (err) {
      vendorsHost.innerHTML = '<p class="lb-admin-hint">' + escapeHtml(hideShopifyNoun(err.message || '載入失敗')) + '</p>';
    }
  }

  async function postSettlementMarkPaid(body) {
    var markUrl = PATHS.settlements + '/' + encodeURIComponent(settlementState.selectedBatchId) + '/mark-paid';
    var res = await fetchJson(markUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    var errCode = res.payload && res.payload.error && res.payload.error.code;
    var errMsg = (res.payload && res.payload.error && res.payload.error.message) || '標記失敗';
    if ((!res.payload || res.payload.ok !== true) && errCode === 'PAID_AMOUNT_MISMATCH') {
      if (!window.confirm(errMsg + '\n\n確定匯款金額與系統應匯不同，仍要標記已匯？')) {
        return { cancelled: true, message: '已取消標記（金額不一致）' };
      }
      body.allow_paid_amount_mismatch = true;
      res = await fetchJson(markUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      errCode = res.payload && res.payload.error && res.payload.error.code;
      errMsg = (res.payload && res.payload.error && res.payload.error.message) || '標記失敗';
    }
    if ((!res.payload || res.payload.ok !== true) && errCode === 'REFUND_ADJUSTED_PRESENT') {
      if (!window.confirm(errMsg + '\n\n建議先取消批次重算。仍要強制標記已匯？')) {
        return { cancelled: true, message: '已取消標記（有結算後退款）' };
      }
      body.allow_refund_adjusted = true;
      res = await fetchJson(markUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      errCode = res.payload && res.payload.error && res.payload.error.code;
      errMsg = (res.payload && res.payload.error && res.payload.error.message) || '標記失敗';
    }
    if (!res.payload || res.payload.ok !== true) {
      return { ok: false, message: errCode ? '[' + errCode + '] ' + errMsg : errMsg };
    }
    return { ok: true, payload: res.payload };
  }

  async function markSettlementVendorPaid(slug) {
    if (!settlementState.selectedBatchId || !slug) return;
    var row = document.querySelector('.lb-admin-settlement-mark-row[data-mark-slug="' + slug + '"]');
    if (!row) return;
    var paidRef = (row.querySelector('[data-settlement-paid-ref]') || {}).value || '';
    var paidNote = (row.querySelector('[data-settlement-paid-note]') || {}).value || '';
    var paidDateNorm = normalizeSettlementPaidDate((row.querySelector('[data-settlement-paid-date]') || {}).value || '');
    var paidAmountRaw = (row.querySelector('[data-settlement-paid-amount]') || {}).value || '';
    if (paidDateNorm === null) {
      setSettlementNotice('匯款日請用 YYYY-MM-DD（例：' + settlementTodayYmd() + '）', true);
      return;
    }
    if (!window.confirm('確認已完成對「' + slug + '」的人工匯款？仍屬同一結算批次；將寫入含批次鍵的匯款紀錄、寄送該廠商通知，並開放其下載結算單。')) return;
    try {
      var body = {
        slug_handle: slug,
        paid_ref: paidRef,
        paid_note: paidNote,
        paid_transfer_date: paidDateNorm || null,
        portal_url: '/pages/vendor-portal-v2',
      };
      if (paidAmountRaw !== '') body.paid_amount = Number(paidAmountRaw);
      var result = await postSettlementMarkPaid(body);
      if (result.cancelled) {
        setSettlementNotice(result.message, true);
        return;
      }
      if (!result.ok) {
        setSettlementNotice(result.message, true);
        return;
      }
      settlementState.markPaidSlug = null;
      setSettlementNotice(
        '已確認「' + slug + '」匯款（同批次）' +
          (result.payload.batch_fully_paid ? '；整批已全部匯完' : '') +
          '；已排隊通知 ' +
          (result.payload.email_queued != null ? result.payload.email_queued : result.payload.emailed || 0) +
          ' 封',
        false
      );
      await loadSettlements();
      openSettlementDetail(settlementState.selectedBatchId);
    } catch (err) {
      setSettlementNotice(err.message || '標記失敗', true);
    }
  }

  async function markSettlementBatchPaid() {
    if (!settlementState.selectedBatchId) return;
    var paidRef = ($('lb-admin-settlement-paid-ref') && $('lb-admin-settlement-paid-ref').value) || '';
    var paidNote = ($('lb-admin-settlement-paid-note') && $('lb-admin-settlement-paid-note').value) || '';
    var paidDateNorm = normalizeSettlementPaidDate(
      ($('lb-admin-settlement-paid-date') && $('lb-admin-settlement-paid-date').value) || ''
    );
    var paidAmountRaw = ($('lb-admin-settlement-paid-amount') && $('lb-admin-settlement-paid-amount').value) || '';
    if (paidDateNorm === null) {
      setSettlementNotice('匯款日請用 YYYY-MM-DD（例：' + settlementTodayYmd() + '）', true);
      return;
    }
    if (!window.confirm('確認以整批方式完成剩餘廠商匯款？仍屬同一結算批次；會為每位待匯廠商寫入紀錄並寄送通知。')) return;
    try {
      var body = {
        mark_all: true,
        paid_ref: paidRef,
        paid_note: paidNote,
        paid_transfer_date: paidDateNorm || null,
        portal_url: '/pages/vendor-portal-v2',
      };
      if (paidAmountRaw !== '') body.paid_amount = Number(paidAmountRaw);
      var result = await postSettlementMarkPaid(body);
      if (result.cancelled) {
        setSettlementNotice(result.message, true);
        return;
      }
      if (!result.ok) {
        setSettlementNotice(result.message, true);
        return;
      }
      settlementState.markPaidSlug = null;
      var n = (result.payload.vendors && result.payload.vendors.length) || 0;
      setSettlementNotice(
        '已整批確認剩餘 ' + n + ' 家廠商匯款' +
          (result.payload.batch_fully_paid ? '（整批已全部匯完）' : '') +
          '；已排隊通知 ' +
          (result.payload.email_queued != null ? result.payload.email_queued : result.payload.emailed || 0) +
          ' 封',
        false
      );
      await loadSettlements();
      openSettlementDetail(settlementState.selectedBatchId);
    } catch (err) {
      setSettlementNotice(err.message || '標記失敗', true);
    }
  }

  async function cancelSettlementBatch() {
    if (!settlementState.selectedBatchId) return;
    if (!window.confirm('確認取消此結算批次？票券會釋放回未結算，可於下期重新納入。已匯款批次無法取消。')) return;
    try {
      var res = await fetchJson(
        PATHS.settlements + '/' + encodeURIComponent(settlementState.selectedBatchId) + '/cancel',
        { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' }
      );
      if (!res.payload || res.payload.ok !== true) {
        var e = extractApiError(res);
        setSettlementNotice(e.code ? '[' + e.code + '] ' + e.message : (e.message || '取消失敗'), true);
        return;
      }
      setSettlementNotice(
        '已取消批次（釋放票券 ' + (res.payload.released_tickets || 0) + ' 張）',
        false
      );
      await loadSettlements();
      openSettlementDetail(settlementState.selectedBatchId);
    } catch (err) {
      setSettlementNotice(err.message || '取消失敗', true);
    }
  }

  async function loadAdminCityTaxonomy() {
    try {
      var res = await fetchJson(PATHS.cityTaxonomy);
      if (res.payload && res.payload.ok && Array.isArray(res.payload.cities) && res.payload.cities.length) {
        CITY_OPTIONS = res.payload.cities.map(function (c) {
          return { code: String(c.code || ''), label: String(c.label || c.code || '') };
        }).filter(function (c) { return c.code; });
      }
    } catch (e) {
      /* keep fallback CITY_OPTIONS */
    }
  }

  async function loadCityBackfill() {
    var host = $('lb-admin-city-backfill-list');
    var notice = $('lb-admin-city-backfill-notice');
    var sourceEl = $('lb-admin-city-backfill-source');
    if (!host) return;
    if (notice) hide(notice);
    host.innerHTML = '<p class="lb-admin-hint">掃描中…</p>';
    var source = (sourceEl && sourceEl.value) || 'all';
    try {
      await loadAdminCityTaxonomy();
      var res = await fetchJson(PATHS.cityBackfill + '?source=' + encodeURIComponent(source));
      if (!res.payload || !res.payload.ok) {
        var errMsg =
          (res.payload && res.payload.error && res.payload.error.message) ||
          (res.response ? ('載入失敗（HTTP ' + res.response.status + '）') : '載入失敗');
        var errCode = res.payload && res.payload.error && res.payload.error.code;
        throw new Error(errCode ? (errMsg + ' [' + errCode + ']') : errMsg);
      }
      var items = res.payload.items || [];
      if (res.payload.warnings && res.payload.warnings.length) {
        setFlash(res.payload.warnings.join('；'), true);
      }
      if (!items.length) {
        host.innerHTML = '<p class="lb-admin-hint">目前沒有待補標項目（或皆已掛上 city-*）。</p>';
        return;
      }
      host.innerHTML = items.map(function (item, idx) {
          var conf = item.confidence || 'none';
        var confLabel = conf === 'high' ? '高' : conf === 'low' ? '低（請人工選，未預勾）' : '無法判斷';
        var sourceLabel = item.source === 'listing'
          ? 'Listing #' + item.id
          : (item.needs_retag ? '官方重標' : '官方商品');
        var preselect = conf === 'high'
          ? (item.suggested_codes || [])
          : (item.current_codes || []);
        return '<article class="lb-admin-city-backfill-card" data-backfill-idx="' + idx + '">' +
          '<div class="lb-admin-city-backfill-card__head">' +
            '<strong>' + escapeHtml(item.title || item.id) + '</strong>' +
            '<span class="lb-admin-chip">' + escapeHtml(sourceLabel) + '</span>' +
            '<span class="lb-admin-chip">信心：' + escapeHtml(confLabel) + '</span>' +
          '</div>' +
          '<div class="lb-admin-m-card__row"><span>地址</span><span>' +
            escapeHtml(item.address || '—') + '</span></div>' +
          '<div class="lb-admin-m-card__row"><span>場地</span><span>' +
            escapeHtml(item.venue_name || '—') + '</span></div>' +
          '<div class="lb-admin-m-card__row"><span>建議／現有</span><span>' +
            escapeHtml((item.suggested_labels || []).join('、') || '—') +
            (item.current_codes && item.current_codes.length
              ? '（現有：' + escapeHtml(cityLabels(item.current_codes).join('、')) + '）'
              : '') +
            '</span></div>' +
          cityCheckboxGridHtml(preselect, 'lb-admin-backfill-city-' + idx) +
          '<div class="lb-admin-m-card__actions">' +
            '<button type="button" class="lb-admin-btn lb-admin-btn--accent lb-admin-btn--sm" data-backfill-apply="' +
              idx + '">確認寫入</button>' +
          '</div>' +
        '</article>';
      }).join('');

      host._backfillItems = items;
      host.querySelectorAll('[data-backfill-apply]').forEach(function (btn) {
        btn.addEventListener('click', async function () {
          var idx = Number(btn.getAttribute('data-backfill-apply'));
          var item = host._backfillItems && host._backfillItems[idx];
          if (!item) return;
          var card = host.querySelector('[data-backfill-idx="' + idx + '"]');
          var codes = collectCityCodesFrom(card, 'lb-admin-backfill-city-' + idx);
          if (!codes.length) {
            setFlash('請至少勾選一個縣市', true);
            return;
          }
          if (!confirm('確認將「' + (item.title || item.id) + '」標記為：' + cityLabels(codes).join('、') + '？')) {
            return;
          }
          btn.disabled = true;
          try {
            var applyRes = await fetchJson(PATHS.cityBackfillApply, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                source: item.source,
                id: item.id,
                city_codes: codes,
                also_shopify: true,
              }),
            });
            if (!applyRes.payload || !applyRes.payload.ok) {
              var e = extractApiError(applyRes);
              throw new Error(e.code ? '[' + e.code + '] ' + e.message : (e.message || '寫入失敗'));
            }
            var warns =
              (applyRes.payload.shopify_warnings && applyRes.payload.shopify_warnings.length
                ? applyRes.payload.shopify_warnings
                : null) ||
              (applyRes.payload.warnings && applyRes.payload.warnings.length
                ? applyRes.payload.warnings
                : null);
            if (warns) {
              setFlash('已寫入地區標記，但有警告：' + hideShopifyNoun(warns.join('；')), true);
            } else {
              setFlash('已寫入地區標記');
            }
            loadCityBackfill();
          } catch (err) {
            setFlash(err.message || '寫入失敗', true);
            btn.disabled = false;
          }
        });
      });
    } catch (err) {
      host.innerHTML = '';
      if (notice) {
        notice.textContent = hideShopifyNoun(err.message || '載入失敗');
        notice.hidden = false;
        show(notice);
      }
      setFlash(err.message || '地區補標載入失敗', true);
    }
  }

  function bindSettlementEvents() {
    bindSettlementPayoutPick();
    if ($('lb-admin-settlements-refresh')) {
      $('lb-admin-settlements-refresh').addEventListener('click', loadSettlements);
    }
    if ($('lb-admin-settlement-preview-btn')) {
      $('lb-admin-settlement-preview-btn').addEventListener('click', previewSettlement);
    }
    if ($('lb-admin-settlement-create-btn')) {
      $('lb-admin-settlement-create-btn').addEventListener('click', createSettlement);
    }
    if ($('lb-admin-settlement-mark-paid-btn')) {
      $('lb-admin-settlement-mark-paid-btn').addEventListener('click', markSettlementBatchPaid);
    }
    if ($('lb-admin-settlement-cancel-btn')) {
      $('lb-admin-settlement-cancel-btn').addEventListener('click', cancelSettlementBatch);
    }
    if ($('lb-admin-settlement-detail-close')) {
      $('lb-admin-settlement-detail-close').addEventListener('click', function () {
        hide($('lb-admin-settlement-detail'));
        settlementState.selectedBatchId = null;
        settlementState.markPaidSlug = null;
      });
    }
  }

  function adminNumericOrderId(raw) {
    var s = String(raw || '').trim();
    if (!s) return '';
    var m = s.match(/gid:\/\/shopify\/Order\/(\d+)/i) || s.match(/^(\d+)$/) || s.match(/(\d{6,})/);
    return m ? m[1] : '';
  }

  function adminShopifyOrderAdminUrl(orderId) {
    var oid = adminNumericOrderId(orderId);
    if (!oid) return '';
    return 'https://admin.shopify.com/store/2ddda5-79/orders/' + encodeURIComponent(oid);
  }

  function formatMoneyTwAdmin(n) {
    var v = Math.round(Number(n));
    if (!isFinite(v)) return '—';
    try {
      return new Intl.NumberFormat('zh-TW', {
        style: 'currency',
        currency: 'TWD',
        maximumFractionDigits: 0,
      }).format(v);
    } catch (e) {
      return 'NT$' + v;
    }
  }

  function formatTsAdmin(raw) {
    if (!raw) return '—';
    try {
      var d = new Date(raw);
      if (isNaN(d.getTime())) return String(raw);
      return d.toLocaleString('zh-TW', { hour12: false, timeZone: 'Asia/Taipei' });
    } catch (e) {
      return String(raw);
    }
  }

  function refundResolutionLabel(row) {
    if (!row.refund_request_resolved_at) {
      if (String(row.refund_shopify_state || '').toUpperCase() === 'IN_FLIGHT') return '對帳中';
      return '待處理';
    }
    var res = String(row.refund_request_resolution || '').toUpperCase();
    if (res === 'APPROVED') return '已核准退訂';
    if (res === 'REJECTED') return '已拒絕';
    return res || '已結案';
  }

  function refundShopifyStateLabel(state) {
    var s = String(state || 'PENDING').toUpperCase();
    if (s === 'SUCCEEDED') return '退款成功';
    if (s === 'FAILED') return '退款失敗';
    if (s === 'IN_FLIGHT') return '結果未確認';
    if (s === 'MANUAL') return '人工補記';
    if (s === 'PENDING') return '尚未打款';
    return s;
  }

  function refundRecordRowHtml(row) {
    var open = !row.refund_request_resolved_at;
    var orderHref = adminShopifyOrderAdminUrl(row.shopify_order_id);
    var orderName = String(row.shopify_order_name || '').trim() || '訂單';
    var orderCell = orderHref
      ? '<a href="' + escapeHtml(orderHref) + '" target="_blank" rel="noopener">' + escapeHtml(orderName) + '</a>'
      : escapeHtml(orderName);
    if (row.shopify_order_id) {
      orderCell += '<div class="lb-admin-muted"><code>' + escapeHtml(hideShopifyNoun(row.shopify_order_id)) + '</code></div>';
    }
    if (row.shopify_refund_id) {
      orderCell += '<div class="lb-admin-muted">退款 <code>' + escapeHtml(hideShopifyNoun(row.shopify_refund_id)) + '</code></div>';
    } else {
      orderCell += '<div class="lb-admin-muted">尚無 SAdmin 退款編號</div>';
    }

    var money =
      '<div>實付 ' + escapeHtml(formatMoneyTwAdmin(row.paid_amount)) + '</div>' +
      '<div class="lb-admin-muted">預計 ' + escapeHtml(formatMoneyTwAdmin(row.refund_expected_amount)) +
      (row.refund_fee_percent != null ? '（扣 ' + escapeHtml(String(row.refund_fee_percent)) + '%）' : '') +
      '</div>' +
      '<div><strong>實退 ' + escapeHtml(formatMoneyTwAdmin(row.refund_amount != null ? row.refund_amount : (open ? row.refund_expected_amount : null))) +
      '</strong></div>';

    var shopify =
      '<div>' + escapeHtml(refundShopifyStateLabel(row.refund_shopify_state)) + '</div>';
    if (row.refund_shopify_attempt_amount != null && row.refund_shopify_attempt_amount !== '') {
      shopify += '<div class="lb-admin-muted">嘗試 ' + escapeHtml(formatMoneyTwAdmin(row.refund_shopify_attempt_amount)) + '</div>';
    }
    if (row.refund_shopify_attempt_at) {
      shopify += '<div class="lb-admin-muted">' + escapeHtml(formatTsAdmin(row.refund_shopify_attempt_at)) + '</div>';
    }
    if (row.refund_shopify_error) {
      shopify += '<div style="color:#a63d3d;max-width:14rem;white-space:normal;">' +
        escapeHtml(hideShopifyNoun(row.refund_shopify_error)) + '</div>';
    }

    var timeline =
      '<div><strong>' + escapeHtml(refundResolutionLabel(row)) + '</strong></div>' +
      '<div class="lb-admin-muted">申請 ' + escapeHtml(formatTsAdmin(row.refund_request_at)) + '</div>';
    if (row.refund_request_resolved_at) {
      timeline += '<div class="lb-admin-muted">結案 ' + escapeHtml(formatTsAdmin(row.refund_request_resolved_at)) + '</div>';
    }
    if (row.refund_request_reason) {
      timeline += '<div class="lb-admin-muted">原因：' + escapeHtml(String(row.refund_request_reason)) + '</div>';
    }
    if (row.refund_reject_reason) {
      timeline += '<div style="color:#a63d3d;">拒絕：' + escapeHtml(String(row.refund_reject_reason)) + '</div>';
    }

    var vendor =
      '<div><strong>' + escapeHtml(row.vendor_name || row.slug_handle || '—') + '</strong></div>' +
      '<div class="lb-admin-muted"><code>' + escapeHtml(row.slug_handle || '') + '</code> · grant#' +
      escapeHtml(String(row.grant_id)) + '</div>' +
      '<div class="lb-admin-muted">' + escapeHtml(row.plan_name || '—') +
      (row.plan_type ? ' · ' + escapeHtml(String(row.plan_type)) : '') + '</div>';
    if (row.listing_id) {
      vendor += '<div class="lb-admin-muted">課程 #' + escapeHtml(String(row.listing_id)) +
        (row.listing_title ? ' ' + escapeHtml(row.listing_title) : '') +
        (row.listing_status ? '（' + escapeHtml(String(row.listing_status)) + '）' : '') +
        '</div>';
    }
    if (Number(row.addon_count) > 0) {
      vendor += '<div class="lb-admin-muted">線上加購 ' + escapeHtml(String(row.addon_count)) + ' 筆</div>';
    }

    var actions = '—';
    if (open) {
      actions =
        '<div class="lb-admin-table-actions" style="flex-direction:column;align-items:stretch;gap:0.35rem;">' +
        '<button type="button" class="lb-admin-btn lb-admin-btn--accent lb-admin-refund-approve" data-grant-id="' +
        escapeHtml(String(row.grant_id)) + '">核准退款</button>' +
        '<button type="button" class="lb-admin-btn lb-admin-refund-manual" data-grant-id="' +
        escapeHtml(String(row.grant_id)) + '">已人工退款結案</button>' +
        '<button type="button" class="lb-admin-btn lb-admin-btn--danger lb-admin-refund-reject" data-grant-id="' +
        escapeHtml(String(row.grant_id)) + '">拒絕</button>' +
        '</div>';
    }

    return '<tr data-grant-id="' + escapeHtml(String(row.grant_id)) + '">' +
      '<td>' + timeline + '</td>' +
      '<td>' + vendor + '</td>' +
      '<td>' + orderCell + '</td>' +
      '<td>' + money + '</td>' +
      '<td>' + shopify + '</td>' +
      '<td>' + actions + '</td>' +
      '</tr>';
  }

  function refundRecordCardHtml(row) {
    // Mobile cards reuse the same fields in stacked form.
    return '<article class="lb-admin-m-card" data-grant-id="' + escapeHtml(String(row.grant_id)) + '">' +
      '<div class="lb-admin-m-card__title">' + escapeHtml(refundResolutionLabel(row)) +
      ' · grant#' + escapeHtml(String(row.grant_id)) + '</div>' +
      '<div class="lb-admin-muted">' + escapeHtml(row.vendor_name || row.slug_handle || '') +
      ' · ' + escapeHtml(row.shopify_order_name || '無訂單') + '</div>' +
      '<div>實退 ' + escapeHtml(formatMoneyTwAdmin(row.refund_amount != null ? row.refund_amount : row.refund_expected_amount)) +
      ' · ' + escapeHtml(refundShopifyStateLabel(row.refund_shopify_state)) + '</div>' +
      (row.shopify_refund_id
        ? '<div class="lb-admin-muted"><code>' + escapeHtml(hideShopifyNoun(row.shopify_refund_id)) + '</code></div>'
        : '') +
      (adminShopifyOrderAdminUrl(row.shopify_order_id)
        ? '<div><a href="' + escapeHtml(adminShopifyOrderAdminUrl(row.shopify_order_id)) +
          '" target="_blank" rel="noopener">開 SAdmin 訂單</a></div>'
        : '') +
      (!row.refund_request_resolved_at
        ? '<div class="lb-admin-table-actions" style="margin-top:0.5rem;flex-wrap:wrap;">' +
          '<button type="button" class="lb-admin-btn lb-admin-btn--accent lb-admin-refund-approve" data-grant-id="' +
          escapeHtml(String(row.grant_id)) + '">核准</button>' +
          '<button type="button" class="lb-admin-btn lb-admin-refund-manual" data-grant-id="' +
          escapeHtml(String(row.grant_id)) + '">已人工退款</button>' +
          '<button type="button" class="lb-admin-btn lb-admin-btn--danger lb-admin-refund-reject" data-grant-id="' +
          escapeHtml(String(row.grant_id)) + '">拒絕</button></div>'
        : '') +
      '</article>';
  }

  function renderSlotRefundRecords() {
    var tbody = $('lb-admin-slot-refunds-tbody');
    var cards = $('lb-admin-slot-refunds-cards');
    var empty = $('lb-admin-slot-refunds-empty');
    var rows = state.refundRecords || [];
    if (tbody) tbody.innerHTML = rows.map(refundRecordRowHtml).join('');
    if (cards) cards.innerHTML = rows.map(refundRecordCardHtml).join('');
    if (empty) empty.hidden = rows.length > 0;
  }

  async function loadSlotRefundRecords() {
    var notice = $('lb-admin-slot-refunds-notice');
    if (notice) { notice.hidden = true; notice.textContent = ''; }
    var scopeEl = $('lb-admin-slot-refunds-scope');
    var slugEl = $('lb-admin-slot-refunds-slug');
    state.refundScope = (scopeEl && scopeEl.value) || state.refundScope || 'open';
    state.refundSlug = String((slugEl && slugEl.value) || '').trim();
    var params = new URLSearchParams();
    params.set('scope', state.refundScope);
    params.set('limit', '100');
    if (state.refundSlug) params.set('slug_handle', state.refundSlug);
    try {
      var result = await fetchJson(PATHS.feeGrantRefundRecords + '?' + params.toString(), { method: 'GET' });
      if (!result.payload || !result.payload.ok) {
        var e = extractApiError(result);
        throw new Error(e.code ? '[' + e.code + '] ' + e.message : (e.message || '載入失敗'));
      }
      state.refundRecords = result.payload.items || [];
      renderSlotRefundRecords();
      if (notice) {
        notice.textContent = '共 ' + state.refundRecords.length + ' 筆（' + state.refundScope + '）';
        notice.hidden = false;
        show(notice);
      }
    } catch (err) {
      state.refundRecords = [];
      renderSlotRefundRecords();
      if (notice) {
        notice.textContent = err.message || '載入失敗';
        notice.hidden = false;
        show(notice);
      }
      setFlash(err.message || '版位退訂載入失敗', true);
    }
  }

  async function approveSlotRefund(grantId, alreadyRefunded) {
    var body = {
      grant_id: Number(grantId),
      unpublish_listing: true,
      cascade_addons: true,
    };
    if (alreadyRefunded) body.already_refunded_in_shopify = true;
    var result = await fetchJson(PATHS.feeGrantRefundApprove, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!result.payload || !result.payload.ok) {
      var e = extractApiError(result);
      throw new Error(e.code ? '[' + e.code + '] ' + e.message : (e.message || '核准失敗'));
    }
    return result.payload;
  }

  async function rejectSlotRefund(grantId, reason) {
    var result = await fetchJson(PATHS.feeGrantRefundReject, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ grant_id: Number(grantId), reason: reason }),
    });
    if (!result.payload || !result.payload.ok) {
      var e = extractApiError(result);
      throw new Error(e.code ? '[' + e.code + '] ' + e.message : (e.message || '拒絕失敗'));
    }
    return result.payload;
  }

  function bindSlotRefundEvents() {
    if ($('lb-admin-slot-refunds-refresh')) {
      $('lb-admin-slot-refunds-refresh').addEventListener('click', loadSlotRefundRecords);
    }
    if ($('lb-admin-slot-refunds-search')) {
      $('lb-admin-slot-refunds-search').addEventListener('click', loadSlotRefundRecords);
    }
    if ($('lb-admin-slot-refunds-scope')) {
      $('lb-admin-slot-refunds-scope').addEventListener('change', loadSlotRefundRecords);
    }
    var root = $('lb-admin-panel-slot-refunds');
    if (!root) return;
    root.addEventListener('click', async function (event) {
      var btn = event.target && event.target.closest
        ? event.target.closest('.lb-admin-refund-approve, .lb-admin-refund-manual, .lb-admin-refund-reject')
        : null;
      if (!btn) return;
      var grantId = btn.getAttribute('data-grant-id');
      if (!grantId) return;
      btn.disabled = true;
      try {
        if (btn.classList.contains('lb-admin-refund-reject')) {
          var reason = window.prompt('請填寫拒絕原因：', '');
          if (!reason || !String(reason).trim()) {
            btn.disabled = false;
            return;
          }
          await rejectSlotRefund(grantId, String(reason).trim());
          setFlash('已拒絕 grant#' + grantId);
        } else if (btn.classList.contains('lb-admin-refund-manual')) {
          if (!window.confirm('確認已在 SAdmin 後台退過款？平台將只補記錄、不再打退款。')) {
            btn.disabled = false;
            return;
          }
          var manual = await approveSlotRefund(grantId, true);
          setFlash('已人工結案 grant#' + grantId +
            (manual.refund_amount != null ? '（實退 ' + formatMoneyTwAdmin(manual.refund_amount) + '）' : ''));
        } else {
          if (!window.confirm('核准後會自動下架（若仍在線上）並打 SAdmin 退款。確定？')) {
            btn.disabled = false;
            return;
          }
          var approved = await approveSlotRefund(grantId, false);
          setFlash('已核准 grant#' + grantId +
            (approved.refund_amount != null ? '（實退 ' + formatMoneyTwAdmin(approved.refund_amount) + '）' : '') +
            (approved.shopify_refund_id ? ' · ' + hideShopifyNoun(approved.shopify_refund_id) : ''));
        }
        await loadSlotRefundRecords();
      } catch (err) {
        setFlash(err.message || '操作失敗', true);
        btn.disabled = false;
      }
    });
  }

  bindListingsEvents();
  bindFeePlanEvents();
  bindPrivateAppsEvents();
  bindSlotEvents();
  loadSlotOptions();
  bindTaxonomyEvents();
  bindSettlementEvents();
  bindSlotRefundEvents();
  bindEvents();
  bootstrap();
})();
